import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: { input: any; output: any; }
  /** The `Decimal` scalar type represents a decimal floating-point number. */
  Decimal: { input: any; output: any; }
  /**
   * The `LocalDate` scalar type represents a ISO date string, represented as UTF-8
   * character sequences YYYY-MM-DD. The scalar follows the specification defined in RFC3339
   */
  LocalDate: { input: any; output: any; }
};

export enum AccommodationTaxScheme {
  Ppo = 'PPO',
  StandardVat = 'STANDARD_VAT'
}

export type AccommodationTaxSchemeOperationFilterInput = {
  eq?: InputMaybe<AccommodationTaxScheme>;
  in?: InputMaybe<Array<AccommodationTaxScheme>>;
  neq?: InputMaybe<AccommodationTaxScheme>;
  nin?: InputMaybe<Array<AccommodationTaxScheme>>;
};

export type AccountChangePasswordDtoInput = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type AccountClaimDto = {
  __typename?: 'AccountClaimDto';
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AccountDeleteDtoInput = {
  username: Scalars['String']['input'];
};

export type AccountLoginDtoInput = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type AccountLoginResponseDto = {
  __typename?: 'AccountLoginResponseDto';
  token: Scalars['String']['output'];
};

export type AccountRegisterDtoOfUserRoleInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  userName: Scalars['String']['input'];
};

export type AccountResendConfirmationEmailDtoInput = {
  username: Scalars['String']['input'];
};

export type AccountResetPasswordDtoInput = {
  newPassword: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type ApplicationUser = {
  __typename?: 'ApplicationUser';
  accessFailedCount: Scalars['Int']['output'];
  concurrencyStamp?: Maybe<Scalars['String']['output']>;
  defaultRole: UserRole;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  emailConfirmed: Scalars['Boolean']['output'];
  emailSignature: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  lockoutEnabled: Scalars['Boolean']['output'];
  lockoutEnd?: Maybe<Scalars['DateTime']['output']>;
  normalizedEmail?: Maybe<Scalars['String']['output']>;
  normalizedUserName?: Maybe<Scalars['String']['output']>;
  onboardingEmailFailureReason: Scalars['String']['output'];
  onboardingEmailLastFailedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  onboardingEmailLastSentAtUtc?: Maybe<Scalars['DateTime']['output']>;
  onboardingEmailQueuedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  onboardingEmailSentCount: Scalars['Int']['output'];
  onboardingEmailStatus?: Maybe<EmailDeliveryStatus>;
  passwordHash?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberConfirmed: Scalars['Boolean']['output'];
  securityStamp?: Maybe<Scalars['String']['output']>;
  twoFactorEnabled: Scalars['Boolean']['output'];
  userName?: Maybe<Scalars['String']['output']>;
};

export type ApplicationUserFilterInput = {
  accessFailedCount?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<ApplicationUserFilterInput>>;
  concurrencyStamp?: InputMaybe<StringOperationFilterInput>;
  defaultRole?: InputMaybe<UserRoleOperationFilterInput>;
  deletedAt?: InputMaybe<DateTimeOperationFilterInput>;
  displayName?: InputMaybe<StringOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  emailConfirmed?: InputMaybe<BooleanOperationFilterInput>;
  emailSignature?: InputMaybe<StringOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  lockoutEnabled?: InputMaybe<BooleanOperationFilterInput>;
  lockoutEnd?: InputMaybe<DateTimeOperationFilterInput>;
  normalizedEmail?: InputMaybe<StringOperationFilterInput>;
  normalizedUserName?: InputMaybe<StringOperationFilterInput>;
  onboardingEmailFailureReason?: InputMaybe<StringOperationFilterInput>;
  onboardingEmailLastFailedAtUtc?: InputMaybe<DateTimeOperationFilterInput>;
  onboardingEmailLastSentAtUtc?: InputMaybe<DateTimeOperationFilterInput>;
  onboardingEmailQueuedAtUtc?: InputMaybe<DateTimeOperationFilterInput>;
  onboardingEmailSentCount?: InputMaybe<IntOperationFilterInput>;
  onboardingEmailStatus?: InputMaybe<NullableOfEmailDeliveryStatusOperationFilterInput>;
  or?: InputMaybe<Array<ApplicationUserFilterInput>>;
  passwordHash?: InputMaybe<StringOperationFilterInput>;
  phoneNumber?: InputMaybe<StringOperationFilterInput>;
  phoneNumberConfirmed?: InputMaybe<BooleanOperationFilterInput>;
  securityStamp?: InputMaybe<StringOperationFilterInput>;
  twoFactorEnabled?: InputMaybe<BooleanOperationFilterInput>;
  userName?: InputMaybe<StringOperationFilterInput>;
};

export type ApplicationUserSortInput = {
  accessFailedCount?: InputMaybe<SortEnumType>;
  concurrencyStamp?: InputMaybe<SortEnumType>;
  defaultRole?: InputMaybe<SortEnumType>;
  deletedAt?: InputMaybe<SortEnumType>;
  displayName?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  emailConfirmed?: InputMaybe<SortEnumType>;
  emailSignature?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  lockoutEnabled?: InputMaybe<SortEnumType>;
  lockoutEnd?: InputMaybe<SortEnumType>;
  normalizedEmail?: InputMaybe<SortEnumType>;
  normalizedUserName?: InputMaybe<SortEnumType>;
  onboardingEmailFailureReason?: InputMaybe<SortEnumType>;
  onboardingEmailLastFailedAtUtc?: InputMaybe<SortEnumType>;
  onboardingEmailLastSentAtUtc?: InputMaybe<SortEnumType>;
  onboardingEmailQueuedAtUtc?: InputMaybe<SortEnumType>;
  onboardingEmailSentCount?: InputMaybe<SortEnumType>;
  onboardingEmailStatus?: InputMaybe<SortEnumType>;
  passwordHash?: InputMaybe<SortEnumType>;
  phoneNumber?: InputMaybe<SortEnumType>;
  phoneNumberConfirmed?: InputMaybe<SortEnumType>;
  securityStamp?: InputMaybe<SortEnumType>;
  twoFactorEnabled?: InputMaybe<SortEnumType>;
  userName?: InputMaybe<SortEnumType>;
};

/** Defines when a policy shall be executed. */
export enum ApplyPolicy {
  /** After the resolver was executed. */
  AfterResolver = 'AFTER_RESOLVER',
  /** Before the resolver was executed. */
  BeforeResolver = 'BEFORE_RESOLVER',
  /** The policy is applied in the validation step before the execution. */
  Validation = 'VALIDATION'
}

export enum ArbitraryFormFieldType {
  Checkbox = 'CHECKBOX',
  Date = 'DATE',
  Email = 'EMAIL',
  MultiSelect = 'MULTI_SELECT',
  Number = 'NUMBER',
  Phone = 'PHONE',
  Select = 'SELECT',
  Text = 'TEXT',
  TextArea = 'TEXT_AREA'
}

export type ArbitraryFormFieldTypeOperationFilterInput = {
  eq?: InputMaybe<ArbitraryFormFieldType>;
  in?: InputMaybe<Array<ArbitraryFormFieldType>>;
  neq?: InputMaybe<ArbitraryFormFieldType>;
  nin?: InputMaybe<Array<ArbitraryFormFieldType>>;
};

export type ArchivedEventReturnDto = {
  __typename?: 'ArchivedEventReturnDto';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  code: Scalars['String']['output'];
  endDate: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  lifecycleStatus: EventLifecycleStatus;
  name: Scalars['String']['output'];
  nameEn: Scalars['String']['output'];
  nameHr: Scalars['String']['output'];
  participantCount: Scalars['Int']['output'];
  place: Scalars['String']['output'];
  reservationCount: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
};

export type ArchivedEventReturnDtoFilterInput = {
  and?: InputMaybe<Array<ArchivedEventReturnDtoFilterInput>>;
  archivedAt?: InputMaybe<DateTimeOperationFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  lifecycleStatus?: InputMaybe<EventLifecycleStatusOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  nameEn?: InputMaybe<StringOperationFilterInput>;
  nameHr?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ArchivedEventReturnDtoFilterInput>>;
  participantCount?: InputMaybe<IntOperationFilterInput>;
  place?: InputMaybe<StringOperationFilterInput>;
  reservationCount?: InputMaybe<IntOperationFilterInput>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
};

export type ArchivedEventReturnDtoSortInput = {
  archivedAt?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lifecycleStatus?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  nameEn?: InputMaybe<SortEnumType>;
  nameHr?: InputMaybe<SortEnumType>;
  participantCount?: InputMaybe<SortEnumType>;
  place?: InputMaybe<SortEnumType>;
  reservationCount?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type ArchivedEventsCollectionSegment = {
  __typename?: 'ArchivedEventsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ArchivedEventReturnDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseMutation = {
  __typename?: 'BaseMutation';
  activateEvent: Array<EventReturnDto>;
  activateEventRegistrationFormArbitraryFieldsTemplate?: Maybe<EventRegistrationFormArbitraryFieldsTemplateReturnDto>;
  addToRoleById: Array<UserRole>;
  changeEventRegistrationPayer: EventRegistrationReturnDto;
  changePassword: Scalars['Boolean']['output'];
  cloneEvent: Array<EventReturnDto>;
  completeEvent: Array<EventReturnDto>;
  completeOrganizationMemberOnboarding: OrganizationMemberOnboardingResultDto;
  completeOrganizerPasswordReset: Scalars['Boolean']['output'];
  confirmEmail: Scalars['Boolean']['output'];
  createEvent: Array<EventReturnDto>;
  createEventEmailTemplate: Array<EventEmailTemplateReturnDto>;
  createEventFeePrice: Array<EventFeePriceReturnDto>;
  createEventFeeType: Array<EventFeeTypeReturnDto>;
  createEventHotel: Array<EventHotelReturnDto>;
  createEventOption: Array<EventOptionReturnDto>;
  createEventPaymentMethod: Array<EventPaymentMethodReturnDto>;
  createEventPricePeriod: Array<EventPricePeriodReturnDto>;
  createEventRegistrationFormArbitraryFieldsTemplate: Array<EventRegistrationFormArbitraryFieldsTemplateReturnDto>;
  createEventRoomAllotment: Array<EventRoomAllotmentReturnDto>;
  createEventRoomType: Array<EventRoomTypeReturnDto>;
  createEventTaxSetting: Array<EventTaxSettingReturnDto>;
  createHotelIdentity: Array<HotelIdentityCatalogItemDto>;
  createOrganizationMember: OrganizationMemberOnboardingResultDto;
  createPayer: Array<PayerReturnDto>;
  delete: Scalars['Boolean']['output'];
  deleteAccommodationOptions: Scalars['Boolean']['output'];
  deleteEvent: Scalars['Boolean']['output'];
  deleteEventParticipant: Scalars['Boolean']['output'];
  deleteHotelIdentity: Scalars['Boolean']['output'];
  deletePayer: Scalars['Boolean']['output'];
  generateEventCertificate: EventCertificateReturnDto;
  grantEventAccess: Scalars['Boolean']['output'];
  inviteEventRegistration: EventRegistrationReturnDto;
  login: AccountLoginResponseDto;
  manualReconcilePayment: PaymentReturnDto;
  ping: Scalars['String']['output'];
  recordOfferPayment: PaymentReturnDto;
  refreshToken: AccountLoginResponseDto;
  register: Scalars['Boolean']['output'];
  rejectEventRegistration: EventRegistrationReturnDto;
  releaseEventRoomReservation: EventRoomReservationReleaseResultDto;
  removePendingOrganizationMemberInvite: OrganizationMemberMaintenanceResultDto;
  renewEventParticipationOffer: EventOfferRenewalResultDto;
  requestOrganizerPasswordReset: Scalars['Boolean']['output'];
  resendConfirmationEmail: Scalars['Boolean']['output'];
  resendEventCertificateEmail: EventCertificateReturnDto;
  resendEventRegistrationVerificationEmail: EventRegistrationReturnDto;
  resendOrganizationMemberOnboarding: OrganizationMemberOnboardingResultDto;
  resetPassword: Scalars['Boolean']['output'];
  restoreEvent: Array<EventReturnDto>;
  retryFailedEventRegistrationNotifications: Scalars['Int']['output'];
  revokeEventAccess: Scalars['Boolean']['output'];
  saveAccommodationOption: Scalars['Boolean']['output'];
  saveEventBasicSetup: Scalars['Boolean']['output'];
  saveEventRegistrationNotificationDraft: EventRegistrationNotificationSendResultDto;
  saveEventRoomReservation: EventRoomReservationSaveResultDto;
  sendEventRegistrationNotification: EventRegistrationNotificationSendResultDto;
  updateCurrentUserProfile: UserProfileDto;
  updateEventEmailTemplate: Array<EventEmailTemplateReturnDto>;
  updateEventFeePrice: Array<EventFeePriceReturnDto>;
  updateEventFeeType: Array<EventFeeTypeReturnDto>;
  updateEventHotel: Array<EventHotelReturnDto>;
  updateEventOption: Array<EventOptionReturnDto>;
  updateEventParticipant: Array<EventParticipantReturnDto>;
  updateEventPaymentMethod: Array<EventPaymentMethodReturnDto>;
  updateEventPricePeriod: Array<EventPricePeriodReturnDto>;
  updateEventRegistrationActivities: EventRegistrationReturnDto;
  updateEventRoomAllotment: Array<EventRoomAllotmentReturnDto>;
  updateEventRoomType: Array<EventRoomTypeReturnDto>;
  updateEventTaxSetting: Array<EventTaxSettingReturnDto>;
  updateHotelIdentity: Array<HotelIdentityCatalogItemDto>;
  updateOrganizationMember: OrganizationMemberMaintenanceResultDto;
  updatePayer: Array<PayerReturnDto>;
  upsertGeneralSettings: GeneralSettingsReturnDto;
};


export type BaseMutationActivateEventArgs = {
  input: EventDeleteDtoInput;
};


export type BaseMutationActivateEventRegistrationFormArbitraryFieldsTemplateArgs = {
  input: EventRegistrationFormArbitraryFieldsTemplateDeleteDtoInput;
};


export type BaseMutationAddToRoleByIdArgs = {
  id: Scalars['String']['input'];
  role: UserRole;
};


export type BaseMutationChangeEventRegistrationPayerArgs = {
  input: EventRegistrationPayerChangeDtoInput;
};


export type BaseMutationChangePasswordArgs = {
  model: AccountChangePasswordDtoInput;
};


export type BaseMutationCloneEventArgs = {
  input: EventCloneDtoInput;
};


export type BaseMutationCompleteEventArgs = {
  input: EventDeleteDtoInput;
};


export type BaseMutationCompleteOrganizationMemberOnboardingArgs = {
  input: OrganizationMemberOnboardingCompleteDtoInput;
};


export type BaseMutationCompleteOrganizerPasswordResetArgs = {
  input: OrganizerPasswordResetCompleteDtoInput;
};


export type BaseMutationConfirmEmailArgs = {
  code: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type BaseMutationCreateEventArgs = {
  input: EventCreateDtoInput;
};


export type BaseMutationCreateEventEmailTemplateArgs = {
  input: EventEmailTemplateCreateDtoInput;
};


export type BaseMutationCreateEventFeePriceArgs = {
  input: EventFeePriceCreateDtoInput;
};


export type BaseMutationCreateEventFeeTypeArgs = {
  input: EventFeeTypeCreateDtoInput;
};


export type BaseMutationCreateEventHotelArgs = {
  input: EventHotelCreateDtoInput;
};


export type BaseMutationCreateEventOptionArgs = {
  input: EventOptionCreateDtoInput;
};


export type BaseMutationCreateEventPaymentMethodArgs = {
  input: EventPaymentMethodCreateDtoInput;
};


export type BaseMutationCreateEventPricePeriodArgs = {
  input: EventPricePeriodCreateDtoInput;
};


export type BaseMutationCreateEventRegistrationFormArbitraryFieldsTemplateArgs = {
  input: EventRegistrationFormArbitraryFieldsTemplateCreateDtoInput;
};


export type BaseMutationCreateEventRoomAllotmentArgs = {
  input: EventRoomAllotmentCreateDtoInput;
};


export type BaseMutationCreateEventRoomTypeArgs = {
  input: EventRoomTypeCreateDtoInput;
};


export type BaseMutationCreateEventTaxSettingArgs = {
  input: EventTaxSettingCreateDtoInput;
};


export type BaseMutationCreateHotelIdentityArgs = {
  input: HotelIdentityCreateDtoInput;
};


export type BaseMutationCreateOrganizationMemberArgs = {
  input: OrganizationMemberCreateDtoInput;
};


export type BaseMutationCreatePayerArgs = {
  input: PayerCreateDtoInput;
};


export type BaseMutationDeleteArgs = {
  model: AccountDeleteDtoInput;
};


export type BaseMutationDeleteAccommodationOptionsArgs = {
  input: DeleteAccommodationOptionsDtoInput;
};


export type BaseMutationDeleteEventArgs = {
  input: EventDeleteDtoInput;
};


export type BaseMutationDeleteEventParticipantArgs = {
  input: EventParticipantDeleteDtoInput;
};


export type BaseMutationDeleteHotelIdentityArgs = {
  id: Scalars['Int']['input'];
};


export type BaseMutationDeletePayerArgs = {
  input: PayerDeleteDtoInput;
};


export type BaseMutationGenerateEventCertificateArgs = {
  input: EventCertificateGenerateDtoInput;
};


export type BaseMutationGrantEventAccessArgs = {
  input: EventAccessGrantDtoInput;
};


export type BaseMutationInviteEventRegistrationArgs = {
  input: EventRegistrationDeleteDtoInput;
};


export type BaseMutationLoginArgs = {
  model: AccountLoginDtoInput;
};


export type BaseMutationManualReconcilePaymentArgs = {
  input: PaymentManualReconcileDtoInput;
};


export type BaseMutationRecordOfferPaymentArgs = {
  input: RecordOfferPaymentDtoInput;
};


export type BaseMutationRegisterArgs = {
  model: AccountRegisterDtoOfUserRoleInput;
};


export type BaseMutationRejectEventRegistrationArgs = {
  input: EventRegistrationRejectDtoInput;
};


export type BaseMutationReleaseEventRoomReservationArgs = {
  input: EventRoomReservationReleaseDtoInput;
};


export type BaseMutationRemovePendingOrganizationMemberInviteArgs = {
  input: OrganizationMemberPendingInviteRemoveDtoInput;
};


export type BaseMutationRenewEventParticipationOfferArgs = {
  input: EventOfferRenewDtoInput;
};


export type BaseMutationRequestOrganizerPasswordResetArgs = {
  email: Scalars['String']['input'];
};


export type BaseMutationResendConfirmationEmailArgs = {
  model: AccountResendConfirmationEmailDtoInput;
};


export type BaseMutationResendEventCertificateEmailArgs = {
  input: EventCertificateEmailResendDtoInput;
};


export type BaseMutationResendEventRegistrationVerificationEmailArgs = {
  input: EventRegistrationDeleteDtoInput;
};


export type BaseMutationResendOrganizationMemberOnboardingArgs = {
  input: OrganizationMemberOnboardingResendDtoInput;
};


export type BaseMutationResetPasswordArgs = {
  model: AccountResetPasswordDtoInput;
};


export type BaseMutationRestoreEventArgs = {
  input: EventDeleteDtoInput;
};


export type BaseMutationRetryFailedEventRegistrationNotificationsArgs = {
  eventId: Scalars['Int']['input'];
  notificationLogIds: Array<Scalars['Int']['input']>;
};


export type BaseMutationRevokeEventAccessArgs = {
  input: EventAccessGrantDtoInput;
};


export type BaseMutationSaveAccommodationOptionArgs = {
  input: SaveAccommodationOptionDtoInput;
};


export type BaseMutationSaveEventBasicSetupArgs = {
  input: EventBasicSetupSaveDtoInput;
};


export type BaseMutationSaveEventRegistrationNotificationDraftArgs = {
  input: EventRegistrationNotificationSendDtoInput;
};


export type BaseMutationSaveEventRoomReservationArgs = {
  input: EventRoomReservationSaveDtoInput;
};


export type BaseMutationSendEventRegistrationNotificationArgs = {
  input: EventRegistrationNotificationSendDtoInput;
};


export type BaseMutationUpdateCurrentUserProfileArgs = {
  input: UserProfileUpdateDtoInput;
};


export type BaseMutationUpdateEventEmailTemplateArgs = {
  input: EventEmailTemplateUpdateDtoInput;
};


export type BaseMutationUpdateEventFeePriceArgs = {
  input: EventFeePriceUpdateDtoInput;
};


export type BaseMutationUpdateEventFeeTypeArgs = {
  input: EventFeeTypeUpdateDtoInput;
};


export type BaseMutationUpdateEventHotelArgs = {
  input: EventHotelUpdateDtoInput;
};


export type BaseMutationUpdateEventOptionArgs = {
  input: EventOptionUpdateDtoInput;
};


export type BaseMutationUpdateEventParticipantArgs = {
  input: EventParticipantUpdateDtoInput;
};


export type BaseMutationUpdateEventPaymentMethodArgs = {
  input: EventPaymentMethodUpdateDtoInput;
};


export type BaseMutationUpdateEventPricePeriodArgs = {
  input: EventPricePeriodUpdateDtoInput;
};


export type BaseMutationUpdateEventRegistrationActivitiesArgs = {
  input: EventRegistrationOptionSelectionUpdateDtoInput;
};


export type BaseMutationUpdateEventRoomAllotmentArgs = {
  input: EventRoomAllotmentUpdateDtoInput;
};


export type BaseMutationUpdateEventRoomTypeArgs = {
  input: EventRoomTypeUpdateDtoInput;
};


export type BaseMutationUpdateEventTaxSettingArgs = {
  input: EventTaxSettingUpdateDtoInput;
};


export type BaseMutationUpdateHotelIdentityArgs = {
  input: HotelIdentityUpdateDtoInput;
};


export type BaseMutationUpdateOrganizationMemberArgs = {
  input: OrganizationMemberUpdateDtoInput;
};


export type BaseMutationUpdatePayerArgs = {
  input: PayerUpdateDtoInput;
};


export type BaseMutationUpsertGeneralSettingsArgs = {
  input: GeneralSettingsUpsertDtoInput;
};

export type BaseQuery = {
  __typename?: 'BaseQuery';
  archivedEvents?: Maybe<ArchivedEventsCollectionSegment>;
  claims: Array<AccountClaimDto>;
  currentUserProfile: UserProfileDto;
  eventAccessGrants?: Maybe<EventAccessGrantsCollectionSegment>;
  eventAccessUsers?: Maybe<EventAccessUsersCollectionSegment>;
  eventActivityLogs?: Maybe<EventActivityLogsCollectionSegment>;
  eventBrandings?: Maybe<EventBrandingsCollectionSegment>;
  eventById?: Maybe<EventReturnDto>;
  eventDashboardSummary: EventDashboardSummaryDto;
  eventEmailTemplates?: Maybe<EventEmailTemplatesCollectionSegment>;
  eventFeePrices?: Maybe<EventFeePricesCollectionSegment>;
  eventFeeTypes?: Maybe<EventFeeTypesCollectionSegment>;
  eventHotels?: Maybe<EventHotelsCollectionSegment>;
  eventNotificationRecipients: Array<EventNotificationRecipientDto>;
  eventOfferBalances?: Maybe<EventOfferBalancesCollectionSegment>;
  eventOptions?: Maybe<EventOptionsCollectionSegment>;
  eventParticipantById?: Maybe<EventParticipantReturnDto>;
  eventParticipantCrmDetail: EventParticipantCrmDetailDto;
  eventParticipantNotificationHistory?: Maybe<EventParticipantNotificationHistoryCollectionSegment>;
  eventParticipants?: Maybe<EventParticipantsCollectionSegment>;
  eventPaymentMethods?: Maybe<EventPaymentMethodsCollectionSegment>;
  eventPricePeriods?: Maybe<EventPricePeriodsCollectionSegment>;
  eventRegistrationFormArbitraryFieldsTemplates?: Maybe<EventRegistrationFormArbitraryFieldsTemplatesCollectionSegment>;
  eventRegistrations?: Maybe<EventRegistrationsCollectionSegment>;
  eventRoomAllotments?: Maybe<EventRoomAllotmentsCollectionSegment>;
  eventRoomTypes?: Maybe<EventRoomTypesCollectionSegment>;
  eventTaxSettings?: Maybe<EventTaxSettingsCollectionSegment>;
  events?: Maybe<EventsCollectionSegment>;
  generalSettings: GeneralSettingsReturnDto;
  hotelIdentityCatalog?: Maybe<HotelIdentityCatalogCollectionSegment>;
  payerOfferHistory?: Maybe<PayerOfferHistoryCollectionSegment>;
  payerPaymentAllocations?: Maybe<PayerPaymentAllocationsCollectionSegment>;
  payers?: Maybe<PayersCollectionSegment>;
  payments?: Maybe<PaymentsCollectionSegment>;
  roles: Array<UserRole>;
  serverTimeUtc: Scalars['DateTime']['output'];
  serverVersion: Scalars['String']['output'];
  token: AccountLoginResponseDto;
  user: Array<ApplicationUser>;
  users?: Maybe<UsersCollectionSegment>;
};


export type BaseQueryArchivedEventsArgs = {
  order?: InputMaybe<Array<ArchivedEventReturnDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArchivedEventReturnDtoFilterInput>;
};


export type BaseQueryEventAccessGrantsArgs = {
  eventId: Scalars['Int']['input'];
  order?: InputMaybe<Array<EventAccessGrantReturnDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EventAccessGrantReturnDtoFilterInput>;
};


export type BaseQueryEventAccessUsersArgs = {
  eventId: Scalars['Int']['input'];
  order?: InputMaybe<Array<EventAccessUserReturnDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EventAccessUserReturnDtoFilterInput>;
};


export type BaseQueryEventActivityLogsArgs = {
  eventId: Scalars['Int']['input'];
  order?: InputMaybe<Array<EventActivityLogDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EventActivityLogDtoFilterInput>;
};


export type BaseQueryEventBrandingsArgs = {
  order?: InputMaybe<Array<EventBrandingReturnDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EventBrandingReturnDtoFilterInput>;
};


export type BaseQueryEventByIdArgs = {
  id: Scalars['Int']['input'];
};


export type BaseQueryEventDashboardSummaryArgs = {
  eventId: Scalars['Int']['input'];
  trendGranularity?: InputMaybe<Scalars['String']['input']>;
  trendRange?: InputMaybe<Scalars['String']['input']>;
};


export type BaseQueryEventEmailTemplatesArgs = {
  order?: InputMaybe<Array<EventEmailTemplateReturnDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EventEmailTemplateReturnDtoFilterInput>;
};


export type BaseQueryEventFeePricesArgs = {
  order?: InputMaybe<Array<EventFeePriceReturnDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EventFeePriceReturnDtoFilterInput>;
};


export type BaseQueryEventFeeTypesArgs = {
  order?: InputMaybe<Array<EventFeeTypeReturnDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EventFeeTypeReturnDtoFilterInput>;
};


export type BaseQueryEventHotelsArgs = {
  order?: InputMaybe<Array<EventHotelReturnDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EventHotelReturnDtoFilterInput>;
};


export type BaseQueryEventNotificationRecipientsArgs = {
  eventId: Scalars['Int']['input'];
};


export type BaseQueryEventOfferBalancesArgs = {
  eventId: Scalars['Int']['input'];
  order?: InputMaybe<Array<EventOfferBalanceDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EventOfferBalanceDtoFilterInput>;
};


export type BaseQueryEventOptionsArgs = {
  order?: InputMaybe<Array<EventOptionReturnDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EventOptionReturnDtoFilterInput>;
};


export type BaseQueryEventParticipantByIdArgs = {
  id: Scalars['Int']['input'];
};


export type BaseQueryEventParticipantCrmDetailArgs = {
  eventId: Scalars['Int']['input'];
  participantId: Scalars['Int']['input'];
};


export type BaseQueryEventParticipantNotificationHistoryArgs = {
  eventId: Scalars['Int']['input'];
  order?: InputMaybe<Array<EventRegistrationNotificationDeliveryLogDtoSortInput>>;
  participantId?: InputMaybe<Scalars['Int']['input']>;
  registrationId?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EventRegistrationNotificationDeliveryLogDtoFilterInput>;
};


export type BaseQueryEventParticipantsArgs = {
  order?: InputMaybe<Array<EventParticipantReturnDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  statusFilter?: InputMaybe<EventParticipantStatusFilterDtoInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EventParticipantReturnDtoFilterInput>;
};


export type BaseQueryEventPaymentMethodsArgs = {
  order?: InputMaybe<Array<EventPaymentMethodReturnDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EventPaymentMethodReturnDtoFilterInput>;
};


export type BaseQueryEventPricePeriodsArgs = {
  order?: InputMaybe<Array<EventPricePeriodReturnDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EventPricePeriodReturnDtoFilterInput>;
};


export type BaseQueryEventRegistrationFormArbitraryFieldsTemplatesArgs = {
  order?: InputMaybe<Array<EventRegistrationFormArbitraryFieldsTemplateReturnDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EventRegistrationFormArbitraryFieldsTemplateReturnDtoFilterInput>;
};


export type BaseQueryEventRegistrationsArgs = {
  order?: InputMaybe<Array<EventRegistrationReturnDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EventRegistrationReturnDtoFilterInput>;
};


export type BaseQueryEventRoomAllotmentsArgs = {
  order?: InputMaybe<Array<EventRoomAllotmentReturnDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EventRoomAllotmentReturnDtoFilterInput>;
};


export type BaseQueryEventRoomTypesArgs = {
  order?: InputMaybe<Array<EventRoomTypeReturnDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EventRoomTypeReturnDtoFilterInput>;
};


export type BaseQueryEventTaxSettingsArgs = {
  order?: InputMaybe<Array<EventTaxSettingReturnDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EventTaxSettingReturnDtoFilterInput>;
};


export type BaseQueryEventsArgs = {
  order?: InputMaybe<Array<EventReturnDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EventReturnDtoFilterInput>;
};


export type BaseQueryHotelIdentityCatalogArgs = {
  eventId?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<HotelIdentityCatalogItemDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HotelIdentityCatalogItemDtoFilterInput>;
};


export type BaseQueryPayerOfferHistoryArgs = {
  order?: InputMaybe<Array<EventOfferHistoryDtoSortInput>>;
  payerId: Scalars['Int']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EventOfferHistoryDtoFilterInput>;
};


export type BaseQueryPayerPaymentAllocationsArgs = {
  order?: InputMaybe<Array<PayerPaymentAllocationHistoryDtoSortInput>>;
  payerId: Scalars['Int']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PayerPaymentAllocationHistoryDtoFilterInput>;
};


export type BaseQueryPayersArgs = {
  order?: InputMaybe<Array<PayerReturnDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PayerReturnDtoFilterInput>;
};


export type BaseQueryPaymentsArgs = {
  order?: InputMaybe<Array<PaymentReturnDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PaymentReturnDtoFilterInput>;
};


export type BaseQueryUsersArgs = {
  order?: InputMaybe<Array<ApplicationUserSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ApplicationUserFilterInput>;
};

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Information about the offset pagination. */
export type CollectionSegmentInfo = {
  __typename?: 'CollectionSegmentInfo';
  /** Indicates whether more items exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more items exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean']['output'];
};

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  ngt?: InputMaybe<Scalars['DateTime']['input']>;
  ngte?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nlt?: InputMaybe<Scalars['DateTime']['input']>;
  nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DecimalOperationFilterInput = {
  eq?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  neq?: InputMaybe<Scalars['Decimal']['input']>;
  ngt?: InputMaybe<Scalars['Decimal']['input']>;
  ngte?: InputMaybe<Scalars['Decimal']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  nlt?: InputMaybe<Scalars['Decimal']['input']>;
  nlte?: InputMaybe<Scalars['Decimal']['input']>;
};

export type DeleteAccommodationOptionsDtoInput = {
  eventId: Scalars['Int']['input'];
  roomTypeIds: Array<Scalars['Int']['input']>;
};

export enum EmailDeliveryStatus {
  Failed = 'FAILED',
  Queued = 'QUEUED',
  Sent = 'SENT'
}

export type EventAccessGrantDtoInput = {
  eventId: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};

export type EventAccessGrantReturnDto = {
  __typename?: 'EventAccessGrantReturnDto';
  eventId: Scalars['Int']['output'];
  grantedAtUtc: Scalars['DateTime']['output'];
  grantedByUserEmail: Scalars['String']['output'];
  grantedByUserId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  userEmail: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export type EventAccessGrantReturnDtoFilterInput = {
  and?: InputMaybe<Array<EventAccessGrantReturnDtoFilterInput>>;
  eventId?: InputMaybe<IntOperationFilterInput>;
  grantedAtUtc?: InputMaybe<DateTimeOperationFilterInput>;
  grantedByUserEmail?: InputMaybe<StringOperationFilterInput>;
  grantedByUserId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<EventAccessGrantReturnDtoFilterInput>>;
  userEmail?: InputMaybe<StringOperationFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
  userName?: InputMaybe<StringOperationFilterInput>;
};

export type EventAccessGrantReturnDtoSortInput = {
  eventId?: InputMaybe<SortEnumType>;
  grantedAtUtc?: InputMaybe<SortEnumType>;
  grantedByUserEmail?: InputMaybe<SortEnumType>;
  grantedByUserId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  userEmail?: InputMaybe<SortEnumType>;
  userId?: InputMaybe<SortEnumType>;
  userName?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type EventAccessGrantsCollectionSegment = {
  __typename?: 'EventAccessGrantsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<EventAccessGrantReturnDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type EventAccessUserReturnDto = {
  __typename?: 'EventAccessUserReturnDto';
  defaultRole: UserRole;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  userName: Scalars['String']['output'];
};

export type EventAccessUserReturnDtoFilterInput = {
  and?: InputMaybe<Array<EventAccessUserReturnDtoFilterInput>>;
  defaultRole?: InputMaybe<UserRoleOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EventAccessUserReturnDtoFilterInput>>;
  userName?: InputMaybe<StringOperationFilterInput>;
};

export type EventAccessUserReturnDtoSortInput = {
  defaultRole?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  userName?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type EventAccessUsersCollectionSegment = {
  __typename?: 'EventAccessUsersCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<EventAccessUserReturnDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export enum EventActivityAction {
  Archived = 'ARCHIVED',
  Created = 'CREATED',
  Deleted = 'DELETED',
  Restored = 'RESTORED',
  Unknown = 'UNKNOWN',
  Updated = 'UPDATED'
}

export type EventActivityActionOperationFilterInput = {
  eq?: InputMaybe<EventActivityAction>;
  in?: InputMaybe<Array<EventActivityAction>>;
  neq?: InputMaybe<EventActivityAction>;
  nin?: InputMaybe<Array<EventActivityAction>>;
};

export type EventActivityLogDto = {
  __typename?: 'EventActivityLogDto';
  action: Scalars['String']['output'];
  actionType: EventActivityAction;
  details: Scalars['String']['output'];
  entityId: Scalars['String']['output'];
  entityName: Scalars['String']['output'];
  eventId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  occurredAt: Scalars['DateTime']['output'];
  userId?: Maybe<Scalars['String']['output']>;
  userName: Scalars['String']['output'];
};

export type EventActivityLogDtoFilterInput = {
  action?: InputMaybe<StringOperationFilterInput>;
  actionType?: InputMaybe<EventActivityActionOperationFilterInput>;
  and?: InputMaybe<Array<EventActivityLogDtoFilterInput>>;
  details?: InputMaybe<StringOperationFilterInput>;
  entityId?: InputMaybe<StringOperationFilterInput>;
  entityName?: InputMaybe<StringOperationFilterInput>;
  eventId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  occurredAt?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<EventActivityLogDtoFilterInput>>;
  userId?: InputMaybe<StringOperationFilterInput>;
  userName?: InputMaybe<StringOperationFilterInput>;
};

export type EventActivityLogDtoSortInput = {
  action?: InputMaybe<SortEnumType>;
  actionType?: InputMaybe<SortEnumType>;
  details?: InputMaybe<SortEnumType>;
  entityId?: InputMaybe<SortEnumType>;
  entityName?: InputMaybe<SortEnumType>;
  eventId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  occurredAt?: InputMaybe<SortEnumType>;
  userId?: InputMaybe<SortEnumType>;
  userName?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type EventActivityLogsCollectionSegment = {
  __typename?: 'EventActivityLogsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<EventActivityLogDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type EventBasicSetupSaveDtoInput = {
  address: Scalars['String']['input'];
  badgeBackTemplateUrl: Scalars['String']['input'];
  badgeCompanyX?: InputMaybe<Scalars['Int']['input']>;
  badgeCompanyY?: InputMaybe<Scalars['Int']['input']>;
  badgeFirstNameX?: InputMaybe<Scalars['Int']['input']>;
  badgeFirstNameY?: InputMaybe<Scalars['Int']['input']>;
  badgeLastNameX?: InputMaybe<Scalars['Int']['input']>;
  badgeLastNameY?: InputMaybe<Scalars['Int']['input']>;
  badgeQrCodeX?: InputMaybe<Scalars['Int']['input']>;
  badgeQrCodeY?: InputMaybe<Scalars['Int']['input']>;
  badgeTemplateUrl: Scalars['String']['input'];
  badgeTextFieldsJson: Scalars['String']['input'];
  certificateParticipantNameX?: InputMaybe<Scalars['Int']['input']>;
  certificateParticipantNameY?: InputMaybe<Scalars['Int']['input']>;
  certificateTemplateUrl: Scalars['String']['input'];
  certificateTextFieldsJson: Scalars['String']['input'];
  code: Scalars['String']['input'];
  endDate: Scalars['DateTime']['input'];
  eventInformationEn: Scalars['String']['input'];
  eventInformationHr: Scalars['String']['input'];
  hasParticipationFee: Scalars['Boolean']['input'];
  headerImageUrl: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  logoUrl: Scalars['String']['input'];
  name: Scalars['String']['input'];
  nameEn: Scalars['String']['input'];
  nameHr: Scalars['String']['input'];
  onSiteRegistrationInstructionsEn: Scalars['String']['input'];
  onSiteRegistrationInstructionsHr: Scalars['String']['input'];
  place: Scalars['String']['input'];
  primaryColor: Scalars['String']['input'];
  programPdfUrl: Scalars['String']['input'];
  publicAssetMode: EventPublicAssetMode;
  secondaryColor: Scalars['String']['input'];
  sponsorsImageUrl: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
  venueLayoutImageUrl: Scalars['String']['input'];
};

export type EventBrandingReturnDto = {
  __typename?: 'EventBrandingReturnDto';
  badgeBackTemplateUrl: Scalars['String']['output'];
  badgeCompanyX?: Maybe<Scalars['Int']['output']>;
  badgeCompanyY?: Maybe<Scalars['Int']['output']>;
  badgeFirstNameX?: Maybe<Scalars['Int']['output']>;
  badgeFirstNameY?: Maybe<Scalars['Int']['output']>;
  badgeLastNameX?: Maybe<Scalars['Int']['output']>;
  badgeLastNameY?: Maybe<Scalars['Int']['output']>;
  badgeQrCodeX?: Maybe<Scalars['Int']['output']>;
  badgeQrCodeY?: Maybe<Scalars['Int']['output']>;
  badgeTemplateUrl: Scalars['String']['output'];
  badgeTextFieldsJson: Scalars['String']['output'];
  certificateParticipantNameX?: Maybe<Scalars['Int']['output']>;
  certificateParticipantNameY?: Maybe<Scalars['Int']['output']>;
  certificateTemplateUrl: Scalars['String']['output'];
  certificateTextFieldsJson: Scalars['String']['output'];
  eventId: Scalars['Int']['output'];
  headerImageUrl: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  logoUrl: Scalars['String']['output'];
  primaryColor: Scalars['String']['output'];
  programPdfUrl: Scalars['String']['output'];
  publicAssetMode: EventPublicAssetMode;
  secondaryColor: Scalars['String']['output'];
  sponsorsImageUrl: Scalars['String']['output'];
  venueLayoutImageUrl: Scalars['String']['output'];
};

export type EventBrandingReturnDtoFilterInput = {
  and?: InputMaybe<Array<EventBrandingReturnDtoFilterInput>>;
  badgeBackTemplateUrl?: InputMaybe<StringOperationFilterInput>;
  badgeCompanyX?: InputMaybe<IntOperationFilterInput>;
  badgeCompanyY?: InputMaybe<IntOperationFilterInput>;
  badgeFirstNameX?: InputMaybe<IntOperationFilterInput>;
  badgeFirstNameY?: InputMaybe<IntOperationFilterInput>;
  badgeLastNameX?: InputMaybe<IntOperationFilterInput>;
  badgeLastNameY?: InputMaybe<IntOperationFilterInput>;
  badgeQrCodeX?: InputMaybe<IntOperationFilterInput>;
  badgeQrCodeY?: InputMaybe<IntOperationFilterInput>;
  badgeTemplateUrl?: InputMaybe<StringOperationFilterInput>;
  badgeTextFieldsJson?: InputMaybe<StringOperationFilterInput>;
  certificateParticipantNameX?: InputMaybe<IntOperationFilterInput>;
  certificateParticipantNameY?: InputMaybe<IntOperationFilterInput>;
  certificateTemplateUrl?: InputMaybe<StringOperationFilterInput>;
  certificateTextFieldsJson?: InputMaybe<StringOperationFilterInput>;
  eventId?: InputMaybe<IntOperationFilterInput>;
  headerImageUrl?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  logoUrl?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EventBrandingReturnDtoFilterInput>>;
  primaryColor?: InputMaybe<StringOperationFilterInput>;
  programPdfUrl?: InputMaybe<StringOperationFilterInput>;
  publicAssetMode?: InputMaybe<EventPublicAssetModeOperationFilterInput>;
  secondaryColor?: InputMaybe<StringOperationFilterInput>;
  sponsorsImageUrl?: InputMaybe<StringOperationFilterInput>;
  venueLayoutImageUrl?: InputMaybe<StringOperationFilterInput>;
};

export type EventBrandingReturnDtoSortInput = {
  badgeBackTemplateUrl?: InputMaybe<SortEnumType>;
  badgeCompanyX?: InputMaybe<SortEnumType>;
  badgeCompanyY?: InputMaybe<SortEnumType>;
  badgeFirstNameX?: InputMaybe<SortEnumType>;
  badgeFirstNameY?: InputMaybe<SortEnumType>;
  badgeLastNameX?: InputMaybe<SortEnumType>;
  badgeLastNameY?: InputMaybe<SortEnumType>;
  badgeQrCodeX?: InputMaybe<SortEnumType>;
  badgeQrCodeY?: InputMaybe<SortEnumType>;
  badgeTemplateUrl?: InputMaybe<SortEnumType>;
  badgeTextFieldsJson?: InputMaybe<SortEnumType>;
  certificateParticipantNameX?: InputMaybe<SortEnumType>;
  certificateParticipantNameY?: InputMaybe<SortEnumType>;
  certificateTemplateUrl?: InputMaybe<SortEnumType>;
  certificateTextFieldsJson?: InputMaybe<SortEnumType>;
  eventId?: InputMaybe<SortEnumType>;
  headerImageUrl?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  logoUrl?: InputMaybe<SortEnumType>;
  primaryColor?: InputMaybe<SortEnumType>;
  programPdfUrl?: InputMaybe<SortEnumType>;
  publicAssetMode?: InputMaybe<SortEnumType>;
  secondaryColor?: InputMaybe<SortEnumType>;
  sponsorsImageUrl?: InputMaybe<SortEnumType>;
  venueLayoutImageUrl?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type EventBrandingsCollectionSegment = {
  __typename?: 'EventBrandingsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<EventBrandingReturnDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type EventCertificateEmailResendDtoInput = {
  certificateId: Scalars['Int']['input'];
  eventId: Scalars['Int']['input'];
};

export type EventCertificateGenerateDtoInput = {
  registrationId: Scalars['Int']['input'];
};

export type EventCertificateHistoryDto = {
  __typename?: 'EventCertificateHistoryDto';
  emailFailedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  emailFailureReason: Scalars['String']['output'];
  emailQueuedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  emailedAt?: Maybe<Scalars['DateTime']['output']>;
  eventId: Scalars['Int']['output'];
  fileContentType: Scalars['String']['output'];
  fileId: Scalars['Int']['output'];
  fileName: Scalars['String']['output'];
  generatedAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  participantEmail: Scalars['String']['output'];
  participantFirstName: Scalars['String']['output'];
  participantFullName: Scalars['String']['output'];
  participantId: Scalars['Int']['output'];
  participantLastName: Scalars['String']['output'];
  registrationId: Scalars['Int']['output'];
  registrationStatus: EventRegistrationStatus;
  requestedAt: Scalars['DateTime']['output'];
  requestedBy: Scalars['String']['output'];
  status: EventCertificateStatus;
};

export type EventCertificateReturnDto = {
  __typename?: 'EventCertificateReturnDto';
  emailFailedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  emailFailureReason: Scalars['String']['output'];
  emailQueuedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  emailedAt?: Maybe<Scalars['DateTime']['output']>;
  eventId: Scalars['Int']['output'];
  fileId: Scalars['Int']['output'];
  fileName: Scalars['String']['output'];
  generatedAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  participantFullName: Scalars['String']['output'];
  participantId: Scalars['Int']['output'];
  participantNameX: Scalars['Int']['output'];
  participantNameY: Scalars['Int']['output'];
  registrationId: Scalars['Int']['output'];
  requestedAt: Scalars['DateTime']['output'];
  requestedBy: Scalars['String']['output'];
  status: EventCertificateStatus;
  templateUrl: Scalars['String']['output'];
};

export enum EventCertificateStatus {
  Emailed = 'EMAILED',
  Failed = 'FAILED',
  Generated = 'GENERATED',
  Queued = 'QUEUED'
}

export type EventCloneDtoInput = {
  code: Scalars['String']['input'];
  endDate: Scalars['DateTime']['input'];
  name: Scalars['String']['input'];
  nameEn: Scalars['String']['input'];
  nameHr: Scalars['String']['input'];
  sourceEventId: Scalars['Int']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type EventCreateDtoInput = {
  address: Scalars['String']['input'];
  code: Scalars['String']['input'];
  endDate: Scalars['DateTime']['input'];
  eventInformationEn: Scalars['String']['input'];
  eventInformationHr: Scalars['String']['input'];
  hasParticipationFee: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  nameEn: Scalars['String']['input'];
  nameHr: Scalars['String']['input'];
  onSiteRegistrationInstructionsEn: Scalars['String']['input'];
  onSiteRegistrationInstructionsHr: Scalars['String']['input'];
  place: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type EventDashboardAccommodationSummaryDto = {
  __typename?: 'EventDashboardAccommodationSummaryDto';
  cancelledReservationCount: Scalars['Int']['output'];
  releasedReservationCount: Scalars['Int']['output'];
  reservationCount: Scalars['Int']['output'];
  reservedReservationCount: Scalars['Int']['output'];
  reservedRoomCount: Scalars['Int']['output'];
  reservedRoomNightCount: Scalars['Int']['output'];
};

export type EventDashboardCertificateSummaryDto = {
  __typename?: 'EventDashboardCertificateSummaryDto';
  readyOrSentCount: Scalars['Int']['output'];
};

export type EventDashboardParticipantSummaryDto = {
  __typename?: 'EventDashboardParticipantSummaryDto';
  participantCount: Scalars['Int']['output'];
  registrationCount: Scalars['Int']['output'];
};

export type EventDashboardPaymentSummaryDto = {
  __typename?: 'EventDashboardPaymentSummaryDto';
  allocatedAmountTotal: Scalars['Decimal']['output'];
  allocationCount: Scalars['Int']['output'];
  cancelledCount: Scalars['Int']['output'];
  failedCount: Scalars['Int']['output'];
  grossTotal: Scalars['Decimal']['output'];
  manuallyReconciledCount: Scalars['Int']['output'];
  netTotal: Scalars['Decimal']['output'];
  paidCount: Scalars['Int']['output'];
  paymentRecordCount: Scalars['Int']['output'];
  pendingCount: Scalars['Int']['output'];
  refundedCount: Scalars['Int']['output'];
  unallocatedGrossTotal: Scalars['Decimal']['output'];
  unpaidCount: Scalars['Int']['output'];
};

export type EventDashboardSummaryDto = {
  __typename?: 'EventDashboardSummaryDto';
  accommodation: EventDashboardAccommodationSummaryDto;
  certificates: EventDashboardCertificateSummaryDto;
  eventId: Scalars['Int']['output'];
  participants: EventDashboardParticipantSummaryDto;
  payments: EventDashboardPaymentSummaryDto;
  trend: EventDashboardTrendSummaryDto;
};

export type EventDashboardTrendPointDto = {
  __typename?: 'EventDashboardTrendPointDto';
  date: Scalars['String']['output'];
  registrationCount: Scalars['Int']['output'];
  reservationCount: Scalars['Int']['output'];
};

export type EventDashboardTrendSummaryDto = {
  __typename?: 'EventDashboardTrendSummaryDto';
  points: Array<EventDashboardTrendPointDto>;
  rangeEndDate: Scalars['String']['output'];
  rangeStartDate: Scalars['String']['output'];
};

export type EventDeleteDtoInput = {
  id: Scalars['Int']['input'];
};

export type EventEmailTemplateCreateDtoInput = {
  body: Scalars['String']['input'];
  eventId: Scalars['Int']['input'];
  language: LanguageCode;
  subject: Scalars['String']['input'];
};

export type EventEmailTemplateReturnDto = {
  __typename?: 'EventEmailTemplateReturnDto';
  body: Scalars['String']['output'];
  eventId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  language: LanguageCode;
  subject: Scalars['String']['output'];
};

export type EventEmailTemplateReturnDtoFilterInput = {
  and?: InputMaybe<Array<EventEmailTemplateReturnDtoFilterInput>>;
  body?: InputMaybe<StringOperationFilterInput>;
  eventId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  language?: InputMaybe<LanguageCodeOperationFilterInput>;
  or?: InputMaybe<Array<EventEmailTemplateReturnDtoFilterInput>>;
  subject?: InputMaybe<StringOperationFilterInput>;
};

export type EventEmailTemplateReturnDtoSortInput = {
  body?: InputMaybe<SortEnumType>;
  eventId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  language?: InputMaybe<SortEnumType>;
  subject?: InputMaybe<SortEnumType>;
};

export type EventEmailTemplateUpdateDtoInput = {
  body: Scalars['String']['input'];
  eventId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  language: LanguageCode;
  subject: Scalars['String']['input'];
};

/** A segment of a collection. */
export type EventEmailTemplatesCollectionSegment = {
  __typename?: 'EventEmailTemplatesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<EventEmailTemplateReturnDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type EventFeePriceCreateDtoInput = {
  amount: Scalars['Decimal']['input'];
  feeTypeId: Scalars['Int']['input'];
  pricePeriodId: Scalars['Int']['input'];
};

export type EventFeePriceReturnDto = {
  __typename?: 'EventFeePriceReturnDto';
  amount: Scalars['Decimal']['output'];
  feeTypeId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  pricePeriodId: Scalars['Int']['output'];
};

export type EventFeePriceReturnDtoFilterInput = {
  amount?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<EventFeePriceReturnDtoFilterInput>>;
  feeTypeId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<EventFeePriceReturnDtoFilterInput>>;
  pricePeriodId?: InputMaybe<IntOperationFilterInput>;
};

export type EventFeePriceReturnDtoSortInput = {
  amount?: InputMaybe<SortEnumType>;
  feeTypeId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  pricePeriodId?: InputMaybe<SortEnumType>;
};

export type EventFeePriceUpdateDtoInput = {
  amount: Scalars['Decimal']['input'];
  feeTypeId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  pricePeriodId: Scalars['Int']['input'];
};

/** A segment of a collection. */
export type EventFeePricesCollectionSegment = {
  __typename?: 'EventFeePricesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<EventFeePriceReturnDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type EventFeeTypeCreateDtoInput = {
  eventId: Scalars['Int']['input'];
  isFree: Scalars['Boolean']['input'];
  isPublicRegistrationHidden: Scalars['Boolean']['input'];
  isSponsored: Scalars['Boolean']['input'];
  labelEn: Scalars['String']['input'];
  labelHr: Scalars['String']['input'];
  requiresParticipantTypeProof: Scalars['Boolean']['input'];
};

export type EventFeeTypeReturnDto = {
  __typename?: 'EventFeeTypeReturnDto';
  eventId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isFree: Scalars['Boolean']['output'];
  isPublicRegistrationHidden: Scalars['Boolean']['output'];
  isSponsored: Scalars['Boolean']['output'];
  labelEn: Scalars['String']['output'];
  labelHr: Scalars['String']['output'];
  requiresParticipantTypeProof: Scalars['Boolean']['output'];
};

export type EventFeeTypeReturnDtoFilterInput = {
  and?: InputMaybe<Array<EventFeeTypeReturnDtoFilterInput>>;
  eventId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isFree?: InputMaybe<BooleanOperationFilterInput>;
  isPublicRegistrationHidden?: InputMaybe<BooleanOperationFilterInput>;
  isSponsored?: InputMaybe<BooleanOperationFilterInput>;
  labelEn?: InputMaybe<StringOperationFilterInput>;
  labelHr?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EventFeeTypeReturnDtoFilterInput>>;
  requiresParticipantTypeProof?: InputMaybe<BooleanOperationFilterInput>;
};

export type EventFeeTypeReturnDtoSortInput = {
  eventId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isFree?: InputMaybe<SortEnumType>;
  isPublicRegistrationHidden?: InputMaybe<SortEnumType>;
  isSponsored?: InputMaybe<SortEnumType>;
  labelEn?: InputMaybe<SortEnumType>;
  labelHr?: InputMaybe<SortEnumType>;
  requiresParticipantTypeProof?: InputMaybe<SortEnumType>;
};

export type EventFeeTypeUpdateDtoInput = {
  eventId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  isFree: Scalars['Boolean']['input'];
  isPublicRegistrationHidden: Scalars['Boolean']['input'];
  isSponsored: Scalars['Boolean']['input'];
  labelEn: Scalars['String']['input'];
  labelHr: Scalars['String']['input'];
  requiresParticipantTypeProof: Scalars['Boolean']['input'];
};

/** A segment of a collection. */
export type EventFeeTypesCollectionSegment = {
  __typename?: 'EventFeeTypesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<EventFeeTypeReturnDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type EventHotelCreateDtoInput = {
  address: Scalars['String']['input'];
  category: Scalars['String']['input'];
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  eventId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  notes: Scalars['String']['input'];
};

export type EventHotelReturnDto = {
  __typename?: 'EventHotelReturnDto';
  address: Scalars['String']['output'];
  category: Scalars['String']['output'];
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  eventId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
};

export type EventHotelReturnDtoFilterInput = {
  address?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<EventHotelReturnDtoFilterInput>>;
  category?: InputMaybe<StringOperationFilterInput>;
  city?: InputMaybe<StringOperationFilterInput>;
  country?: InputMaybe<StringOperationFilterInput>;
  eventId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EventHotelReturnDtoFilterInput>>;
};

export type EventHotelReturnDtoSortInput = {
  address?: InputMaybe<SortEnumType>;
  category?: InputMaybe<SortEnumType>;
  city?: InputMaybe<SortEnumType>;
  country?: InputMaybe<SortEnumType>;
  eventId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
};

export type EventHotelUpdateDtoInput = {
  address: Scalars['String']['input'];
  category: Scalars['String']['input'];
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  eventId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  notes: Scalars['String']['input'];
};

/** A segment of a collection. */
export type EventHotelsCollectionSegment = {
  __typename?: 'EventHotelsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<EventHotelReturnDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export enum EventLifecycleStatus {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Draft = 'DRAFT'
}

export type EventLifecycleStatusOperationFilterInput = {
  eq?: InputMaybe<EventLifecycleStatus>;
  in?: InputMaybe<Array<EventLifecycleStatus>>;
  neq?: InputMaybe<EventLifecycleStatus>;
  nin?: InputMaybe<Array<EventLifecycleStatus>>;
};

export enum EventNotificationChannel {
  Application = 'APPLICATION',
  Email = 'EMAIL'
}

export type EventNotificationChannelOperationFilterInput = {
  eq?: InputMaybe<EventNotificationChannel>;
  in?: InputMaybe<Array<EventNotificationChannel>>;
  neq?: InputMaybe<EventNotificationChannel>;
  nin?: InputMaybe<Array<EventNotificationChannel>>;
};

export enum EventNotificationDeliveryStatus {
  Draft = 'DRAFT',
  Failed = 'FAILED',
  Queued = 'QUEUED',
  Sent = 'SENT'
}

export type EventNotificationDeliveryStatusOperationFilterInput = {
  eq?: InputMaybe<EventNotificationDeliveryStatus>;
  in?: InputMaybe<Array<EventNotificationDeliveryStatus>>;
  neq?: InputMaybe<EventNotificationDeliveryStatus>;
  nin?: InputMaybe<Array<EventNotificationDeliveryStatus>>;
};

export type EventNotificationRecipientDto = {
  __typename?: 'EventNotificationRecipientDto';
  additionalInfo: Scalars['String']['output'];
  company: Scalars['String']['output'];
  email: Scalars['String']['output'];
  eventId: Scalars['Int']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastName: Scalars['String']['output'];
  linkedInUrl: Scalars['String']['output'];
  participantId: Scalars['Int']['output'];
  participationFeePricePeriodName: Scalars['String']['output'];
  participationFeeTypeId?: Maybe<Scalars['Int']['output']>;
  participationFeeTypeLabelEn: Scalars['String']['output'];
  participationFeeTypeLabelHr: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  registrationId?: Maybe<Scalars['Int']['output']>;
  registrationStatus?: Maybe<EventRegistrationStatus>;
};

export type EventOfferBalanceDto = {
  __typename?: 'EventOfferBalanceDto';
  currency: Scalars['String']['output'];
  dueDate: Scalars['DateTime']['output'];
  eventId: Scalars['Int']['output'];
  generatedAt: Scalars['DateTime']['output'];
  grossTotal: Scalars['Decimal']['output'];
  id: Scalars['Int']['output'];
  offerNumber: Scalars['String']['output'];
  outstandingAmount: Scalars['Decimal']['output'];
  paidAmount: Scalars['Decimal']['output'];
  participantFullName: Scalars['String']['output'];
  participantId: Scalars['Int']['output'];
  payerId: Scalars['Int']['output'];
  payerName: Scalars['String']['output'];
  registrationId: Scalars['Int']['output'];
  status: EventOfferStatus;
  type: EventOfferType;
};

export type EventOfferBalanceDtoFilterInput = {
  and?: InputMaybe<Array<EventOfferBalanceDtoFilterInput>>;
  currency?: InputMaybe<StringOperationFilterInput>;
  dueDate?: InputMaybe<DateTimeOperationFilterInput>;
  eventId?: InputMaybe<IntOperationFilterInput>;
  generatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  grossTotal?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  offerNumber?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EventOfferBalanceDtoFilterInput>>;
  outstandingAmount?: InputMaybe<DecimalOperationFilterInput>;
  paidAmount?: InputMaybe<DecimalOperationFilterInput>;
  participantFullName?: InputMaybe<StringOperationFilterInput>;
  participantId?: InputMaybe<IntOperationFilterInput>;
  payerId?: InputMaybe<IntOperationFilterInput>;
  payerName?: InputMaybe<StringOperationFilterInput>;
  registrationId?: InputMaybe<IntOperationFilterInput>;
  status?: InputMaybe<EventOfferStatusOperationFilterInput>;
  type?: InputMaybe<EventOfferTypeOperationFilterInput>;
};

export type EventOfferBalanceDtoSortInput = {
  currency?: InputMaybe<SortEnumType>;
  dueDate?: InputMaybe<SortEnumType>;
  eventId?: InputMaybe<SortEnumType>;
  generatedAt?: InputMaybe<SortEnumType>;
  grossTotal?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  offerNumber?: InputMaybe<SortEnumType>;
  outstandingAmount?: InputMaybe<SortEnumType>;
  paidAmount?: InputMaybe<SortEnumType>;
  participantFullName?: InputMaybe<SortEnumType>;
  participantId?: InputMaybe<SortEnumType>;
  payerId?: InputMaybe<SortEnumType>;
  payerName?: InputMaybe<SortEnumType>;
  registrationId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type EventOfferBalancesCollectionSegment = {
  __typename?: 'EventOfferBalancesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<EventOfferBalanceDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type EventOfferHistoryDto = {
  __typename?: 'EventOfferHistoryDto';
  currency: Scalars['String']['output'];
  customerPurchaseOrderFileContentType?: Maybe<Scalars['String']['output']>;
  customerPurchaseOrderFileId?: Maybe<Scalars['Int']['output']>;
  customerPurchaseOrderFileName?: Maybe<Scalars['String']['output']>;
  dueDate: Scalars['DateTime']['output'];
  emailFailedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  emailFailureReason: Scalars['String']['output'];
  emailQueuedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  emailTo: Scalars['String']['output'];
  emailedAt?: Maybe<Scalars['DateTime']['output']>;
  eventCode: Scalars['String']['output'];
  eventId: Scalars['Int']['output'];
  eventName: Scalars['String']['output'];
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  fileContentType: Scalars['String']['output'];
  fileId: Scalars['Int']['output'];
  fileName: Scalars['String']['output'];
  generatedAt: Scalars['DateTime']['output'];
  grossTotal: Scalars['Decimal']['output'];
  id: Scalars['Int']['output'];
  lines: Array<EventOfferLineSummaryDto>;
  netTotal: Scalars['Decimal']['output'];
  offerNumber: Scalars['String']['output'];
  participantFullName: Scalars['String']['output'];
  participantId: Scalars['Int']['output'];
  paymentMethod: PaymentMethod;
  registrationId: Scalars['Int']['output'];
  replacedAt?: Maybe<Scalars['DateTime']['output']>;
  replacementOfferId?: Maybe<Scalars['Int']['output']>;
  replacementOfferNumber?: Maybe<Scalars['String']['output']>;
  replacesOfferId?: Maybe<Scalars['Int']['output']>;
  replacesOfferNumber?: Maybe<Scalars['String']['output']>;
  status: EventOfferStatus;
  taxTotal: Scalars['Decimal']['output'];
  type: EventOfferType;
};

export type EventOfferHistoryDtoFilterInput = {
  and?: InputMaybe<Array<EventOfferHistoryDtoFilterInput>>;
  currency?: InputMaybe<StringOperationFilterInput>;
  customerPurchaseOrderFileContentType?: InputMaybe<StringOperationFilterInput>;
  customerPurchaseOrderFileId?: InputMaybe<IntOperationFilterInput>;
  customerPurchaseOrderFileName?: InputMaybe<StringOperationFilterInput>;
  dueDate?: InputMaybe<DateTimeOperationFilterInput>;
  emailFailedAtUtc?: InputMaybe<DateTimeOperationFilterInput>;
  emailFailureReason?: InputMaybe<StringOperationFilterInput>;
  emailQueuedAtUtc?: InputMaybe<DateTimeOperationFilterInput>;
  emailTo?: InputMaybe<StringOperationFilterInput>;
  emailedAt?: InputMaybe<DateTimeOperationFilterInput>;
  eventCode?: InputMaybe<StringOperationFilterInput>;
  eventId?: InputMaybe<IntOperationFilterInput>;
  eventName?: InputMaybe<StringOperationFilterInput>;
  expiredAt?: InputMaybe<DateTimeOperationFilterInput>;
  fileContentType?: InputMaybe<StringOperationFilterInput>;
  fileId?: InputMaybe<IntOperationFilterInput>;
  fileName?: InputMaybe<StringOperationFilterInput>;
  generatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  grossTotal?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  lines?: InputMaybe<ListFilterInputTypeOfEventOfferLineSummaryDtoFilterInput>;
  netTotal?: InputMaybe<DecimalOperationFilterInput>;
  offerNumber?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EventOfferHistoryDtoFilterInput>>;
  participantFullName?: InputMaybe<StringOperationFilterInput>;
  participantId?: InputMaybe<IntOperationFilterInput>;
  paymentMethod?: InputMaybe<PaymentMethodOperationFilterInput>;
  registrationId?: InputMaybe<IntOperationFilterInput>;
  replacedAt?: InputMaybe<DateTimeOperationFilterInput>;
  replacementOfferId?: InputMaybe<IntOperationFilterInput>;
  replacementOfferNumber?: InputMaybe<StringOperationFilterInput>;
  replacesOfferId?: InputMaybe<IntOperationFilterInput>;
  replacesOfferNumber?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<EventOfferStatusOperationFilterInput>;
  taxTotal?: InputMaybe<DecimalOperationFilterInput>;
  type?: InputMaybe<EventOfferTypeOperationFilterInput>;
};

export type EventOfferHistoryDtoSortInput = {
  currency?: InputMaybe<SortEnumType>;
  customerPurchaseOrderFileContentType?: InputMaybe<SortEnumType>;
  customerPurchaseOrderFileId?: InputMaybe<SortEnumType>;
  customerPurchaseOrderFileName?: InputMaybe<SortEnumType>;
  dueDate?: InputMaybe<SortEnumType>;
  emailFailedAtUtc?: InputMaybe<SortEnumType>;
  emailFailureReason?: InputMaybe<SortEnumType>;
  emailQueuedAtUtc?: InputMaybe<SortEnumType>;
  emailTo?: InputMaybe<SortEnumType>;
  emailedAt?: InputMaybe<SortEnumType>;
  eventCode?: InputMaybe<SortEnumType>;
  eventId?: InputMaybe<SortEnumType>;
  eventName?: InputMaybe<SortEnumType>;
  expiredAt?: InputMaybe<SortEnumType>;
  fileContentType?: InputMaybe<SortEnumType>;
  fileId?: InputMaybe<SortEnumType>;
  fileName?: InputMaybe<SortEnumType>;
  generatedAt?: InputMaybe<SortEnumType>;
  grossTotal?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  netTotal?: InputMaybe<SortEnumType>;
  offerNumber?: InputMaybe<SortEnumType>;
  participantFullName?: InputMaybe<SortEnumType>;
  participantId?: InputMaybe<SortEnumType>;
  paymentMethod?: InputMaybe<SortEnumType>;
  registrationId?: InputMaybe<SortEnumType>;
  replacedAt?: InputMaybe<SortEnumType>;
  replacementOfferId?: InputMaybe<SortEnumType>;
  replacementOfferNumber?: InputMaybe<SortEnumType>;
  replacesOfferId?: InputMaybe<SortEnumType>;
  replacesOfferNumber?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  taxTotal?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

export enum EventOfferLineItemType {
  Accommodation = 'ACCOMMODATION',
  Option = 'OPTION',
  Participation = 'PARTICIPATION'
}

export type EventOfferLineItemTypeOperationFilterInput = {
  eq?: InputMaybe<EventOfferLineItemType>;
  in?: InputMaybe<Array<EventOfferLineItemType>>;
  neq?: InputMaybe<EventOfferLineItemType>;
  nin?: InputMaybe<Array<EventOfferLineItemType>>;
};

export enum EventOfferLineSourceType {
  EventAccommodation = 'EVENT_ACCOMMODATION',
  EventFeePrice = 'EVENT_FEE_PRICE',
  EventOption = 'EVENT_OPTION',
  EventRoomReservation = 'EVENT_ROOM_RESERVATION',
  None = 'NONE'
}

export type EventOfferLineSourceTypeOperationFilterInput = {
  eq?: InputMaybe<EventOfferLineSourceType>;
  in?: InputMaybe<Array<EventOfferLineSourceType>>;
  neq?: InputMaybe<EventOfferLineSourceType>;
  nin?: InputMaybe<Array<EventOfferLineSourceType>>;
};

export type EventOfferLineSummaryDto = {
  __typename?: 'EventOfferLineSummaryDto';
  description: Scalars['String']['output'];
  grossTotal: Scalars['Decimal']['output'];
  id: Scalars['Int']['output'];
  itemType: EventOfferLineItemType;
  lineNumber: Scalars['Int']['output'];
  netTotal: Scalars['Decimal']['output'];
  quantity: Scalars['Decimal']['output'];
  sourceId?: Maybe<Scalars['Int']['output']>;
  sourceType: EventOfferLineSourceType;
  taxRate: Scalars['Decimal']['output'];
  taxTotal: Scalars['Decimal']['output'];
  unitNetPrice: Scalars['Decimal']['output'];
};

export type EventOfferLineSummaryDtoFilterInput = {
  and?: InputMaybe<Array<EventOfferLineSummaryDtoFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  grossTotal?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  itemType?: InputMaybe<EventOfferLineItemTypeOperationFilterInput>;
  lineNumber?: InputMaybe<IntOperationFilterInput>;
  netTotal?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<EventOfferLineSummaryDtoFilterInput>>;
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  sourceId?: InputMaybe<IntOperationFilterInput>;
  sourceType?: InputMaybe<EventOfferLineSourceTypeOperationFilterInput>;
  taxRate?: InputMaybe<DecimalOperationFilterInput>;
  taxTotal?: InputMaybe<DecimalOperationFilterInput>;
  unitNetPrice?: InputMaybe<DecimalOperationFilterInput>;
};

export type EventOfferRenewDtoInput = {
  eventId: Scalars['Int']['input'];
  offerId: Scalars['Int']['input'];
};

export type EventOfferRenewalResultDto = {
  __typename?: 'EventOfferRenewalResultDto';
  currency: Scalars['String']['output'];
  emailFailedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  emailFailureReason: Scalars['String']['output'];
  emailQueuedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  emailTo: Scalars['String']['output'];
  emailedAt?: Maybe<Scalars['DateTime']['output']>;
  eventId: Scalars['Int']['output'];
  fileId: Scalars['Int']['output'];
  participantId: Scalars['Int']['output'];
  paymentMethod: PaymentMethod;
  previousExpiredAt?: Maybe<Scalars['DateTime']['output']>;
  previousOfferId: Scalars['Int']['output'];
  previousOfferNumber: Scalars['String']['output'];
  previousReplacedAt?: Maybe<Scalars['DateTime']['output']>;
  previousStatus: EventOfferStatus;
  registrationId: Scalars['Int']['output'];
  replacementDueDate: Scalars['DateTime']['output'];
  replacementGeneratedAt: Scalars['DateTime']['output'];
  replacementGrossTotal: Scalars['Decimal']['output'];
  replacementLines: Array<EventOfferLineSummaryDto>;
  replacementNetTotal: Scalars['Decimal']['output'];
  replacementOfferId: Scalars['Int']['output'];
  replacementOfferNumber: Scalars['String']['output'];
  replacementStatus: EventOfferStatus;
  replacementTaxTotal: Scalars['Decimal']['output'];
  replacesOfferId: Scalars['Int']['output'];
  type: EventOfferType;
};

export enum EventOfferStatus {
  Emailed = 'EMAILED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  Generated = 'GENERATED',
  Queued = 'QUEUED',
  Replaced = 'REPLACED'
}

export type EventOfferStatusOperationFilterInput = {
  eq?: InputMaybe<EventOfferStatus>;
  in?: InputMaybe<Array<EventOfferStatus>>;
  neq?: InputMaybe<EventOfferStatus>;
  nin?: InputMaybe<Array<EventOfferStatus>>;
};

export enum EventOfferType {
  Accommodation = 'ACCOMMODATION',
  Participation = 'PARTICIPATION'
}

export type EventOfferTypeOperationFilterInput = {
  eq?: InputMaybe<EventOfferType>;
  in?: InputMaybe<Array<EventOfferType>>;
  neq?: InputMaybe<EventOfferType>;
  nin?: InputMaybe<Array<EventOfferType>>;
};

export type EventOptionChoiceDto = {
  __typename?: 'EventOptionChoiceDto';
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  labelEn: Scalars['String']['output'];
  labelHr: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

export type EventOptionChoiceDtoFilterInput = {
  and?: InputMaybe<Array<EventOptionChoiceDtoFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  labelEn?: InputMaybe<StringOperationFilterInput>;
  labelHr?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EventOptionChoiceDtoFilterInput>>;
  order?: InputMaybe<IntOperationFilterInput>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type EventOptionChoiceDtoInput = {
  id: Scalars['Int']['input'];
  isActive: Scalars['Boolean']['input'];
  labelEn: Scalars['String']['input'];
  labelHr: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EventOptionCreateDtoInput = {
  allowedFeeTypeIds: Array<Scalars['Int']['input']>;
  categoryCodes: Scalars['String']['input'];
  choices: Array<EventOptionChoiceDtoInput>;
  conditionType: OptionConditionType;
  dependsOnCode: Scalars['String']['input'];
  dependsOnValue: Scalars['String']['input'];
  descriptionEn: Scalars['String']['input'];
  descriptionHr: Scalars['String']['input'];
  eventId: Scalars['Int']['input'];
  isActive: Scalars['Boolean']['input'];
  labelEn: Scalars['String']['input'];
  labelHr: Scalars['String']['input'];
  price: Scalars['Decimal']['input'];
  priceEffect: OptionPriceEffect;
  publicRegistrationEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  questionType: OptionQuestionType;
  tracksUsageOrAttendance: Scalars['Boolean']['input'];
  vatRate: Scalars['Decimal']['input'];
  visibilityDependsOnEventOptionId?: InputMaybe<Scalars['Int']['input']>;
  visibilityDependsOnExpectedAnswer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EventOptionReturnDto = {
  __typename?: 'EventOptionReturnDto';
  allowedFeeTypeIds: Array<Scalars['Int']['output']>;
  categoryCodes: Scalars['String']['output'];
  choices: Array<EventOptionChoiceDto>;
  conditionType: OptionConditionType;
  dependsOnCode: Scalars['String']['output'];
  dependsOnValue: Scalars['String']['output'];
  descriptionEn: Scalars['String']['output'];
  descriptionHr: Scalars['String']['output'];
  eventId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  labelEn: Scalars['String']['output'];
  labelHr: Scalars['String']['output'];
  price: Scalars['Decimal']['output'];
  priceEffect: OptionPriceEffect;
  publicRegistrationEndDate?: Maybe<Scalars['DateTime']['output']>;
  questionType: OptionQuestionType;
  tracksUsageOrAttendance: Scalars['Boolean']['output'];
  vatRate: Scalars['Decimal']['output'];
  visibilityDependsOnEventOptionId?: Maybe<Scalars['Int']['output']>;
  visibilityDependsOnExpectedAnswer?: Maybe<Scalars['Boolean']['output']>;
};

export type EventOptionReturnDtoFilterInput = {
  allowedFeeTypeIds?: InputMaybe<ListIntOperationFilterInput>;
  and?: InputMaybe<Array<EventOptionReturnDtoFilterInput>>;
  categoryCodes?: InputMaybe<StringOperationFilterInput>;
  choices?: InputMaybe<ListFilterInputTypeOfEventOptionChoiceDtoFilterInput>;
  conditionType?: InputMaybe<OptionConditionTypeOperationFilterInput>;
  dependsOnCode?: InputMaybe<StringOperationFilterInput>;
  dependsOnValue?: InputMaybe<StringOperationFilterInput>;
  descriptionEn?: InputMaybe<StringOperationFilterInput>;
  descriptionHr?: InputMaybe<StringOperationFilterInput>;
  eventId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  labelEn?: InputMaybe<StringOperationFilterInput>;
  labelHr?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EventOptionReturnDtoFilterInput>>;
  price?: InputMaybe<DecimalOperationFilterInput>;
  priceEffect?: InputMaybe<OptionPriceEffectOperationFilterInput>;
  publicRegistrationEndDate?: InputMaybe<DateTimeOperationFilterInput>;
  questionType?: InputMaybe<OptionQuestionTypeOperationFilterInput>;
  tracksUsageOrAttendance?: InputMaybe<BooleanOperationFilterInput>;
  vatRate?: InputMaybe<DecimalOperationFilterInput>;
  visibilityDependsOnEventOptionId?: InputMaybe<IntOperationFilterInput>;
  visibilityDependsOnExpectedAnswer?: InputMaybe<BooleanOperationFilterInput>;
};

export type EventOptionReturnDtoSortInput = {
  categoryCodes?: InputMaybe<SortEnumType>;
  conditionType?: InputMaybe<SortEnumType>;
  dependsOnCode?: InputMaybe<SortEnumType>;
  dependsOnValue?: InputMaybe<SortEnumType>;
  descriptionEn?: InputMaybe<SortEnumType>;
  descriptionHr?: InputMaybe<SortEnumType>;
  eventId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  labelEn?: InputMaybe<SortEnumType>;
  labelHr?: InputMaybe<SortEnumType>;
  price?: InputMaybe<SortEnumType>;
  priceEffect?: InputMaybe<SortEnumType>;
  publicRegistrationEndDate?: InputMaybe<SortEnumType>;
  questionType?: InputMaybe<SortEnumType>;
  tracksUsageOrAttendance?: InputMaybe<SortEnumType>;
  vatRate?: InputMaybe<SortEnumType>;
  visibilityDependsOnEventOptionId?: InputMaybe<SortEnumType>;
  visibilityDependsOnExpectedAnswer?: InputMaybe<SortEnumType>;
};

export type EventOptionUpdateDtoInput = {
  allowedFeeTypeIds: Array<Scalars['Int']['input']>;
  categoryCodes: Scalars['String']['input'];
  choices: Array<EventOptionChoiceDtoInput>;
  conditionType: OptionConditionType;
  dependsOnCode: Scalars['String']['input'];
  dependsOnValue: Scalars['String']['input'];
  descriptionEn: Scalars['String']['input'];
  descriptionHr: Scalars['String']['input'];
  eventId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  isActive: Scalars['Boolean']['input'];
  labelEn: Scalars['String']['input'];
  labelHr: Scalars['String']['input'];
  price: Scalars['Decimal']['input'];
  priceEffect: OptionPriceEffect;
  publicRegistrationEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  questionType: OptionQuestionType;
  tracksUsageOrAttendance: Scalars['Boolean']['input'];
  vatRate: Scalars['Decimal']['input'];
  visibilityDependsOnEventOptionId?: InputMaybe<Scalars['Int']['input']>;
  visibilityDependsOnExpectedAnswer?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A segment of a collection. */
export type EventOptionsCollectionSegment = {
  __typename?: 'EventOptionsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<EventOptionReturnDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type EventParticipantCrmDetailDto = {
  __typename?: 'EventParticipantCrmDetailDto';
  additionalInfo: Scalars['String']['output'];
  certificates: Array<EventCertificateHistoryDto>;
  company: Scalars['String']['output'];
  email: Scalars['String']['output'];
  eventCode: Scalars['String']['output'];
  eventId: Scalars['Int']['output'];
  eventName: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  linkedInUrl: Scalars['String']['output'];
  offers: Array<EventOfferHistoryDto>;
  participantId: Scalars['Int']['output'];
  phoneNumber: Scalars['String']['output'];
  registrationCodes: Array<EventParticipantCrmRegistrationCodeDto>;
  registrations: Array<EventParticipantCrmRegistrationDto>;
  roomReservations: Array<EventParticipantCrmRoomReservationDto>;
};

export type EventParticipantCrmRegistrationCodeDto = {
  __typename?: 'EventParticipantCrmRegistrationCodeDto';
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  issuedAt: Scalars['DateTime']['output'];
  registrationId: Scalars['Int']['output'];
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EventParticipantCrmRegistrationDto = {
  __typename?: 'EventParticipantCrmRegistrationDto';
  accommodationPaymentMethod: PaymentMethod;
  activityAnswers: Array<EventRegistrationActivityAnswerReturnDto>;
  createdAt: Scalars['DateTime']['output'];
  currentAccommodationOfferId?: Maybe<Scalars['Int']['output']>;
  currentAccommodationOfferNumber: Scalars['String']['output'];
  currentAccommodationOfferPaymentCount: Scalars['Int']['output'];
  currentAccommodationOfferPaymentGrossTotal: Scalars['Decimal']['output'];
  currentAccommodationOfferPaymentStatus?: Maybe<PaymentStatus>;
  currentAccommodationOfferStatus?: Maybe<EventOfferStatus>;
  currentParticipationOfferId?: Maybe<Scalars['Int']['output']>;
  currentParticipationOfferNumber: Scalars['String']['output'];
  currentParticipationOfferPaymentCount: Scalars['Int']['output'];
  currentParticipationOfferPaymentGrossTotal: Scalars['Decimal']['output'];
  currentParticipationOfferPaymentStatus?: Maybe<PaymentStatus>;
  currentParticipationOfferStatus?: Maybe<EventOfferStatus>;
  emailVerifiedAt?: Maybe<Scalars['DateTime']['output']>;
  gdprConsentAccepted: Scalars['Boolean']['output'];
  gdprConsentAcceptedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  gdprConsentEventId?: Maybe<Scalars['Int']['output']>;
  gdprConsentTextVersion: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  invitationEmailFailedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  invitationEmailFailureReason: Scalars['String']['output'];
  invitationEmailQueuedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  invitationEmailSentAtUtc?: Maybe<Scalars['DateTime']['output']>;
  invitationEmailStatus?: Maybe<EmailDeliveryStatus>;
  isEmailVerified: Scalars['Boolean']['output'];
  offerDueDate?: Maybe<Scalars['DateTime']['output']>;
  participantTypeProofFileContentType: Scalars['String']['output'];
  participantTypeProofFileId?: Maybe<Scalars['Int']['output']>;
  participantTypeProofFileName: Scalars['String']['output'];
  participationPaymentMethod: PaymentMethod;
  payerAddress: Scalars['String']['output'];
  payerCity: Scalars['String']['output'];
  payerContactPerson: Scalars['String']['output'];
  payerCountry: Scalars['String']['output'];
  payerEmail: Scalars['String']['output'];
  payerId: Scalars['Int']['output'];
  payerName: Scalars['String']['output'];
  payerPhone: Scalars['String']['output'];
  payerTaxId: Scalars['String']['output'];
  payerType: PayerType;
  rejectionReason: Scalars['String']['output'];
  selectedEventOptionIds: Array<Scalars['Int']['output']>;
  selectedParticipationFeeTypeId?: Maybe<Scalars['Int']['output']>;
  status: EventRegistrationStatus;
  updatedAt: Scalars['DateTime']['output'];
  verificationEmailFailedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  verificationEmailFailureReason: Scalars['String']['output'];
  verificationEmailQueuedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  verificationEmailSentAtUtc?: Maybe<Scalars['DateTime']['output']>;
  verificationEmailStatus?: Maybe<EmailDeliveryStatus>;
};

export type EventParticipantCrmRoomReservationDto = {
  __typename?: 'EventParticipantCrmRoomReservationDto';
  arrivalDate: Scalars['LocalDate']['output'];
  departureDate: Scalars['LocalDate']['output'];
  hotelId: Scalars['Int']['output'];
  hotelName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  nightCount: Scalars['Int']['output'];
  pricePerNightSnapshot: Scalars['Decimal']['output'];
  registrationId: Scalars['Int']['output'];
  roomCount: Scalars['Int']['output'];
  roomTypeId: Scalars['Int']['output'];
  roomTypeName: Scalars['String']['output'];
  status: EventRoomReservationStatus;
  totalPriceSnapshot: Scalars['Decimal']['output'];
};

export type EventParticipantDeleteDtoInput = {
  id: Scalars['Int']['input'];
};

/** A segment of a collection. */
export type EventParticipantNotificationHistoryCollectionSegment = {
  __typename?: 'EventParticipantNotificationHistoryCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<EventRegistrationNotificationDeliveryLogDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type EventParticipantReturnDto = {
  __typename?: 'EventParticipantReturnDto';
  accommodationStatusSortKey: Scalars['Int']['output'];
  additionalInfo: Scalars['String']['output'];
  certificateStatusSortKey: Scalars['Int']['output'];
  company: Scalars['String']['output'];
  email: Scalars['String']['output'];
  eventId: Scalars['Int']['output'];
  feeStatusSortKey: Scalars['Int']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastName: Scalars['String']['output'];
  linkedInUrl: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  qrStatusSortKey: Scalars['Int']['output'];
  registrationStatusSortKey: Scalars['Int']['output'];
};

export type EventParticipantReturnDtoFilterInput = {
  accommodationStatusSortKey?: InputMaybe<IntOperationFilterInput>;
  additionalInfo?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<EventParticipantReturnDtoFilterInput>>;
  certificateStatusSortKey?: InputMaybe<IntOperationFilterInput>;
  company?: InputMaybe<StringOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  eventId?: InputMaybe<IntOperationFilterInput>;
  feeStatusSortKey?: InputMaybe<IntOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  linkedInUrl?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EventParticipantReturnDtoFilterInput>>;
  phoneNumber?: InputMaybe<StringOperationFilterInput>;
  qrStatusSortKey?: InputMaybe<IntOperationFilterInput>;
  registrationStatusSortKey?: InputMaybe<IntOperationFilterInput>;
};

export type EventParticipantReturnDtoSortInput = {
  accommodationStatusSortKey?: InputMaybe<SortEnumType>;
  additionalInfo?: InputMaybe<SortEnumType>;
  certificateStatusSortKey?: InputMaybe<SortEnumType>;
  company?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  eventId?: InputMaybe<SortEnumType>;
  feeStatusSortKey?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  linkedInUrl?: InputMaybe<SortEnumType>;
  phoneNumber?: InputMaybe<SortEnumType>;
  qrStatusSortKey?: InputMaybe<SortEnumType>;
  registrationStatusSortKey?: InputMaybe<SortEnumType>;
};

export type EventParticipantStatusFilterDtoInput = {
  accommodationStatuses?: InputMaybe<Array<Scalars['String']['input']>>;
  certificateStatuses?: InputMaybe<Array<Scalars['String']['input']>>;
  feeStatuses?: InputMaybe<Array<Scalars['String']['input']>>;
  qrStatuses?: InputMaybe<Array<Scalars['String']['input']>>;
  registrationStatuses?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EventParticipantUpdateDtoInput = {
  additionalInfo: Scalars['String']['input'];
  company: Scalars['String']['input'];
  email: Scalars['String']['input'];
  eventId: Scalars['Int']['input'];
  firstName: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  lastName: Scalars['String']['input'];
  linkedInUrl: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

/** A segment of a collection. */
export type EventParticipantsCollectionSegment = {
  __typename?: 'EventParticipantsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<EventParticipantReturnDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type EventPaymentMethodCreateDtoInput = {
  bankTransferAllowed: Scalars['Boolean']['input'];
  cardAllowed: Scalars['Boolean']['input'];
  category: PaymentMethodCategory;
  eventId: Scalars['Int']['input'];
  posAllowed: Scalars['Boolean']['input'];
};

export type EventPaymentMethodReturnDto = {
  __typename?: 'EventPaymentMethodReturnDto';
  allowedMethods: Array<PaymentMethod>;
  bankTransferAllowed: Scalars['Boolean']['output'];
  cardAllowed: Scalars['Boolean']['output'];
  category: PaymentMethodCategory;
  eventId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  posAllowed: Scalars['Boolean']['output'];
};

export type EventPaymentMethodReturnDtoFilterInput = {
  and?: InputMaybe<Array<EventPaymentMethodReturnDtoFilterInput>>;
  bankTransferAllowed?: InputMaybe<BooleanOperationFilterInput>;
  cardAllowed?: InputMaybe<BooleanOperationFilterInput>;
  category?: InputMaybe<PaymentMethodCategoryOperationFilterInput>;
  eventId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<EventPaymentMethodReturnDtoFilterInput>>;
  posAllowed?: InputMaybe<BooleanOperationFilterInput>;
};

export type EventPaymentMethodReturnDtoSortInput = {
  bankTransferAllowed?: InputMaybe<SortEnumType>;
  cardAllowed?: InputMaybe<SortEnumType>;
  category?: InputMaybe<SortEnumType>;
  eventId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  posAllowed?: InputMaybe<SortEnumType>;
};

export type EventPaymentMethodUpdateDtoInput = {
  bankTransferAllowed: Scalars['Boolean']['input'];
  cardAllowed: Scalars['Boolean']['input'];
  category: PaymentMethodCategory;
  eventId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  posAllowed: Scalars['Boolean']['input'];
};

/** A segment of a collection. */
export type EventPaymentMethodsCollectionSegment = {
  __typename?: 'EventPaymentMethodsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<EventPaymentMethodReturnDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type EventPricePeriodCreateDtoInput = {
  code: Scalars['String']['input'];
  endDate: Scalars['DateTime']['input'];
  eventId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type EventPricePeriodReturnDto = {
  __typename?: 'EventPricePeriodReturnDto';
  code: Scalars['String']['output'];
  endDate: Scalars['DateTime']['output'];
  eventId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  startDate: Scalars['DateTime']['output'];
};

export type EventPricePeriodReturnDtoFilterInput = {
  and?: InputMaybe<Array<EventPricePeriodReturnDtoFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  eventId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EventPricePeriodReturnDtoFilterInput>>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
};

export type EventPricePeriodReturnDtoSortInput = {
  code?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  eventId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
};

export type EventPricePeriodUpdateDtoInput = {
  code: Scalars['String']['input'];
  endDate: Scalars['DateTime']['input'];
  eventId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
};

/** A segment of a collection. */
export type EventPricePeriodsCollectionSegment = {
  __typename?: 'EventPricePeriodsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<EventPricePeriodReturnDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export enum EventPublicAssetMode {
  CombinedPdf = 'COMBINED_PDF',
  SeparateProgramAndLayout = 'SEPARATE_PROGRAM_AND_LAYOUT'
}

export type EventPublicAssetModeOperationFilterInput = {
  eq?: InputMaybe<EventPublicAssetMode>;
  in?: InputMaybe<Array<EventPublicAssetMode>>;
  neq?: InputMaybe<EventPublicAssetMode>;
  nin?: InputMaybe<Array<EventPublicAssetMode>>;
};

export type EventRegistrationActivityAnswerInputDtoInput = {
  eventOptionId: Scalars['Int']['input'];
  isSelected: Scalars['Boolean']['input'];
  selectedChoiceIds: Array<Scalars['Int']['input']>;
  textValue?: InputMaybe<Scalars['String']['input']>;
};

export type EventRegistrationActivityAnswerReturnDto = {
  __typename?: 'EventRegistrationActivityAnswerReturnDto';
  eventOptionId: Scalars['Int']['output'];
  isSelected: Scalars['Boolean']['output'];
  questionType: OptionQuestionType;
  selectedChoiceIds: Array<Scalars['Int']['output']>;
  textValue: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type EventRegistrationDeleteDtoInput = {
  id: Scalars['Int']['input'];
};

export type EventRegistrationFormArbitraryFieldOptionReturnDto = {
  __typename?: 'EventRegistrationFormArbitraryFieldOptionReturnDto';
  fieldId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

export type EventRegistrationFormArbitraryFieldOptionReturnDtoFilterInput = {
  and?: InputMaybe<Array<EventRegistrationFormArbitraryFieldOptionReturnDtoFilterInput>>;
  fieldId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  label?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EventRegistrationFormArbitraryFieldOptionReturnDtoFilterInput>>;
  order?: InputMaybe<IntOperationFilterInput>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type EventRegistrationFormArbitraryFieldReturnDto = {
  __typename?: 'EventRegistrationFormArbitraryFieldReturnDto';
  code: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  options: Array<EventRegistrationFormArbitraryFieldOptionReturnDto>;
  order: Scalars['Int']['output'];
  templateId: Scalars['Int']['output'];
  type: ArbitraryFormFieldType;
};

export type EventRegistrationFormArbitraryFieldReturnDtoFilterInput = {
  and?: InputMaybe<Array<EventRegistrationFormArbitraryFieldReturnDtoFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isRequired?: InputMaybe<BooleanOperationFilterInput>;
  label?: InputMaybe<StringOperationFilterInput>;
  options?: InputMaybe<ListFilterInputTypeOfEventRegistrationFormArbitraryFieldOptionReturnDtoFilterInput>;
  or?: InputMaybe<Array<EventRegistrationFormArbitraryFieldReturnDtoFilterInput>>;
  order?: InputMaybe<IntOperationFilterInput>;
  templateId?: InputMaybe<IntOperationFilterInput>;
  type?: InputMaybe<ArbitraryFormFieldTypeOperationFilterInput>;
};

export type EventRegistrationFormArbitraryFieldsTemplateCreateDtoInput = {
  eventId: Scalars['Int']['input'];
  status: EventRegistrationFormTemplateStatus;
};

export type EventRegistrationFormArbitraryFieldsTemplateDeleteDtoInput = {
  id: Scalars['Int']['input'];
};

export type EventRegistrationFormArbitraryFieldsTemplateReturnDto = {
  __typename?: 'EventRegistrationFormArbitraryFieldsTemplateReturnDto';
  eventId: Scalars['Int']['output'];
  fields: Array<EventRegistrationFormArbitraryFieldReturnDto>;
  id: Scalars['Int']['output'];
  status: EventRegistrationFormTemplateStatus;
  version: Scalars['Int']['output'];
};

export type EventRegistrationFormArbitraryFieldsTemplateReturnDtoFilterInput = {
  and?: InputMaybe<Array<EventRegistrationFormArbitraryFieldsTemplateReturnDtoFilterInput>>;
  eventId?: InputMaybe<IntOperationFilterInput>;
  fields?: InputMaybe<ListFilterInputTypeOfEventRegistrationFormArbitraryFieldReturnDtoFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<EventRegistrationFormArbitraryFieldsTemplateReturnDtoFilterInput>>;
  status?: InputMaybe<EventRegistrationFormTemplateStatusOperationFilterInput>;
  version?: InputMaybe<IntOperationFilterInput>;
};

export type EventRegistrationFormArbitraryFieldsTemplateReturnDtoSortInput = {
  eventId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  version?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type EventRegistrationFormArbitraryFieldsTemplatesCollectionSegment = {
  __typename?: 'EventRegistrationFormArbitraryFieldsTemplatesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<EventRegistrationFormArbitraryFieldsTemplateReturnDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export enum EventRegistrationFormTemplateStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT'
}

export type EventRegistrationFormTemplateStatusOperationFilterInput = {
  eq?: InputMaybe<EventRegistrationFormTemplateStatus>;
  in?: InputMaybe<Array<EventRegistrationFormTemplateStatus>>;
  neq?: InputMaybe<EventRegistrationFormTemplateStatus>;
  nin?: InputMaybe<Array<EventRegistrationFormTemplateStatus>>;
};

export type EventRegistrationNotificationDeliveryLogDto = {
  __typename?: 'EventRegistrationNotificationDeliveryLogDto';
  createdAt: Scalars['DateTime']['output'];
  eventEmailTemplateId?: Maybe<Scalars['Int']['output']>;
  eventId: Scalars['Int']['output'];
  failedAt?: Maybe<Scalars['DateTime']['output']>;
  failureMessage: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  notificationChannel: EventNotificationChannel;
  participantId?: Maybe<Scalars['Int']['output']>;
  queuedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  recipientEmail: Scalars['String']['output'];
  registrationId?: Maybe<Scalars['Int']['output']>;
  replyToEmailsJson: Scalars['String']['output'];
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  sentByUserId: Scalars['String']['output'];
  status: EventNotificationDeliveryStatus;
  subject: Scalars['String']['output'];
};

export type EventRegistrationNotificationDeliveryLogDtoFilterInput = {
  and?: InputMaybe<Array<EventRegistrationNotificationDeliveryLogDtoFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  eventEmailTemplateId?: InputMaybe<IntOperationFilterInput>;
  eventId?: InputMaybe<IntOperationFilterInput>;
  failedAt?: InputMaybe<DateTimeOperationFilterInput>;
  failureMessage?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  message?: InputMaybe<StringOperationFilterInput>;
  notificationChannel?: InputMaybe<EventNotificationChannelOperationFilterInput>;
  or?: InputMaybe<Array<EventRegistrationNotificationDeliveryLogDtoFilterInput>>;
  participantId?: InputMaybe<IntOperationFilterInput>;
  queuedAtUtc?: InputMaybe<DateTimeOperationFilterInput>;
  recipientEmail?: InputMaybe<StringOperationFilterInput>;
  registrationId?: InputMaybe<IntOperationFilterInput>;
  replyToEmailsJson?: InputMaybe<StringOperationFilterInput>;
  sentAt?: InputMaybe<DateTimeOperationFilterInput>;
  sentByUserId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<EventNotificationDeliveryStatusOperationFilterInput>;
  subject?: InputMaybe<StringOperationFilterInput>;
};

export type EventRegistrationNotificationDeliveryLogDtoSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  eventEmailTemplateId?: InputMaybe<SortEnumType>;
  eventId?: InputMaybe<SortEnumType>;
  failedAt?: InputMaybe<SortEnumType>;
  failureMessage?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  message?: InputMaybe<SortEnumType>;
  notificationChannel?: InputMaybe<SortEnumType>;
  participantId?: InputMaybe<SortEnumType>;
  queuedAtUtc?: InputMaybe<SortEnumType>;
  recipientEmail?: InputMaybe<SortEnumType>;
  registrationId?: InputMaybe<SortEnumType>;
  replyToEmailsJson?: InputMaybe<SortEnumType>;
  sentAt?: InputMaybe<SortEnumType>;
  sentByUserId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  subject?: InputMaybe<SortEnumType>;
};

export type EventRegistrationNotificationSendDtoInput = {
  channels: Array<EventNotificationChannel>;
  eventEmailTemplateId?: InputMaybe<Scalars['Int']['input']>;
  eventId: Scalars['Int']['input'];
  message: Scalars['String']['input'];
  participantIds: Array<Scalars['Int']['input']>;
  registrationIds: Array<Scalars['Int']['input']>;
  replyToEmails: Array<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
};

export type EventRegistrationNotificationSendResultDto = {
  __typename?: 'EventRegistrationNotificationSendResultDto';
  eventEmailTemplateId?: Maybe<Scalars['Int']['output']>;
  eventId: Scalars['Int']['output'];
  failedCount: Scalars['Int']['output'];
  logs: Array<EventRegistrationNotificationDeliveryLogDto>;
  queuedCount: Scalars['Int']['output'];
  requestedCount: Scalars['Int']['output'];
  sentCount: Scalars['Int']['output'];
};

export type EventRegistrationOptionSelectionUpdateDtoInput = {
  activityAnswers: Array<EventRegistrationActivityAnswerInputDtoInput>;
  eventId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  selectedOptionIds: Array<Scalars['Int']['input']>;
};

export type EventRegistrationPayerChangeDtoInput = {
  eventId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  payerId: Scalars['Int']['input'];
};

export type EventRegistrationRejectDtoInput = {
  eventId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
};

export type EventRegistrationReturnDto = {
  __typename?: 'EventRegistrationReturnDto';
  accommodationArrivalDate?: Maybe<Scalars['LocalDate']['output']>;
  accommodationDepartureDate?: Maybe<Scalars['LocalDate']['output']>;
  accommodationHotelId?: Maybe<Scalars['Int']['output']>;
  accommodationHotelName: Scalars['String']['output'];
  accommodationReservationCount: Scalars['Int']['output'];
  accommodationReservationId?: Maybe<Scalars['Int']['output']>;
  accommodationReservationStatus?: Maybe<EventRoomReservationStatus>;
  accommodationReservedRoomCount: Scalars['Int']['output'];
  accommodationRoomTypeId?: Maybe<Scalars['Int']['output']>;
  accommodationRoomTypeName: Scalars['String']['output'];
  activeRegistrationCodeCount: Scalars['Int']['output'];
  arbitraryFieldsTemplateId: Scalars['Int']['output'];
  certificateCount: Scalars['Int']['output'];
  currentAccommodationOfferId?: Maybe<Scalars['Int']['output']>;
  currentAccommodationOfferNumber: Scalars['String']['output'];
  currentAccommodationOfferPaymentCount: Scalars['Int']['output'];
  currentAccommodationOfferPaymentGrossTotal: Scalars['Decimal']['output'];
  currentAccommodationOfferPaymentStatus?: Maybe<PaymentStatus>;
  currentAccommodationOfferStatus?: Maybe<EventOfferStatus>;
  currentParticipationOfferId?: Maybe<Scalars['Int']['output']>;
  currentParticipationOfferNumber: Scalars['String']['output'];
  currentParticipationOfferPaymentCount: Scalars['Int']['output'];
  currentParticipationOfferPaymentGrossTotal: Scalars['Decimal']['output'];
  currentParticipationOfferPaymentStatus?: Maybe<PaymentStatus>;
  currentParticipationOfferStatus?: Maybe<EventOfferStatus>;
  eventId: Scalars['Int']['output'];
  hasAccommodationOffer: Scalars['Boolean']['output'];
  hasAccommodationReservation: Scalars['Boolean']['output'];
  hasCertificates: Scalars['Boolean']['output'];
  hasOffers: Scalars['Boolean']['output'];
  hasParticipationOffer: Scalars['Boolean']['output'];
  hasPaymentAllocations: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  invitationEmailFailedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  invitationEmailFailureReason: Scalars['String']['output'];
  invitationEmailQueuedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  invitationEmailSentAtUtc?: Maybe<Scalars['DateTime']['output']>;
  invitationEmailStatus?: Maybe<EmailDeliveryStatus>;
  offerCount: Scalars['Int']['output'];
  participantCompany: Scalars['String']['output'];
  participantEmail: Scalars['String']['output'];
  participantFirstName: Scalars['String']['output'];
  participantFullName: Scalars['String']['output'];
  participantId: Scalars['Int']['output'];
  participantLastName: Scalars['String']['output'];
  participantLinkedInUrl: Scalars['String']['output'];
  participantPhoneNumber: Scalars['String']['output'];
  payerAddress: Scalars['String']['output'];
  payerCity: Scalars['String']['output'];
  payerContactPerson: Scalars['String']['output'];
  payerCountry: Scalars['String']['output'];
  payerEmail: Scalars['String']['output'];
  payerId?: Maybe<Scalars['Int']['output']>;
  payerName: Scalars['String']['output'];
  payerPhone: Scalars['String']['output'];
  payerTaxId: Scalars['String']['output'];
  payerType: PayerType;
  paymentAllocatedAmountTotal: Scalars['Decimal']['output'];
  paymentAllocationCount: Scalars['Int']['output'];
  rejectionReason: Scalars['String']['output'];
  revokedRegistrationCodeCount: Scalars['Int']['output'];
  status: EventRegistrationStatus;
  verificationEmailFailedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  verificationEmailFailureReason: Scalars['String']['output'];
  verificationEmailQueuedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  verificationEmailSentAtUtc?: Maybe<Scalars['DateTime']['output']>;
  verificationEmailStatus?: Maybe<EmailDeliveryStatus>;
};

export type EventRegistrationReturnDtoFilterInput = {
  accommodationArrivalDate?: InputMaybe<LocalDateOperationFilterInput>;
  accommodationDepartureDate?: InputMaybe<LocalDateOperationFilterInput>;
  accommodationHotelId?: InputMaybe<IntOperationFilterInput>;
  accommodationHotelName?: InputMaybe<StringOperationFilterInput>;
  accommodationReservationCount?: InputMaybe<IntOperationFilterInput>;
  accommodationReservationId?: InputMaybe<IntOperationFilterInput>;
  accommodationReservationStatus?: InputMaybe<NullableOfEventRoomReservationStatusOperationFilterInput>;
  accommodationReservedRoomCount?: InputMaybe<IntOperationFilterInput>;
  accommodationRoomTypeId?: InputMaybe<IntOperationFilterInput>;
  accommodationRoomTypeName?: InputMaybe<StringOperationFilterInput>;
  activeRegistrationCodeCount?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<EventRegistrationReturnDtoFilterInput>>;
  arbitraryFieldsTemplateId?: InputMaybe<IntOperationFilterInput>;
  certificateCount?: InputMaybe<IntOperationFilterInput>;
  currentAccommodationOfferId?: InputMaybe<IntOperationFilterInput>;
  currentAccommodationOfferNumber?: InputMaybe<StringOperationFilterInput>;
  currentAccommodationOfferPaymentCount?: InputMaybe<IntOperationFilterInput>;
  currentAccommodationOfferPaymentGrossTotal?: InputMaybe<DecimalOperationFilterInput>;
  currentAccommodationOfferPaymentStatus?: InputMaybe<NullableOfPaymentStatusOperationFilterInput>;
  currentAccommodationOfferStatus?: InputMaybe<NullableOfEventOfferStatusOperationFilterInput>;
  currentParticipationOfferId?: InputMaybe<IntOperationFilterInput>;
  currentParticipationOfferNumber?: InputMaybe<StringOperationFilterInput>;
  currentParticipationOfferPaymentCount?: InputMaybe<IntOperationFilterInput>;
  currentParticipationOfferPaymentGrossTotal?: InputMaybe<DecimalOperationFilterInput>;
  currentParticipationOfferPaymentStatus?: InputMaybe<NullableOfPaymentStatusOperationFilterInput>;
  currentParticipationOfferStatus?: InputMaybe<NullableOfEventOfferStatusOperationFilterInput>;
  eventId?: InputMaybe<IntOperationFilterInput>;
  hasAccommodationOffer?: InputMaybe<BooleanOperationFilterInput>;
  hasAccommodationReservation?: InputMaybe<BooleanOperationFilterInput>;
  hasCertificates?: InputMaybe<BooleanOperationFilterInput>;
  hasOffers?: InputMaybe<BooleanOperationFilterInput>;
  hasParticipationOffer?: InputMaybe<BooleanOperationFilterInput>;
  hasPaymentAllocations?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  invitationEmailFailedAtUtc?: InputMaybe<DateTimeOperationFilterInput>;
  invitationEmailFailureReason?: InputMaybe<StringOperationFilterInput>;
  invitationEmailQueuedAtUtc?: InputMaybe<DateTimeOperationFilterInput>;
  invitationEmailSentAtUtc?: InputMaybe<DateTimeOperationFilterInput>;
  invitationEmailStatus?: InputMaybe<NullableOfEmailDeliveryStatusOperationFilterInput>;
  offerCount?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<EventRegistrationReturnDtoFilterInput>>;
  participantCompany?: InputMaybe<StringOperationFilterInput>;
  participantEmail?: InputMaybe<StringOperationFilterInput>;
  participantFirstName?: InputMaybe<StringOperationFilterInput>;
  participantFullName?: InputMaybe<StringOperationFilterInput>;
  participantId?: InputMaybe<IntOperationFilterInput>;
  participantLastName?: InputMaybe<StringOperationFilterInput>;
  participantLinkedInUrl?: InputMaybe<StringOperationFilterInput>;
  participantPhoneNumber?: InputMaybe<StringOperationFilterInput>;
  payerAddress?: InputMaybe<StringOperationFilterInput>;
  payerCity?: InputMaybe<StringOperationFilterInput>;
  payerContactPerson?: InputMaybe<StringOperationFilterInput>;
  payerCountry?: InputMaybe<StringOperationFilterInput>;
  payerEmail?: InputMaybe<StringOperationFilterInput>;
  payerId?: InputMaybe<IntOperationFilterInput>;
  payerName?: InputMaybe<StringOperationFilterInput>;
  payerPhone?: InputMaybe<StringOperationFilterInput>;
  payerTaxId?: InputMaybe<StringOperationFilterInput>;
  payerType?: InputMaybe<PayerTypeOperationFilterInput>;
  paymentAllocatedAmountTotal?: InputMaybe<DecimalOperationFilterInput>;
  paymentAllocationCount?: InputMaybe<IntOperationFilterInput>;
  rejectionReason?: InputMaybe<StringOperationFilterInput>;
  revokedRegistrationCodeCount?: InputMaybe<IntOperationFilterInput>;
  status?: InputMaybe<EventRegistrationStatusOperationFilterInput>;
  verificationEmailFailedAtUtc?: InputMaybe<DateTimeOperationFilterInput>;
  verificationEmailFailureReason?: InputMaybe<StringOperationFilterInput>;
  verificationEmailQueuedAtUtc?: InputMaybe<DateTimeOperationFilterInput>;
  verificationEmailSentAtUtc?: InputMaybe<DateTimeOperationFilterInput>;
  verificationEmailStatus?: InputMaybe<NullableOfEmailDeliveryStatusOperationFilterInput>;
};

export type EventRegistrationReturnDtoSortInput = {
  accommodationArrivalDate?: InputMaybe<SortEnumType>;
  accommodationDepartureDate?: InputMaybe<SortEnumType>;
  accommodationHotelId?: InputMaybe<SortEnumType>;
  accommodationHotelName?: InputMaybe<SortEnumType>;
  accommodationReservationCount?: InputMaybe<SortEnumType>;
  accommodationReservationId?: InputMaybe<SortEnumType>;
  accommodationReservationStatus?: InputMaybe<SortEnumType>;
  accommodationReservedRoomCount?: InputMaybe<SortEnumType>;
  accommodationRoomTypeId?: InputMaybe<SortEnumType>;
  accommodationRoomTypeName?: InputMaybe<SortEnumType>;
  activeRegistrationCodeCount?: InputMaybe<SortEnumType>;
  arbitraryFieldsTemplateId?: InputMaybe<SortEnumType>;
  certificateCount?: InputMaybe<SortEnumType>;
  currentAccommodationOfferId?: InputMaybe<SortEnumType>;
  currentAccommodationOfferNumber?: InputMaybe<SortEnumType>;
  currentAccommodationOfferPaymentCount?: InputMaybe<SortEnumType>;
  currentAccommodationOfferPaymentGrossTotal?: InputMaybe<SortEnumType>;
  currentAccommodationOfferPaymentStatus?: InputMaybe<SortEnumType>;
  currentAccommodationOfferStatus?: InputMaybe<SortEnumType>;
  currentParticipationOfferId?: InputMaybe<SortEnumType>;
  currentParticipationOfferNumber?: InputMaybe<SortEnumType>;
  currentParticipationOfferPaymentCount?: InputMaybe<SortEnumType>;
  currentParticipationOfferPaymentGrossTotal?: InputMaybe<SortEnumType>;
  currentParticipationOfferPaymentStatus?: InputMaybe<SortEnumType>;
  currentParticipationOfferStatus?: InputMaybe<SortEnumType>;
  eventId?: InputMaybe<SortEnumType>;
  hasAccommodationOffer?: InputMaybe<SortEnumType>;
  hasAccommodationReservation?: InputMaybe<SortEnumType>;
  hasCertificates?: InputMaybe<SortEnumType>;
  hasOffers?: InputMaybe<SortEnumType>;
  hasParticipationOffer?: InputMaybe<SortEnumType>;
  hasPaymentAllocations?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  invitationEmailFailedAtUtc?: InputMaybe<SortEnumType>;
  invitationEmailFailureReason?: InputMaybe<SortEnumType>;
  invitationEmailQueuedAtUtc?: InputMaybe<SortEnumType>;
  invitationEmailSentAtUtc?: InputMaybe<SortEnumType>;
  invitationEmailStatus?: InputMaybe<SortEnumType>;
  offerCount?: InputMaybe<SortEnumType>;
  participantCompany?: InputMaybe<SortEnumType>;
  participantEmail?: InputMaybe<SortEnumType>;
  participantFirstName?: InputMaybe<SortEnumType>;
  participantFullName?: InputMaybe<SortEnumType>;
  participantId?: InputMaybe<SortEnumType>;
  participantLastName?: InputMaybe<SortEnumType>;
  participantLinkedInUrl?: InputMaybe<SortEnumType>;
  participantPhoneNumber?: InputMaybe<SortEnumType>;
  payerAddress?: InputMaybe<SortEnumType>;
  payerCity?: InputMaybe<SortEnumType>;
  payerContactPerson?: InputMaybe<SortEnumType>;
  payerCountry?: InputMaybe<SortEnumType>;
  payerEmail?: InputMaybe<SortEnumType>;
  payerId?: InputMaybe<SortEnumType>;
  payerName?: InputMaybe<SortEnumType>;
  payerPhone?: InputMaybe<SortEnumType>;
  payerTaxId?: InputMaybe<SortEnumType>;
  payerType?: InputMaybe<SortEnumType>;
  paymentAllocatedAmountTotal?: InputMaybe<SortEnumType>;
  paymentAllocationCount?: InputMaybe<SortEnumType>;
  rejectionReason?: InputMaybe<SortEnumType>;
  revokedRegistrationCodeCount?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  verificationEmailFailedAtUtc?: InputMaybe<SortEnumType>;
  verificationEmailFailureReason?: InputMaybe<SortEnumType>;
  verificationEmailQueuedAtUtc?: InputMaybe<SortEnumType>;
  verificationEmailSentAtUtc?: InputMaybe<SortEnumType>;
  verificationEmailStatus?: InputMaybe<SortEnumType>;
};

export enum EventRegistrationStatus {
  Odbijen = 'ODBIJEN',
  Potvrden = 'POTVRDEN',
  Pozvan = 'POZVAN',
  Prijavljen = 'PRIJAVLJEN',
  Registriran = 'REGISTRIRAN'
}

export type EventRegistrationStatusOperationFilterInput = {
  eq?: InputMaybe<EventRegistrationStatus>;
  in?: InputMaybe<Array<EventRegistrationStatus>>;
  neq?: InputMaybe<EventRegistrationStatus>;
  nin?: InputMaybe<Array<EventRegistrationStatus>>;
};

/** A segment of a collection. */
export type EventRegistrationsCollectionSegment = {
  __typename?: 'EventRegistrationsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<EventRegistrationReturnDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type EventReturnDto = {
  __typename?: 'EventReturnDto';
  address: Scalars['String']['output'];
  arbitraryFieldsTemplateId?: Maybe<Scalars['Int']['output']>;
  code: Scalars['String']['output'];
  endDate: Scalars['DateTime']['output'];
  eventInformationEn: Scalars['String']['output'];
  eventInformationHr: Scalars['String']['output'];
  hasParticipationFee: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  lifecycleStatus: EventLifecycleStatus;
  name: Scalars['String']['output'];
  nameEn: Scalars['String']['output'];
  nameHr: Scalars['String']['output'];
  onSiteRegistrationInstructionsEn: Scalars['String']['output'];
  onSiteRegistrationInstructionsHr: Scalars['String']['output'];
  participantCount: Scalars['Int']['output'];
  place: Scalars['String']['output'];
  reservationCount: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
};

export type EventReturnDtoFilterInput = {
  address?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<EventReturnDtoFilterInput>>;
  arbitraryFieldsTemplateId?: InputMaybe<IntOperationFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  eventInformationEn?: InputMaybe<StringOperationFilterInput>;
  eventInformationHr?: InputMaybe<StringOperationFilterInput>;
  hasParticipationFee?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  lifecycleStatus?: InputMaybe<EventLifecycleStatusOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  nameEn?: InputMaybe<StringOperationFilterInput>;
  nameHr?: InputMaybe<StringOperationFilterInput>;
  onSiteRegistrationInstructionsEn?: InputMaybe<StringOperationFilterInput>;
  onSiteRegistrationInstructionsHr?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EventReturnDtoFilterInput>>;
  participantCount?: InputMaybe<IntOperationFilterInput>;
  place?: InputMaybe<StringOperationFilterInput>;
  reservationCount?: InputMaybe<IntOperationFilterInput>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
};

export type EventReturnDtoSortInput = {
  address?: InputMaybe<SortEnumType>;
  arbitraryFieldsTemplateId?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  eventInformationEn?: InputMaybe<SortEnumType>;
  eventInformationHr?: InputMaybe<SortEnumType>;
  hasParticipationFee?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lifecycleStatus?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  nameEn?: InputMaybe<SortEnumType>;
  nameHr?: InputMaybe<SortEnumType>;
  onSiteRegistrationInstructionsEn?: InputMaybe<SortEnumType>;
  onSiteRegistrationInstructionsHr?: InputMaybe<SortEnumType>;
  participantCount?: InputMaybe<SortEnumType>;
  place?: InputMaybe<SortEnumType>;
  reservationCount?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
};

export type EventRoomAllotmentCreateDtoInput = {
  endDate: Scalars['LocalDate']['input'];
  hotelId: Scalars['Int']['input'];
  paymentDeadline?: InputMaybe<Scalars['LocalDate']['input']>;
  roomTypeId: Scalars['Int']['input'];
  startDate: Scalars['LocalDate']['input'];
  totalRooms: Scalars['Int']['input'];
};

export type EventRoomAllotmentReturnDto = {
  __typename?: 'EventRoomAllotmentReturnDto';
  endDate: Scalars['LocalDate']['output'];
  hotelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  paymentDeadline?: Maybe<Scalars['LocalDate']['output']>;
  roomTypeId: Scalars['Int']['output'];
  startDate: Scalars['LocalDate']['output'];
  totalRooms: Scalars['Int']['output'];
};

export type EventRoomAllotmentReturnDtoFilterInput = {
  and?: InputMaybe<Array<EventRoomAllotmentReturnDtoFilterInput>>;
  endDate?: InputMaybe<LocalDateOperationFilterInput>;
  hotelId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<EventRoomAllotmentReturnDtoFilterInput>>;
  paymentDeadline?: InputMaybe<LocalDateOperationFilterInput>;
  roomTypeId?: InputMaybe<IntOperationFilterInput>;
  startDate?: InputMaybe<LocalDateOperationFilterInput>;
  totalRooms?: InputMaybe<IntOperationFilterInput>;
};

export type EventRoomAllotmentReturnDtoSortInput = {
  endDate?: InputMaybe<SortEnumType>;
  hotelId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  paymentDeadline?: InputMaybe<SortEnumType>;
  roomTypeId?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  totalRooms?: InputMaybe<SortEnumType>;
};

export type EventRoomAllotmentUpdateDtoInput = {
  endDate: Scalars['LocalDate']['input'];
  hotelId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  paymentDeadline?: InputMaybe<Scalars['LocalDate']['input']>;
  roomTypeId: Scalars['Int']['input'];
  startDate: Scalars['LocalDate']['input'];
  totalRooms: Scalars['Int']['input'];
};

/** A segment of a collection. */
export type EventRoomAllotmentsCollectionSegment = {
  __typename?: 'EventRoomAllotmentsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<EventRoomAllotmentReturnDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type EventRoomReservationReleaseDtoInput = {
  id: Scalars['Int']['input'];
};

export type EventRoomReservationReleaseResultDto = {
  __typename?: 'EventRoomReservationReleaseResultDto';
  eventId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  participantId: Scalars['Int']['output'];
  registrationId: Scalars['Int']['output'];
  status: EventRoomReservationStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type EventRoomReservationSaveDtoInput = {
  arrivalDate: Scalars['LocalDate']['input'];
  departureDate: Scalars['LocalDate']['input'];
  eventId: Scalars['Int']['input'];
  hotelId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  participantId: Scalars['Int']['input'];
  registrationId: Scalars['Int']['input'];
  roomCount: Scalars['Int']['input'];
  roomTypeId: Scalars['Int']['input'];
};

export type EventRoomReservationSaveResultDto = {
  __typename?: 'EventRoomReservationSaveResultDto';
  arrivalDate: Scalars['LocalDate']['output'];
  departureDate: Scalars['LocalDate']['output'];
  eventId: Scalars['Int']['output'];
  hotelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  participantId: Scalars['Int']['output'];
  pricePerNightSnapshot: Scalars['Decimal']['output'];
  registrationId: Scalars['Int']['output'];
  roomCount: Scalars['Int']['output'];
  roomTypeId: Scalars['Int']['output'];
  status: EventRoomReservationStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export enum EventRoomReservationStatus {
  Cancelled = 'CANCELLED',
  Released = 'RELEASED',
  Reserved = 'RESERVED'
}

export type EventRoomTypeCreateDtoInput = {
  capacity: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  hotelId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  pricePerNight: Scalars['Decimal']['input'];
  vatRate: Scalars['Decimal']['input'];
};

export type EventRoomTypeReturnDto = {
  __typename?: 'EventRoomTypeReturnDto';
  capacity: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  hotelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pricePerNight: Scalars['Decimal']['output'];
  reservationCount: Scalars['Int']['output'];
  vatRate: Scalars['Decimal']['output'];
};

export type EventRoomTypeReturnDtoFilterInput = {
  and?: InputMaybe<Array<EventRoomTypeReturnDtoFilterInput>>;
  capacity?: InputMaybe<IntOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  hotelId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EventRoomTypeReturnDtoFilterInput>>;
  pricePerNight?: InputMaybe<DecimalOperationFilterInput>;
  reservationCount?: InputMaybe<IntOperationFilterInput>;
  vatRate?: InputMaybe<DecimalOperationFilterInput>;
};

export type EventRoomTypeReturnDtoSortInput = {
  capacity?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  hotelId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  pricePerNight?: InputMaybe<SortEnumType>;
  reservationCount?: InputMaybe<SortEnumType>;
  vatRate?: InputMaybe<SortEnumType>;
};

export type EventRoomTypeUpdateDtoInput = {
  capacity: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  hotelId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  pricePerNight: Scalars['Decimal']['input'];
  vatRate: Scalars['Decimal']['input'];
};

/** A segment of a collection. */
export type EventRoomTypesCollectionSegment = {
  __typename?: 'EventRoomTypesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<EventRoomTypeReturnDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type EventTaxSettingCreateDtoInput = {
  accommodationTaxScheme: AccommodationTaxScheme;
  accommodationVatRate: Scalars['Decimal']['input'];
  eventId: Scalars['Int']['input'];
  registrationVatRate: Scalars['Decimal']['input'];
};

export type EventTaxSettingReturnDto = {
  __typename?: 'EventTaxSettingReturnDto';
  accommodationTaxScheme: AccommodationTaxScheme;
  accommodationVatRate: Scalars['Decimal']['output'];
  eventId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  registrationVatRate: Scalars['Decimal']['output'];
};

export type EventTaxSettingReturnDtoFilterInput = {
  accommodationTaxScheme?: InputMaybe<AccommodationTaxSchemeOperationFilterInput>;
  accommodationVatRate?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<EventTaxSettingReturnDtoFilterInput>>;
  eventId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<EventTaxSettingReturnDtoFilterInput>>;
  registrationVatRate?: InputMaybe<DecimalOperationFilterInput>;
};

export type EventTaxSettingReturnDtoSortInput = {
  accommodationTaxScheme?: InputMaybe<SortEnumType>;
  accommodationVatRate?: InputMaybe<SortEnumType>;
  eventId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  registrationVatRate?: InputMaybe<SortEnumType>;
};

export type EventTaxSettingUpdateDtoInput = {
  accommodationTaxScheme: AccommodationTaxScheme;
  accommodationVatRate: Scalars['Decimal']['input'];
  eventId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  registrationVatRate: Scalars['Decimal']['input'];
};

/** A segment of a collection. */
export type EventTaxSettingsCollectionSegment = {
  __typename?: 'EventTaxSettingsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<EventTaxSettingReturnDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type EventsCollectionSegment = {
  __typename?: 'EventsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<EventReturnDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type GeneralSettingsReturnDto = {
  __typename?: 'GeneralSettingsReturnDto';
  accommodationTaxScheme: AccommodationTaxScheme;
  accommodationVatRate: Scalars['Decimal']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  isPersisted: Scalars['Boolean']['output'];
  payeeAddress: Scalars['String']['output'];
  payeeIban: Scalars['String']['output'];
  payeeName: Scalars['String']['output'];
  payeeOib: Scalars['String']['output'];
  registrationVatRate: Scalars['Decimal']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GeneralSettingsUpsertDtoInput = {
  accommodationTaxScheme: AccommodationTaxScheme;
  accommodationVatRate: Scalars['Decimal']['input'];
  payeeAddress: Scalars['String']['input'];
  payeeIban: Scalars['String']['input'];
  payeeName: Scalars['String']['input'];
  payeeOib: Scalars['String']['input'];
  registrationVatRate: Scalars['Decimal']['input'];
};

/** A segment of a collection. */
export type HotelIdentityCatalogCollectionSegment = {
  __typename?: 'HotelIdentityCatalogCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<HotelIdentityCatalogItemDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type HotelIdentityCatalogItemDto = {
  __typename?: 'HotelIdentityCatalogItemDto';
  address: Scalars['String']['output'];
  category: Scalars['String']['output'];
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
};

export type HotelIdentityCatalogItemDtoFilterInput = {
  address?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<HotelIdentityCatalogItemDtoFilterInput>>;
  category?: InputMaybe<StringOperationFilterInput>;
  city?: InputMaybe<StringOperationFilterInput>;
  country?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<HotelIdentityCatalogItemDtoFilterInput>>;
};

export type HotelIdentityCatalogItemDtoSortInput = {
  address?: InputMaybe<SortEnumType>;
  category?: InputMaybe<SortEnumType>;
  city?: InputMaybe<SortEnumType>;
  country?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
};

export type HotelIdentityCreateDtoInput = {
  address: Scalars['String']['input'];
  category: Scalars['String']['input'];
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  name: Scalars['String']['input'];
  notes: Scalars['String']['input'];
};

export type HotelIdentityUpdateDtoInput = {
  address: Scalars['String']['input'];
  category: Scalars['String']['input'];
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  notes: Scalars['String']['input'];
};

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  ngt?: InputMaybe<Scalars['Int']['input']>;
  ngte?: InputMaybe<Scalars['Int']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  nlt?: InputMaybe<Scalars['Int']['input']>;
  nlte?: InputMaybe<Scalars['Int']['input']>;
};

export enum LanguageCode {
  En = 'EN',
  Hr = 'HR'
}

export type LanguageCodeOperationFilterInput = {
  eq?: InputMaybe<LanguageCode>;
  in?: InputMaybe<Array<LanguageCode>>;
  neq?: InputMaybe<LanguageCode>;
  nin?: InputMaybe<Array<LanguageCode>>;
};

export type ListFilterInputTypeOfEventOfferLineSummaryDtoFilterInput = {
  all?: InputMaybe<EventOfferLineSummaryDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<EventOfferLineSummaryDtoFilterInput>;
  some?: InputMaybe<EventOfferLineSummaryDtoFilterInput>;
};

export type ListFilterInputTypeOfEventOptionChoiceDtoFilterInput = {
  all?: InputMaybe<EventOptionChoiceDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<EventOptionChoiceDtoFilterInput>;
  some?: InputMaybe<EventOptionChoiceDtoFilterInput>;
};

export type ListFilterInputTypeOfEventRegistrationFormArbitraryFieldOptionReturnDtoFilterInput = {
  all?: InputMaybe<EventRegistrationFormArbitraryFieldOptionReturnDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<EventRegistrationFormArbitraryFieldOptionReturnDtoFilterInput>;
  some?: InputMaybe<EventRegistrationFormArbitraryFieldOptionReturnDtoFilterInput>;
};

export type ListFilterInputTypeOfEventRegistrationFormArbitraryFieldReturnDtoFilterInput = {
  all?: InputMaybe<EventRegistrationFormArbitraryFieldReturnDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<EventRegistrationFormArbitraryFieldReturnDtoFilterInput>;
  some?: InputMaybe<EventRegistrationFormArbitraryFieldReturnDtoFilterInput>;
};

export type ListIntOperationFilterInput = {
  all?: InputMaybe<IntOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<IntOperationFilterInput>;
  some?: InputMaybe<IntOperationFilterInput>;
};

export type LocalDateOperationFilterInput = {
  eq?: InputMaybe<Scalars['LocalDate']['input']>;
  gt?: InputMaybe<Scalars['LocalDate']['input']>;
  gte?: InputMaybe<Scalars['LocalDate']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['LocalDate']['input']>>>;
  lt?: InputMaybe<Scalars['LocalDate']['input']>;
  lte?: InputMaybe<Scalars['LocalDate']['input']>;
  neq?: InputMaybe<Scalars['LocalDate']['input']>;
  ngt?: InputMaybe<Scalars['LocalDate']['input']>;
  ngte?: InputMaybe<Scalars['LocalDate']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['LocalDate']['input']>>>;
  nlt?: InputMaybe<Scalars['LocalDate']['input']>;
  nlte?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type NullableOfEmailDeliveryStatusOperationFilterInput = {
  eq?: InputMaybe<EmailDeliveryStatus>;
  in?: InputMaybe<Array<InputMaybe<EmailDeliveryStatus>>>;
  neq?: InputMaybe<EmailDeliveryStatus>;
  nin?: InputMaybe<Array<InputMaybe<EmailDeliveryStatus>>>;
};

export type NullableOfEventOfferStatusOperationFilterInput = {
  eq?: InputMaybe<EventOfferStatus>;
  in?: InputMaybe<Array<InputMaybe<EventOfferStatus>>>;
  neq?: InputMaybe<EventOfferStatus>;
  nin?: InputMaybe<Array<InputMaybe<EventOfferStatus>>>;
};

export type NullableOfEventRoomReservationStatusOperationFilterInput = {
  eq?: InputMaybe<EventRoomReservationStatus>;
  in?: InputMaybe<Array<InputMaybe<EventRoomReservationStatus>>>;
  neq?: InputMaybe<EventRoomReservationStatus>;
  nin?: InputMaybe<Array<InputMaybe<EventRoomReservationStatus>>>;
};

export type NullableOfPaymentStatusOperationFilterInput = {
  eq?: InputMaybe<PaymentStatus>;
  in?: InputMaybe<Array<InputMaybe<PaymentStatus>>>;
  neq?: InputMaybe<PaymentStatus>;
  nin?: InputMaybe<Array<InputMaybe<PaymentStatus>>>;
};

export enum OptionConditionType {
  Always = 'ALWAYS',
  CategoryOnly = 'CATEGORY_ONLY',
  DependsOnAnswer = 'DEPENDS_ON_ANSWER'
}

export type OptionConditionTypeOperationFilterInput = {
  eq?: InputMaybe<OptionConditionType>;
  in?: InputMaybe<Array<OptionConditionType>>;
  neq?: InputMaybe<OptionConditionType>;
  nin?: InputMaybe<Array<OptionConditionType>>;
};

export enum OptionPriceEffect {
  AddLineItem = 'ADD_LINE_ITEM',
  NoCharge = 'NO_CHARGE'
}

export type OptionPriceEffectOperationFilterInput = {
  eq?: InputMaybe<OptionPriceEffect>;
  in?: InputMaybe<Array<OptionPriceEffect>>;
  neq?: InputMaybe<OptionPriceEffect>;
  nin?: InputMaybe<Array<OptionPriceEffect>>;
};

export enum OptionQuestionType {
  MultiChoice = 'MULTI_CHOICE',
  SingleChoice = 'SINGLE_CHOICE',
  Text = 'TEXT',
  YesNo = 'YES_NO'
}

export type OptionQuestionTypeOperationFilterInput = {
  eq?: InputMaybe<OptionQuestionType>;
  in?: InputMaybe<Array<OptionQuestionType>>;
  neq?: InputMaybe<OptionQuestionType>;
  nin?: InputMaybe<Array<OptionQuestionType>>;
};

export type OrganizationMemberCreateDtoInput = {
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationMemberMaintenanceResultDto = {
  __typename?: 'OrganizationMemberMaintenanceResultDto';
  email: Scalars['String']['output'];
  emailConfirmed: Scalars['Boolean']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  hasPassword: Scalars['Boolean']['output'];
  isActive: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isPendingOnboarding: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  onboardingEmailFailureReason: Scalars['String']['output'];
  onboardingEmailLastFailedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  onboardingEmailLastSentAtUtc?: Maybe<Scalars['DateTime']['output']>;
  onboardingEmailQueuedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  onboardingEmailSentCount: Scalars['Int']['output'];
  onboardingEmailStatus?: Maybe<EmailDeliveryStatus>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  role: UserRole;
  userId: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export type OrganizationMemberOnboardingCompleteDtoInput = {
  emailConfirmationToken: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  passwordResetToken: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type OrganizationMemberOnboardingResendDtoInput = {
  userId: Scalars['String']['input'];
};

export type OrganizationMemberOnboardingResultDto = {
  __typename?: 'OrganizationMemberOnboardingResultDto';
  email: Scalars['String']['output'];
  emailConfirmed: Scalars['Boolean']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  hasPassword: Scalars['Boolean']['output'];
  isPendingOnboarding: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  onboardingEmailFailureReason: Scalars['String']['output'];
  onboardingEmailLastFailedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  onboardingEmailLastSentAtUtc?: Maybe<Scalars['DateTime']['output']>;
  onboardingEmailQueuedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  onboardingEmailSent: Scalars['Boolean']['output'];
  onboardingEmailSentCount: Scalars['Int']['output'];
  onboardingEmailStatus?: Maybe<EmailDeliveryStatus>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  role: UserRole;
  userId: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export type OrganizationMemberPendingInviteRemoveDtoInput = {
  userId: Scalars['String']['input'];
};

export type OrganizationMemberUpdateDtoInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  role: UserRole;
  userId: Scalars['String']['input'];
};

export type OrganizerPasswordResetCompleteDtoInput = {
  newPassword: Scalars['String']['input'];
  passwordResetToken: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type PayerCreateDtoInput = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  contactPerson: Scalars['String']['input'];
  country: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  taxId: Scalars['String']['input'];
  type: PayerType;
};

export type PayerDeleteDtoInput = {
  id: Scalars['Int']['input'];
};

/** A segment of a collection. */
export type PayerOfferHistoryCollectionSegment = {
  __typename?: 'PayerOfferHistoryCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<EventOfferHistoryDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type PayerPaymentAllocationHistoryDto = {
  __typename?: 'PayerPaymentAllocationHistoryDto';
  allocatedAmount: Scalars['Decimal']['output'];
  currency: Scalars['String']['output'];
  description: Scalars['String']['output'];
  eventCode: Scalars['String']['output'];
  eventId: Scalars['Int']['output'];
  eventName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isSponsorPayment: Scalars['Boolean']['output'];
  manuallyReconciledAt?: Maybe<Scalars['DateTime']['output']>;
  offerId?: Maybe<Scalars['Int']['output']>;
  offerNumber: Scalars['String']['output'];
  paidAt: Scalars['DateTime']['output'];
  participantFullName: Scalars['String']['output'];
  participantId?: Maybe<Scalars['Int']['output']>;
  payerEmail: Scalars['String']['output'];
  payerName: Scalars['String']['output'];
  paymentAmountGross: Scalars['Decimal']['output'];
  paymentAmountNet: Scalars['Decimal']['output'];
  paymentId: Scalars['Int']['output'];
  paymentMethod: PaymentMethod;
  paymentRefundedAmountGross: Scalars['Decimal']['output'];
  paymentStatus: PaymentStatus;
  provider: Scalars['String']['output'];
  providerReference: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  registrationId?: Maybe<Scalars['Int']['output']>;
};

export type PayerPaymentAllocationHistoryDtoFilterInput = {
  allocatedAmount?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<PayerPaymentAllocationHistoryDtoFilterInput>>;
  currency?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  eventCode?: InputMaybe<StringOperationFilterInput>;
  eventId?: InputMaybe<IntOperationFilterInput>;
  eventName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isSponsorPayment?: InputMaybe<BooleanOperationFilterInput>;
  manuallyReconciledAt?: InputMaybe<DateTimeOperationFilterInput>;
  offerId?: InputMaybe<IntOperationFilterInput>;
  offerNumber?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PayerPaymentAllocationHistoryDtoFilterInput>>;
  paidAt?: InputMaybe<DateTimeOperationFilterInput>;
  participantFullName?: InputMaybe<StringOperationFilterInput>;
  participantId?: InputMaybe<IntOperationFilterInput>;
  payerEmail?: InputMaybe<StringOperationFilterInput>;
  payerName?: InputMaybe<StringOperationFilterInput>;
  paymentAmountGross?: InputMaybe<DecimalOperationFilterInput>;
  paymentAmountNet?: InputMaybe<DecimalOperationFilterInput>;
  paymentId?: InputMaybe<IntOperationFilterInput>;
  paymentMethod?: InputMaybe<PaymentMethodOperationFilterInput>;
  paymentRefundedAmountGross?: InputMaybe<DecimalOperationFilterInput>;
  paymentStatus?: InputMaybe<PaymentStatusOperationFilterInput>;
  provider?: InputMaybe<StringOperationFilterInput>;
  providerReference?: InputMaybe<StringOperationFilterInput>;
  reference?: InputMaybe<StringOperationFilterInput>;
  registrationId?: InputMaybe<IntOperationFilterInput>;
};

export type PayerPaymentAllocationHistoryDtoSortInput = {
  allocatedAmount?: InputMaybe<SortEnumType>;
  currency?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  eventCode?: InputMaybe<SortEnumType>;
  eventId?: InputMaybe<SortEnumType>;
  eventName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isSponsorPayment?: InputMaybe<SortEnumType>;
  manuallyReconciledAt?: InputMaybe<SortEnumType>;
  offerId?: InputMaybe<SortEnumType>;
  offerNumber?: InputMaybe<SortEnumType>;
  paidAt?: InputMaybe<SortEnumType>;
  participantFullName?: InputMaybe<SortEnumType>;
  participantId?: InputMaybe<SortEnumType>;
  payerEmail?: InputMaybe<SortEnumType>;
  payerName?: InputMaybe<SortEnumType>;
  paymentAmountGross?: InputMaybe<SortEnumType>;
  paymentAmountNet?: InputMaybe<SortEnumType>;
  paymentId?: InputMaybe<SortEnumType>;
  paymentMethod?: InputMaybe<SortEnumType>;
  paymentRefundedAmountGross?: InputMaybe<SortEnumType>;
  paymentStatus?: InputMaybe<SortEnumType>;
  provider?: InputMaybe<SortEnumType>;
  providerReference?: InputMaybe<SortEnumType>;
  reference?: InputMaybe<SortEnumType>;
  registrationId?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type PayerPaymentAllocationsCollectionSegment = {
  __typename?: 'PayerPaymentAllocationsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PayerPaymentAllocationHistoryDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type PayerReturnDto = {
  __typename?: 'PayerReturnDto';
  address: Scalars['String']['output'];
  city: Scalars['String']['output'];
  contactPerson: Scalars['String']['output'];
  country: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  taxId: Scalars['String']['output'];
  type: PayerType;
};

export type PayerReturnDtoFilterInput = {
  address?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<PayerReturnDtoFilterInput>>;
  city?: InputMaybe<StringOperationFilterInput>;
  contactPerson?: InputMaybe<StringOperationFilterInput>;
  country?: InputMaybe<StringOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PayerReturnDtoFilterInput>>;
  phone?: InputMaybe<StringOperationFilterInput>;
  taxId?: InputMaybe<StringOperationFilterInput>;
  type?: InputMaybe<PayerTypeOperationFilterInput>;
};

export type PayerReturnDtoSortInput = {
  address?: InputMaybe<SortEnumType>;
  city?: InputMaybe<SortEnumType>;
  contactPerson?: InputMaybe<SortEnumType>;
  country?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  phone?: InputMaybe<SortEnumType>;
  taxId?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

export enum PayerType {
  Company = 'COMPANY',
  Individual = 'INDIVIDUAL',
  SponsoredParticipation = 'SPONSORED_PARTICIPATION'
}

export type PayerTypeOperationFilterInput = {
  eq?: InputMaybe<PayerType>;
  in?: InputMaybe<Array<PayerType>>;
  neq?: InputMaybe<PayerType>;
  nin?: InputMaybe<Array<PayerType>>;
};

export type PayerUpdateDtoInput = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  contactPerson: Scalars['String']['input'];
  country: Scalars['String']['input'];
  email: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  taxId: Scalars['String']['input'];
  type: PayerType;
};

/** A segment of a collection. */
export type PayersCollectionSegment = {
  __typename?: 'PayersCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PayerReturnDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type PaymentManualReconcileDtoInput = {
  id: Scalars['Int']['input'];
  note: Scalars['String']['input'];
};

export enum PaymentMethod {
  BankTransfer = 'BANK_TRANSFER',
  Card = 'CARD',
  Cash = 'CASH',
  Pos = 'POS',
  Sponsor = 'SPONSOR'
}

export enum PaymentMethodCategory {
  Accommodation = 'ACCOMMODATION',
  Participation = 'PARTICIPATION'
}

export type PaymentMethodCategoryOperationFilterInput = {
  eq?: InputMaybe<PaymentMethodCategory>;
  in?: InputMaybe<Array<PaymentMethodCategory>>;
  neq?: InputMaybe<PaymentMethodCategory>;
  nin?: InputMaybe<Array<PaymentMethodCategory>>;
};

export type PaymentMethodOperationFilterInput = {
  eq?: InputMaybe<PaymentMethod>;
  in?: InputMaybe<Array<PaymentMethod>>;
  neq?: InputMaybe<PaymentMethod>;
  nin?: InputMaybe<Array<PaymentMethod>>;
};

export type PaymentReturnDto = {
  __typename?: 'PaymentReturnDto';
  amountGross: Scalars['Decimal']['output'];
  amountNet: Scalars['Decimal']['output'];
  currency: Scalars['String']['output'];
  eventId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isSponsorPayment: Scalars['Boolean']['output'];
  manualReconciliationNote: Scalars['String']['output'];
  manuallyReconciledAt?: Maybe<Scalars['DateTime']['output']>;
  method: PaymentMethod;
  notes: Scalars['String']['output'];
  offerId?: Maybe<Scalars['Int']['output']>;
  paidAt: Scalars['DateTime']['output'];
  payerEmail: Scalars['String']['output'];
  payerName: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  providerReference: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  refundedAmountGross: Scalars['Decimal']['output'];
  status: PaymentStatus;
};

export type PaymentReturnDtoFilterInput = {
  amountGross?: InputMaybe<DecimalOperationFilterInput>;
  amountNet?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<PaymentReturnDtoFilterInput>>;
  currency?: InputMaybe<StringOperationFilterInput>;
  eventId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isSponsorPayment?: InputMaybe<BooleanOperationFilterInput>;
  manualReconciliationNote?: InputMaybe<StringOperationFilterInput>;
  manuallyReconciledAt?: InputMaybe<DateTimeOperationFilterInput>;
  method?: InputMaybe<PaymentMethodOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  offerId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<PaymentReturnDtoFilterInput>>;
  paidAt?: InputMaybe<DateTimeOperationFilterInput>;
  payerEmail?: InputMaybe<StringOperationFilterInput>;
  payerName?: InputMaybe<StringOperationFilterInput>;
  provider?: InputMaybe<StringOperationFilterInput>;
  providerReference?: InputMaybe<StringOperationFilterInput>;
  reference?: InputMaybe<StringOperationFilterInput>;
  refundedAmountGross?: InputMaybe<DecimalOperationFilterInput>;
  status?: InputMaybe<PaymentStatusOperationFilterInput>;
};

export type PaymentReturnDtoSortInput = {
  amountGross?: InputMaybe<SortEnumType>;
  amountNet?: InputMaybe<SortEnumType>;
  currency?: InputMaybe<SortEnumType>;
  eventId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isSponsorPayment?: InputMaybe<SortEnumType>;
  manualReconciliationNote?: InputMaybe<SortEnumType>;
  manuallyReconciledAt?: InputMaybe<SortEnumType>;
  method?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  offerId?: InputMaybe<SortEnumType>;
  paidAt?: InputMaybe<SortEnumType>;
  payerEmail?: InputMaybe<SortEnumType>;
  payerName?: InputMaybe<SortEnumType>;
  provider?: InputMaybe<SortEnumType>;
  providerReference?: InputMaybe<SortEnumType>;
  reference?: InputMaybe<SortEnumType>;
  refundedAmountGross?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
};

export enum PaymentStatus {
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  ManuallyReconciled = 'MANUALLY_RECONCILED',
  Paid = 'PAID',
  Pending = 'PENDING',
  Refunded = 'REFUNDED',
  Unpaid = 'UNPAID'
}

export type PaymentStatusOperationFilterInput = {
  eq?: InputMaybe<PaymentStatus>;
  in?: InputMaybe<Array<PaymentStatus>>;
  neq?: InputMaybe<PaymentStatus>;
  nin?: InputMaybe<Array<PaymentStatus>>;
};

/** A segment of a collection. */
export type PaymentsCollectionSegment = {
  __typename?: 'PaymentsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PaymentReturnDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type RecordOfferPaymentDtoInput = {
  amount: Scalars['Decimal']['input'];
  method: PaymentMethod;
  note: Scalars['String']['input'];
  offerId: Scalars['Int']['input'];
  paidAt: Scalars['DateTime']['input'];
  payerId: Scalars['Int']['input'];
  reference: Scalars['String']['input'];
};

export type SaveAccommodationOptionDtoInput = {
  allotmentId?: InputMaybe<Scalars['Int']['input']>;
  capacity: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  endDate: Scalars['LocalDate']['input'];
  eventId: Scalars['Int']['input'];
  hotelId?: InputMaybe<Scalars['Int']['input']>;
  hotelIdentityId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  paymentDeadline?: InputMaybe<Scalars['LocalDate']['input']>;
  pricePerNight: Scalars['Decimal']['input'];
  roomTypeId?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['LocalDate']['input'];
  totalRooms: Scalars['Int']['input'];
};

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ncontains?: InputMaybe<Scalars['String']['input']>;
  nendsWith?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nstartsWith?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type UserProfileDto = {
  __typename?: 'UserProfileDto';
  email?: Maybe<Scalars['String']['output']>;
  emailSignature: Scalars['String']['output'];
  id: Scalars['String']['output'];
  userName?: Maybe<Scalars['String']['output']>;
};

export type UserProfileUpdateDtoInput = {
  emailSignature: Scalars['String']['input'];
};

export enum UserRole {
  Administrator = 'ADMINISTRATOR',
  User = 'USER'
}

export type UserRoleOperationFilterInput = {
  eq?: InputMaybe<UserRole>;
  in?: InputMaybe<Array<UserRole>>;
  neq?: InputMaybe<UserRole>;
  nin?: InputMaybe<Array<UserRole>>;
};

/** A segment of a collection. */
export type UsersCollectionSegment = {
  __typename?: 'UsersCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ApplicationUser>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type CompleteOrganizationMemberOnboardingMutationVariables = Exact<{
  input: OrganizationMemberOnboardingCompleteDtoInput;
}>;


export type CompleteOrganizationMemberOnboardingMutation = { __typename?: 'BaseMutation', completeOrganizationMemberOnboarding: { __typename?: 'OrganizationMemberOnboardingResultDto', userId: string, emailConfirmed: boolean, hasPassword: boolean, isPendingOnboarding: boolean } };

export type CompleteOrganizerPasswordResetMutationVariables = Exact<{
  input: OrganizerPasswordResetCompleteDtoInput;
}>;


export type CompleteOrganizerPasswordResetMutation = { __typename?: 'BaseMutation', completeOrganizerPasswordReset: boolean };

export type CurrentAuthenticatedUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentAuthenticatedUserQuery = { __typename?: 'BaseQuery', user: Array<{ __typename?: 'ApplicationUser', id: string }> };

export type CurrentUserProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserProfileQuery = { __typename?: 'BaseQuery', currentUserProfile: { __typename?: 'UserProfileDto', id: string, userName?: string | null, email?: string | null, emailSignature: string } };

export type LogMeInMutationVariables = Exact<{
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
}>;


export type LogMeInMutation = { __typename?: 'BaseMutation', login: { __typename?: 'AccountLoginResponseDto', token: string } };

export type RefreshTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshTokenMutation = { __typename?: 'BaseMutation', refreshToken: { __typename?: 'AccountLoginResponseDto', token: string } };

export type RequestOrganizerPasswordResetMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type RequestOrganizerPasswordResetMutation = { __typename?: 'BaseMutation', requestOrganizerPasswordReset: boolean };

export type ResendConfirmationEmailMutationVariables = Exact<{
  model: AccountResendConfirmationEmailDtoInput;
}>;


export type ResendConfirmationEmailMutation = { __typename?: 'BaseMutation', resendConfirmationEmail: boolean };

export type UpdateCurrentUserProfileMutationVariables = Exact<{
  input: UserProfileUpdateDtoInput;
}>;


export type UpdateCurrentUserProfileMutation = { __typename?: 'BaseMutation', updateCurrentUserProfile: { __typename?: 'UserProfileDto', id: string, userName?: string | null, email?: string | null, emailSignature: string } };

export type EventActivityLogsQueryVariables = Exact<{
  eventId: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<EventActivityLogDtoSortInput> | EventActivityLogDtoSortInput>;
}>;


export type EventActivityLogsQuery = { __typename?: 'BaseQuery', eventActivityLogs?: { __typename?: 'EventActivityLogsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'EventActivityLogDto', id: number, eventId: number, occurredAt: any, userId?: string | null, userName: string, action: string, actionType: EventActivityAction, entityName: string, entityId: string, details: string }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type CreateEventEmailTemplateMutationVariables = Exact<{
  input: EventEmailTemplateCreateDtoInput;
}>;


export type CreateEventEmailTemplateMutation = { __typename?: 'BaseMutation', createEventEmailTemplate: Array<{ __typename?: 'EventEmailTemplateReturnDto', id: number, eventId: number, language: LanguageCode, subject: string, body: string }> };

export type CreateEventFeePriceMutationVariables = Exact<{
  input: EventFeePriceCreateDtoInput;
}>;


export type CreateEventFeePriceMutation = { __typename?: 'BaseMutation', createEventFeePrice: Array<{ __typename?: 'EventFeePriceReturnDto', id: number, feeTypeId: number, pricePeriodId: number, amount: any }> };

export type CreateEventFeeTypeMutationVariables = Exact<{
  input: EventFeeTypeCreateDtoInput;
}>;


export type CreateEventFeeTypeMutation = { __typename?: 'BaseMutation', createEventFeeType: Array<{ __typename?: 'EventFeeTypeReturnDto', id: number, eventId: number, labelHr: string, labelEn: string, isFree: boolean, isSponsored: boolean, isPublicRegistrationHidden: boolean, requiresParticipantTypeProof: boolean }> };

export type CreateEventHotelMutationVariables = Exact<{
  input: EventHotelCreateDtoInput;
}>;


export type CreateEventHotelMutation = { __typename?: 'BaseMutation', createEventHotel: Array<{ __typename?: 'EventHotelReturnDto', id: number, eventId: number, name: string, category: string, address: string, city: string, country: string, notes: string }> };

export type CreateEventOptionMutationVariables = Exact<{
  input: EventOptionCreateDtoInput;
}>;


export type CreateEventOptionMutation = { __typename?: 'BaseMutation', createEventOption: Array<{ __typename?: 'EventOptionReturnDto', id: number, eventId: number, labelHr: string, labelEn: string, vatRate: any, questionType: OptionQuestionType, price: any, publicRegistrationEndDate?: any | null, tracksUsageOrAttendance: boolean, allowedFeeTypeIds: Array<number>, visibilityDependsOnEventOptionId?: number | null, visibilityDependsOnExpectedAnswer?: boolean | null, isActive: boolean }> };

export type CreateEventPaymentMethodForConfigMutationVariables = Exact<{
  input: EventPaymentMethodCreateDtoInput;
}>;


export type CreateEventPaymentMethodForConfigMutation = { __typename?: 'BaseMutation', createEventPaymentMethod: Array<{ __typename?: 'EventPaymentMethodReturnDto', id: number, eventId: number, category: PaymentMethodCategory, bankTransferAllowed: boolean, cardAllowed: boolean, posAllowed: boolean }> };

export type CreateEventPricePeriodMutationVariables = Exact<{
  input: EventPricePeriodCreateDtoInput;
}>;


export type CreateEventPricePeriodMutation = { __typename?: 'BaseMutation', createEventPricePeriod: Array<{ __typename?: 'EventPricePeriodReturnDto', id: number, eventId: number, name: string, code: string, startDate: any, endDate: any }> };

export type CreateEventTaxSettingMutationVariables = Exact<{
  input: EventTaxSettingCreateDtoInput;
}>;


export type CreateEventTaxSettingMutation = { __typename?: 'BaseMutation', createEventTaxSetting: Array<{ __typename?: 'EventTaxSettingReturnDto', id: number, eventId: number, registrationVatRate: any, accommodationVatRate: any, accommodationTaxScheme: AccommodationTaxScheme }> };

export type DeleteAccommodationOptionsMutationVariables = Exact<{
  input: DeleteAccommodationOptionsDtoInput;
}>;


export type DeleteAccommodationOptionsMutation = { __typename?: 'BaseMutation', deleteAccommodationOptions: boolean };

export type EventAccessGrantsForConfigQueryVariables = Exact<{
  eventId: Scalars['Int']['input'];
}>;


export type EventAccessGrantsForConfigQuery = { __typename?: 'BaseQuery', eventAccessGrants?: { __typename?: 'EventAccessGrantsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'EventAccessGrantReturnDto', id: number, eventId: number, userId: string, userEmail: string, userName: string, grantedAtUtc: any }> | null } | null };

export type EventAccessUsersForConfigQueryVariables = Exact<{
  eventId: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type EventAccessUsersForConfigQuery = { __typename?: 'BaseQuery', eventAccessUsers?: { __typename?: 'EventAccessUsersCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'EventAccessUserReturnDto', id: string, email: string, userName: string, firstName?: string | null, lastName?: string | null, defaultRole: UserRole }> | null } | null };

export type EventEmailTemplatesListQueryVariables = Exact<{
  where?: InputMaybe<EventEmailTemplateReturnDtoFilterInput>;
  order?: InputMaybe<Array<EventEmailTemplateReturnDtoSortInput> | EventEmailTemplateReturnDtoSortInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EventEmailTemplatesListQuery = { __typename?: 'BaseQuery', eventEmailTemplates?: { __typename?: 'EventEmailTemplatesCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'EventEmailTemplateReturnDto', id: number, eventId: number, language: LanguageCode, subject: string, body: string }> | null } | null };

export type EventFeePricesListQueryVariables = Exact<{
  where?: InputMaybe<EventFeePriceReturnDtoFilterInput>;
  order?: InputMaybe<Array<EventFeePriceReturnDtoSortInput> | EventFeePriceReturnDtoSortInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EventFeePricesListQuery = { __typename?: 'BaseQuery', eventFeePrices?: { __typename?: 'EventFeePricesCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'EventFeePriceReturnDto', id: number, feeTypeId: number, pricePeriodId: number, amount: any }> | null } | null };

export type EventFeeTypesListQueryVariables = Exact<{
  where?: InputMaybe<EventFeeTypeReturnDtoFilterInput>;
  order?: InputMaybe<Array<EventFeeTypeReturnDtoSortInput> | EventFeeTypeReturnDtoSortInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EventFeeTypesListQuery = { __typename?: 'BaseQuery', eventFeeTypes?: { __typename?: 'EventFeeTypesCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'EventFeeTypeReturnDto', id: number, eventId: number, labelHr: string, labelEn: string, isFree: boolean, isSponsored: boolean, isPublicRegistrationHidden: boolean, requiresParticipantTypeProof: boolean }> | null } | null };

export type EventHotelsListQueryVariables = Exact<{
  where?: InputMaybe<EventHotelReturnDtoFilterInput>;
  order?: InputMaybe<Array<EventHotelReturnDtoSortInput> | EventHotelReturnDtoSortInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EventHotelsListQuery = { __typename?: 'BaseQuery', eventHotels?: { __typename?: 'EventHotelsCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'EventHotelReturnDto', id: number, eventId: number, name: string, category: string, address: string, city: string, country: string, notes: string }> | null } | null };

export type EventOptionsForConfigQueryVariables = Exact<{
  where?: InputMaybe<EventOptionReturnDtoFilterInput>;
  order?: InputMaybe<Array<EventOptionReturnDtoSortInput> | EventOptionReturnDtoSortInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EventOptionsForConfigQuery = { __typename?: 'BaseQuery', eventOptions?: { __typename?: 'EventOptionsCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'EventOptionReturnDto', id: number, eventId: number, labelHr: string, labelEn: string, descriptionHr: string, descriptionEn: string, vatRate: any, conditionType: OptionConditionType, categoryCodes: string, dependsOnCode: string, dependsOnValue: string, questionType: OptionQuestionType, priceEffect: OptionPriceEffect, price: any, publicRegistrationEndDate?: any | null, tracksUsageOrAttendance: boolean, allowedFeeTypeIds: Array<number>, visibilityDependsOnEventOptionId?: number | null, visibilityDependsOnExpectedAnswer?: boolean | null, isActive: boolean, choices: Array<{ __typename?: 'EventOptionChoiceDto', id: number, value: string, labelHr: string, labelEn: string, order: number, isActive: boolean }> }> | null } | null };

export type EventOptionsListQueryVariables = Exact<{
  where?: InputMaybe<EventOptionReturnDtoFilterInput>;
  order?: InputMaybe<Array<EventOptionReturnDtoSortInput> | EventOptionReturnDtoSortInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EventOptionsListQuery = { __typename?: 'BaseQuery', eventOptions?: { __typename?: 'EventOptionsCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'EventOptionReturnDto', id: number, eventId: number, labelHr: string, labelEn: string, descriptionHr: string, descriptionEn: string, vatRate: any, conditionType: OptionConditionType, categoryCodes: string, dependsOnCode: string, dependsOnValue: string, questionType: OptionQuestionType, priceEffect: OptionPriceEffect, price: any, publicRegistrationEndDate?: any | null, tracksUsageOrAttendance: boolean, allowedFeeTypeIds: Array<number>, visibilityDependsOnEventOptionId?: number | null, visibilityDependsOnExpectedAnswer?: boolean | null, isActive: boolean }> | null } | null };

export type EventPaymentMethodsQueryVariables = Exact<{
  eventId: Scalars['Int']['input'];
}>;


export type EventPaymentMethodsQuery = { __typename?: 'BaseQuery', eventPaymentMethods?: { __typename?: 'EventPaymentMethodsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'EventPaymentMethodReturnDto', id: number, eventId: number, category: PaymentMethodCategory, bankTransferAllowed: boolean, cardAllowed: boolean, posAllowed: boolean }> | null } | null };

export type EventPricePeriodsListQueryVariables = Exact<{
  where?: InputMaybe<EventPricePeriodReturnDtoFilterInput>;
  order?: InputMaybe<Array<EventPricePeriodReturnDtoSortInput> | EventPricePeriodReturnDtoSortInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EventPricePeriodsListQuery = { __typename?: 'BaseQuery', eventPricePeriods?: { __typename?: 'EventPricePeriodsCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'EventPricePeriodReturnDto', id: number, eventId: number, name: string, code: string, startDate: any, endDate: any }> | null } | null };

export type EventRoomAllotmentsListQueryVariables = Exact<{
  where?: InputMaybe<EventRoomAllotmentReturnDtoFilterInput>;
  order?: InputMaybe<Array<EventRoomAllotmentReturnDtoSortInput> | EventRoomAllotmentReturnDtoSortInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EventRoomAllotmentsListQuery = { __typename?: 'BaseQuery', eventRoomAllotments?: { __typename?: 'EventRoomAllotmentsCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'EventRoomAllotmentReturnDto', id: number, hotelId: number, roomTypeId: number, startDate: any, endDate: any, totalRooms: number, paymentDeadline?: any | null }> | null } | null };

export type EventRoomTypesListQueryVariables = Exact<{
  where?: InputMaybe<EventRoomTypeReturnDtoFilterInput>;
  order?: InputMaybe<Array<EventRoomTypeReturnDtoSortInput> | EventRoomTypeReturnDtoSortInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EventRoomTypesListQuery = { __typename?: 'BaseQuery', eventRoomTypes?: { __typename?: 'EventRoomTypesCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'EventRoomTypeReturnDto', id: number, hotelId: number, name: string, capacity: number, pricePerNight: any, vatRate: any, description: string, reservationCount: number }> | null } | null };

export type EventTaxSettingsListQueryVariables = Exact<{
  where?: InputMaybe<EventTaxSettingReturnDtoFilterInput>;
  order?: InputMaybe<Array<EventTaxSettingReturnDtoSortInput> | EventTaxSettingReturnDtoSortInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EventTaxSettingsListQuery = { __typename?: 'BaseQuery', eventTaxSettings?: { __typename?: 'EventTaxSettingsCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'EventTaxSettingReturnDto', id: number, eventId: number, registrationVatRate: any, accommodationVatRate: any, accommodationTaxScheme: AccommodationTaxScheme }> | null } | null };

export type GrantEventAccessForConfigMutationVariables = Exact<{
  input: EventAccessGrantDtoInput;
}>;


export type GrantEventAccessForConfigMutation = { __typename?: 'BaseMutation', grantEventAccess: boolean };

export type RevokeEventAccessForConfigMutationVariables = Exact<{
  input: EventAccessGrantDtoInput;
}>;


export type RevokeEventAccessForConfigMutation = { __typename?: 'BaseMutation', revokeEventAccess: boolean };

export type SaveAccommodationOptionMutationVariables = Exact<{
  input: SaveAccommodationOptionDtoInput;
}>;


export type SaveAccommodationOptionMutation = { __typename?: 'BaseMutation', saveAccommodationOption: boolean };

export type UpdateEventEmailTemplateMutationVariables = Exact<{
  input: EventEmailTemplateUpdateDtoInput;
}>;


export type UpdateEventEmailTemplateMutation = { __typename?: 'BaseMutation', updateEventEmailTemplate: Array<{ __typename?: 'EventEmailTemplateReturnDto', id: number, eventId: number, language: LanguageCode, subject: string, body: string }> };

export type UpdateEventFeePriceMutationVariables = Exact<{
  input: EventFeePriceUpdateDtoInput;
}>;


export type UpdateEventFeePriceMutation = { __typename?: 'BaseMutation', updateEventFeePrice: Array<{ __typename?: 'EventFeePriceReturnDto', id: number, feeTypeId: number, pricePeriodId: number, amount: any }> };

export type UpdateEventFeeTypeMutationVariables = Exact<{
  input: EventFeeTypeUpdateDtoInput;
}>;


export type UpdateEventFeeTypeMutation = { __typename?: 'BaseMutation', updateEventFeeType: Array<{ __typename?: 'EventFeeTypeReturnDto', id: number, eventId: number, labelHr: string, labelEn: string, isFree: boolean, isSponsored: boolean, isPublicRegistrationHidden: boolean, requiresParticipantTypeProof: boolean }> };

export type UpdateEventOptionMutationVariables = Exact<{
  input: EventOptionUpdateDtoInput;
}>;


export type UpdateEventOptionMutation = { __typename?: 'BaseMutation', updateEventOption: Array<{ __typename?: 'EventOptionReturnDto', id: number, eventId: number, labelHr: string, labelEn: string, vatRate: any, questionType: OptionQuestionType, price: any, publicRegistrationEndDate?: any | null, tracksUsageOrAttendance: boolean, allowedFeeTypeIds: Array<number>, visibilityDependsOnEventOptionId?: number | null, visibilityDependsOnExpectedAnswer?: boolean | null, isActive: boolean }> };

export type UpdateEventPaymentMethodForConfigMutationVariables = Exact<{
  input: EventPaymentMethodUpdateDtoInput;
}>;


export type UpdateEventPaymentMethodForConfigMutation = { __typename?: 'BaseMutation', updateEventPaymentMethod: Array<{ __typename?: 'EventPaymentMethodReturnDto', id: number, eventId: number, category: PaymentMethodCategory, bankTransferAllowed: boolean, cardAllowed: boolean, posAllowed: boolean }> };

export type UpdateEventPricePeriodMutationVariables = Exact<{
  input: EventPricePeriodUpdateDtoInput;
}>;


export type UpdateEventPricePeriodMutation = { __typename?: 'BaseMutation', updateEventPricePeriod: Array<{ __typename?: 'EventPricePeriodReturnDto', id: number, eventId: number, name: string, code: string, startDate: any, endDate: any }> };

export type UpdateEventTaxSettingMutationVariables = Exact<{
  input: EventTaxSettingUpdateDtoInput;
}>;


export type UpdateEventTaxSettingMutation = { __typename?: 'BaseMutation', updateEventTaxSetting: Array<{ __typename?: 'EventTaxSettingReturnDto', id: number, eventId: number, registrationVatRate: any, accommodationVatRate: any, accommodationTaxScheme: AccommodationTaxScheme }> };

export type ActivateEventRegistrationFormTemplateMutationVariables = Exact<{
  input: EventRegistrationFormArbitraryFieldsTemplateDeleteDtoInput;
}>;


export type ActivateEventRegistrationFormTemplateMutation = { __typename?: 'BaseMutation', activateEventRegistrationFormArbitraryFieldsTemplate?: { __typename?: 'EventRegistrationFormArbitraryFieldsTemplateReturnDto', id: number, eventId: number, status: EventRegistrationFormTemplateStatus, version: number } | null };

export type CreateBasicEventRegistrationFormTemplateMutationVariables = Exact<{
  input: EventRegistrationFormArbitraryFieldsTemplateCreateDtoInput;
}>;


export type CreateBasicEventRegistrationFormTemplateMutation = { __typename?: 'BaseMutation', createEventRegistrationFormArbitraryFieldsTemplate: Array<{ __typename?: 'EventRegistrationFormArbitraryFieldsTemplateReturnDto', id: number, eventId: number, status: EventRegistrationFormTemplateStatus, version: number }> };

export type EventRegistrationFormTemplatesForSetupQueryVariables = Exact<{
  eventId: Scalars['Int']['input'];
}>;


export type EventRegistrationFormTemplatesForSetupQuery = { __typename?: 'BaseQuery', eventRegistrationFormArbitraryFieldsTemplates?: { __typename?: 'EventRegistrationFormArbitraryFieldsTemplatesCollectionSegment', items?: Array<{ __typename?: 'EventRegistrationFormArbitraryFieldsTemplateReturnDto', id: number, eventId: number, status: EventRegistrationFormTemplateStatus, version: number }> | null } | null };

export type ArchivedEventsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ArchivedEventReturnDtoSortInput> | ArchivedEventReturnDtoSortInput>;
}>;


export type ArchivedEventsQuery = { __typename?: 'BaseQuery', archivedEvents?: { __typename?: 'ArchivedEventsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'ArchivedEventReturnDto', id: number, code: string, name: string, nameHr: string, nameEn: string, place: string, startDate: any, endDate: any, lifecycleStatus: EventLifecycleStatus, archivedAt?: any | null, participantCount: number, reservationCount: number }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type EventsPageEventsQueryVariables = Exact<{
  where?: InputMaybe<EventReturnDtoFilterInput>;
  order?: InputMaybe<Array<EventReturnDtoSortInput> | EventReturnDtoSortInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EventsPageEventsQuery = { __typename?: 'BaseQuery', events?: { __typename?: 'EventsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'EventReturnDto', id: number, code: string, name: string, nameHr: string, nameEn: string, place: string, startDate: any, endDate: any, lifecycleStatus: EventLifecycleStatus, arbitraryFieldsTemplateId?: number | null, participantCount: number, reservationCount: number }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type ActivateEventActionMutationVariables = Exact<{
  input: EventDeleteDtoInput;
}>;


export type ActivateEventActionMutation = { __typename?: 'BaseMutation', activateEvent: Array<{ __typename?: 'EventReturnDto', id: number }> };

export type ArchiveEventActionMutationVariables = Exact<{
  input: EventDeleteDtoInput;
}>;


export type ArchiveEventActionMutation = { __typename?: 'BaseMutation', deleteEvent: boolean };

export type CompleteEventActionMutationVariables = Exact<{
  input: EventDeleteDtoInput;
}>;


export type CompleteEventActionMutation = { __typename?: 'BaseMutation', completeEvent: Array<{ __typename?: 'EventReturnDto', id: number }> };

export type CreateEventMutationVariables = Exact<{
  input: EventCreateDtoInput;
}>;


export type CreateEventMutation = { __typename?: 'BaseMutation', createEvent: Array<{ __typename?: 'EventReturnDto', id: number, code: string, name: string, hasParticipationFee: boolean, startDate: any, endDate: any }> };

export type DuplicateEventActionMutationVariables = Exact<{
  input: EventCloneDtoInput;
}>;


export type DuplicateEventActionMutation = { __typename?: 'BaseMutation', cloneEvent: Array<{ __typename?: 'EventReturnDto', id: number }> };

export type EventBasicSetupQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type EventBasicSetupQuery = { __typename?: 'BaseQuery', eventById?: { __typename?: 'EventReturnDto', id: number, code: string, name: string, nameHr: string, nameEn: string, place: string, address: string, eventInformationHr: string, eventInformationEn: string, onSiteRegistrationInstructionsHr: string, onSiteRegistrationInstructionsEn: string, hasParticipationFee: boolean, startDate: any, endDate: any, lifecycleStatus: EventLifecycleStatus } | null };

export type EventBasicSetupBrandingQueryVariables = Exact<{
  eventId: Scalars['Int']['input'];
}>;


export type EventBasicSetupBrandingQuery = { __typename?: 'BaseQuery', eventBrandings?: { __typename?: 'EventBrandingsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'EventBrandingReturnDto', id: number, eventId: number, logoUrl: string, primaryColor: string, secondaryColor: string, publicAssetMode: EventPublicAssetMode, programPdfUrl: string, venueLayoutImageUrl: string, sponsorsImageUrl: string, badgeTemplateUrl: string, badgeBackTemplateUrl: string, badgeFirstNameX?: number | null, badgeFirstNameY?: number | null, badgeLastNameX?: number | null, badgeLastNameY?: number | null, badgeCompanyX?: number | null, badgeCompanyY?: number | null, badgeQrCodeX?: number | null, badgeQrCodeY?: number | null, badgeTextFieldsJson: string, headerImageUrl: string, certificateTemplateUrl: string, certificateParticipantNameX?: number | null, certificateParticipantNameY?: number | null, certificateTextFieldsJson: string }> | null } | null };

export type EventOverviewSummaryQueryVariables = Exact<{
  eventId: Scalars['Int']['input'];
  trendRange?: InputMaybe<Scalars['String']['input']>;
  trendGranularity?: InputMaybe<Scalars['String']['input']>;
}>;


export type EventOverviewSummaryQuery = { __typename?: 'BaseQuery', overviewSummary: { __typename?: 'EventDashboardSummaryDto', eventId: number, participants: { __typename?: 'EventDashboardParticipantSummaryDto', participantCount: number, registrationCount: number }, payments: { __typename?: 'EventDashboardPaymentSummaryDto', paidCount: number, unpaidCount: number, pendingCount: number }, accommodation: { __typename?: 'EventDashboardAccommodationSummaryDto', reservationCount: number, reservedRoomCount: number }, certificates: { __typename?: 'EventDashboardCertificateSummaryDto', readyOrSentCount: number }, trend: { __typename?: 'EventDashboardTrendSummaryDto', rangeStartDate: string, rangeEndDate: string, points: Array<{ __typename?: 'EventDashboardTrendPointDto', date: string, registrationCount: number, reservationCount: number }> } } };

export type EventTemplateSettingsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type EventTemplateSettingsQuery = { __typename?: 'BaseQuery', eventById?: { __typename?: 'EventReturnDto', id: number, code: string, name: string, nameHr: string, nameEn: string, place: string, address: string, eventInformationHr: string, eventInformationEn: string, onSiteRegistrationInstructionsHr: string, onSiteRegistrationInstructionsEn: string, hasParticipationFee: boolean, startDate: any, endDate: any } | null, eventBrandings?: { __typename?: 'EventBrandingsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'EventBrandingReturnDto', id: number, eventId: number, logoUrl: string, primaryColor: string, secondaryColor: string, publicAssetMode: EventPublicAssetMode, programPdfUrl: string, venueLayoutImageUrl: string, sponsorsImageUrl: string, badgeTemplateUrl: string, badgeBackTemplateUrl: string, badgeFirstNameX?: number | null, badgeFirstNameY?: number | null, badgeLastNameX?: number | null, badgeLastNameY?: number | null, badgeCompanyX?: number | null, badgeCompanyY?: number | null, badgeQrCodeX?: number | null, badgeQrCodeY?: number | null, badgeTextFieldsJson: string, headerImageUrl: string, certificateTemplateUrl: string, certificateParticipantNameX?: number | null, certificateParticipantNameY?: number | null, certificateTextFieldsJson: string }> | null } | null };

export type EventsListQueryVariables = Exact<{
  where?: InputMaybe<EventReturnDtoFilterInput>;
  order?: InputMaybe<Array<EventReturnDtoSortInput> | EventReturnDtoSortInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EventsListQuery = { __typename?: 'BaseQuery', events?: { __typename?: 'EventsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'EventReturnDto', id: number, code: string, name: string, place: string, hasParticipationFee: boolean, startDate: any, endDate: any, arbitraryFieldsTemplateId?: number | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type RestoreEventActionMutationVariables = Exact<{
  input: EventDeleteDtoInput;
}>;


export type RestoreEventActionMutation = { __typename?: 'BaseMutation', restoreEvent: Array<{ __typename?: 'EventReturnDto', id: number }> };

export type SaveEventBasicSetupForConfigMutationVariables = Exact<{
  input: EventBasicSetupSaveDtoInput;
}>;


export type SaveEventBasicSetupForConfigMutation = { __typename?: 'BaseMutation', saveEventBasicSetup: boolean };

export type SaveEventBasicSetupFromWizardMutationVariables = Exact<{
  input: EventBasicSetupSaveDtoInput;
}>;


export type SaveEventBasicSetupFromWizardMutation = { __typename?: 'BaseMutation', saveEventBasicSetup: boolean };

export type SaveEventTemplateSettingsMutationVariables = Exact<{
  input: EventBasicSetupSaveDtoInput;
}>;


export type SaveEventTemplateSettingsMutation = { __typename?: 'BaseMutation', saveEventBasicSetup: boolean };

export type HotelCatalogQueryVariables = Exact<{
  eventId?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HotelIdentityCatalogItemDtoFilterInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type HotelCatalogQuery = { __typename?: 'BaseQuery', hotelIdentityCatalog?: { __typename?: 'HotelIdentityCatalogCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'HotelIdentityCatalogItemDto', id: number, name: string, category: string, address: string, city: string, country: string, notes: string }> | null } | null };

export type CreateCatalogHotelMutationVariables = Exact<{
  input: HotelIdentityCreateDtoInput;
}>;


export type CreateCatalogHotelMutation = { __typename?: 'BaseMutation', createHotelIdentity: Array<{ __typename?: 'HotelIdentityCatalogItemDto', id: number, name: string, category: string, address: string, city: string, country: string, notes: string }> };

export type UpdateCatalogHotelMutationVariables = Exact<{
  input: HotelIdentityUpdateDtoInput;
}>;


export type UpdateCatalogHotelMutation = { __typename?: 'BaseMutation', updateHotelIdentity: Array<{ __typename?: 'HotelIdentityCatalogItemDto', id: number, name: string, category: string, address: string, city: string, country: string, notes: string }> };

export type DeleteCatalogHotelMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteCatalogHotelMutation = { __typename?: 'BaseMutation', deleteHotelIdentity: boolean };

export type EventNotificationRecipientsQueryVariables = Exact<{
  eventId: Scalars['Int']['input'];
}>;


export type EventNotificationRecipientsQuery = { __typename?: 'BaseQuery', eventNotificationRecipients: Array<{ __typename?: 'EventNotificationRecipientDto', id: number, participantId: number, registrationId?: number | null, eventId: number, registrationStatus?: EventRegistrationStatus | null, firstName: string, lastName: string, email: string, company: string, phoneNumber: string, linkedInUrl: string, additionalInfo: string, participationFeeTypeId?: number | null, participationFeeTypeLabelHr: string, participationFeeTypeLabelEn: string, participationFeePricePeriodName: string }> };

export type EventNotificationTemplatesQueryVariables = Exact<{
  eventId: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
}>;


export type EventNotificationTemplatesQuery = { __typename?: 'BaseQuery', eventEmailTemplates?: { __typename?: 'EventEmailTemplatesCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'EventEmailTemplateReturnDto', id: number, eventId: number, language: LanguageCode, subject: string, body: string }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type EventParticipantNotificationHistoryQueryVariables = Exact<{
  eventId: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EventParticipantNotificationHistoryQuery = { __typename?: 'BaseQuery', eventParticipantNotificationHistory?: { __typename?: 'EventParticipantNotificationHistoryCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'EventRegistrationNotificationDeliveryLogDto', id: number, registrationId?: number | null, participantId?: number | null, eventEmailTemplateId?: number | null, notificationChannel: EventNotificationChannel, recipientEmail: string, subject: string, message: string, replyToEmailsJson: string, status: EventNotificationDeliveryStatus, createdAt: any, sentAt?: any | null, failedAt?: any | null, failureMessage: string }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type RetryFailedEventRegistrationNotificationsMutationVariables = Exact<{
  eventId: Scalars['Int']['input'];
  notificationLogIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type RetryFailedEventRegistrationNotificationsMutation = { __typename?: 'BaseMutation', retryFailedEventRegistrationNotifications: number };

export type SaveEventRegistrationNotificationDraftMutationVariables = Exact<{
  input: EventRegistrationNotificationSendDtoInput;
}>;


export type SaveEventRegistrationNotificationDraftMutation = { __typename?: 'BaseMutation', saveEventRegistrationNotificationDraft: { __typename?: 'EventRegistrationNotificationSendResultDto', eventId: number, eventEmailTemplateId?: number | null, requestedCount: number, queuedCount: number, sentCount: number, failedCount: number, logs: Array<{ __typename?: 'EventRegistrationNotificationDeliveryLogDto', id: number, registrationId?: number | null, participantId?: number | null, recipientEmail: string, status: EventNotificationDeliveryStatus, failureMessage: string, createdAt: any, sentAt?: any | null, failedAt?: any | null, notificationChannel: EventNotificationChannel, subject: string, message: string }> } };

export type SendEventRegistrationNotificationMutationVariables = Exact<{
  input: EventRegistrationNotificationSendDtoInput;
}>;


export type SendEventRegistrationNotificationMutation = { __typename?: 'BaseMutation', sendEventRegistrationNotification: { __typename?: 'EventRegistrationNotificationSendResultDto', eventId: number, eventEmailTemplateId?: number | null, requestedCount: number, queuedCount: number, sentCount: number, failedCount: number, logs: Array<{ __typename?: 'EventRegistrationNotificationDeliveryLogDto', id: number, registrationId?: number | null, recipientEmail: string, status: EventNotificationDeliveryStatus, failureMessage: string, createdAt: any, sentAt?: any | null, failedAt?: any | null, notificationChannel: EventNotificationChannel, subject: string, message: string }> } };

export type CreateOrganizationMemberMutationVariables = Exact<{
  input: OrganizationMemberCreateDtoInput;
}>;


export type CreateOrganizationMemberMutation = { __typename?: 'BaseMutation', createOrganizationMember: { __typename?: 'OrganizationMemberOnboardingResultDto', userId: string, email: string, userName: string, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, role: UserRole, emailConfirmed: boolean, hasPassword: boolean, isPendingOnboarding: boolean, onboardingEmailSent: boolean, onboardingEmailStatus?: EmailDeliveryStatus | null, onboardingEmailQueuedAtUtc?: any | null, onboardingEmailLastSentAtUtc?: any | null, onboardingEmailLastFailedAtUtc?: any | null, onboardingEmailSentCount: number, onboardingEmailFailureReason: string } };

export type OrganizationMembersQueryVariables = Exact<{
  take: Scalars['Int']['input'];
}>;


export type OrganizationMembersQuery = { __typename?: 'BaseQuery', users?: { __typename?: 'UsersCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'ApplicationUser', id: string, email?: string | null, userName?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, emailConfirmed: boolean, isActive: boolean, isDeleted: boolean, defaultRole: UserRole, onboardingEmailStatus?: EmailDeliveryStatus | null, onboardingEmailQueuedAtUtc?: any | null, onboardingEmailLastSentAtUtc?: any | null, onboardingEmailLastFailedAtUtc?: any | null, onboardingEmailSentCount: number, onboardingEmailFailureReason: string }> | null } | null };

export type RemovePendingOrganizationMemberInviteMutationVariables = Exact<{
  input: OrganizationMemberPendingInviteRemoveDtoInput;
}>;


export type RemovePendingOrganizationMemberInviteMutation = { __typename?: 'BaseMutation', removePendingOrganizationMemberInvite: { __typename?: 'OrganizationMemberMaintenanceResultDto', userId: string, email: string, isActive: boolean, isDeleted: boolean, isPendingOnboarding: boolean } };

export type ResendOrganizationMemberOnboardingMutationVariables = Exact<{
  input: OrganizationMemberOnboardingResendDtoInput;
}>;


export type ResendOrganizationMemberOnboardingMutation = { __typename?: 'BaseMutation', resendOrganizationMemberOnboarding: { __typename?: 'OrganizationMemberOnboardingResultDto', userId: string, email: string, emailConfirmed: boolean, hasPassword: boolean, isPendingOnboarding: boolean, onboardingEmailSent: boolean, onboardingEmailStatus?: EmailDeliveryStatus | null, onboardingEmailQueuedAtUtc?: any | null, onboardingEmailLastSentAtUtc?: any | null, onboardingEmailLastFailedAtUtc?: any | null, onboardingEmailSentCount: number, onboardingEmailFailureReason: string } };

export type UpdateOrganizationMemberMutationVariables = Exact<{
  input: OrganizationMemberUpdateDtoInput;
}>;


export type UpdateOrganizationMemberMutation = { __typename?: 'BaseMutation', updateOrganizationMember: { __typename?: 'OrganizationMemberMaintenanceResultDto', userId: string, email: string, userName: string, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, role: UserRole, emailConfirmed: boolean, hasPassword: boolean, isPendingOnboarding: boolean, isActive: boolean, isDeleted: boolean, onboardingEmailStatus?: EmailDeliveryStatus | null, onboardingEmailQueuedAtUtc?: any | null, onboardingEmailLastSentAtUtc?: any | null, onboardingEmailLastFailedAtUtc?: any | null, onboardingEmailSentCount: number, onboardingEmailFailureReason: string } };

export type ChangeEventRegistrationPayerMutationVariables = Exact<{
  input: EventRegistrationPayerChangeDtoInput;
}>;


export type ChangeEventRegistrationPayerMutation = { __typename?: 'BaseMutation', changeEventRegistrationPayer: { __typename?: 'EventRegistrationReturnDto', id: number, payerId?: number | null, payerType: PayerType, payerName: string, payerEmail: string, payerPhone: string, payerAddress: string, payerCity: string, payerCountry: string, payerTaxId: string, payerContactPerson: string } };

export type DeleteEventParticipantMutationVariables = Exact<{
  input: EventParticipantDeleteDtoInput;
}>;


export type DeleteEventParticipantMutation = { __typename?: 'BaseMutation', deleteEventParticipant: boolean };

export type EventParticipantActivityOptionsQueryVariables = Exact<{
  eventId: Scalars['Int']['input'];
}>;


export type EventParticipantActivityOptionsQuery = { __typename?: 'BaseQuery', eventOptions?: { __typename?: 'EventOptionsCollectionSegment', items?: Array<{ __typename?: 'EventOptionReturnDto', id: number, eventId: number, labelHr: string, labelEn: string, questionType: OptionQuestionType, price: any, allowedFeeTypeIds: Array<number>, visibilityDependsOnEventOptionId?: number | null, visibilityDependsOnExpectedAnswer?: boolean | null, choices: Array<{ __typename?: 'EventOptionChoiceDto', id: number, value: string, labelHr: string, labelEn: string, order: number, isActive: boolean }> }> | null } | null };

export type EventParticipantCockpitRegistrationsQueryVariables = Exact<{
  where?: InputMaybe<EventRegistrationReturnDtoFilterInput>;
  order?: InputMaybe<Array<EventRegistrationReturnDtoSortInput> | EventRegistrationReturnDtoSortInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EventParticipantCockpitRegistrationsQuery = { __typename?: 'BaseQuery', eventRegistrations?: { __typename?: 'EventRegistrationsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'EventRegistrationReturnDto', id: number, eventId: number, participantId: number, status: EventRegistrationStatus, rejectionReason: string, hasAccommodationReservation: boolean, accommodationReservationCount: number, currentParticipationOfferNumber: string, currentParticipationOfferStatus?: EventOfferStatus | null, currentParticipationOfferPaymentStatus?: PaymentStatus | null, currentAccommodationOfferNumber: string, currentAccommodationOfferStatus?: EventOfferStatus | null, currentAccommodationOfferPaymentStatus?: PaymentStatus | null, activeRegistrationCodeCount: number, revokedRegistrationCodeCount: number, hasCertificates: boolean, certificateCount: number }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type EventParticipantDetailFallbackQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type EventParticipantDetailFallbackQuery = { __typename?: 'BaseQuery', eventParticipantById?: { __typename?: 'EventParticipantReturnDto', id: number, eventId: number, firstName: string, lastName: string, email: string, phoneNumber: string, company: string, linkedInUrl: string, additionalInfo: string } | null };

export type EventParticipantHotelOptionsQueryVariables = Exact<{
  eventId: Scalars['Int']['input'];
}>;


export type EventParticipantHotelOptionsQuery = { __typename?: 'BaseQuery', eventHotels?: { __typename?: 'EventHotelsCollectionSegment', items?: Array<{ __typename?: 'EventHotelReturnDto', id: number, eventId: number, name: string, city: string, country: string }> | null } | null };

export type EventParticipantOperationsDetailQueryVariables = Exact<{
  eventId: Scalars['Int']['input'];
  participantId: Scalars['Int']['input'];
}>;


export type EventParticipantOperationsDetailQuery = { __typename?: 'BaseQuery', eventParticipantOperationsDetail: { __typename?: 'EventParticipantCrmDetailDto', eventId: number, eventCode: string, eventName: string, participantId: number, firstName: string, lastName: string, fullName: string, company: string, phoneNumber: string, email: string, linkedInUrl: string, additionalInfo: string, registrations: Array<{ __typename?: 'EventParticipantCrmRegistrationDto', id: number, status: EventRegistrationStatus, rejectionReason: string, isEmailVerified: boolean, verificationEmailStatus?: EmailDeliveryStatus | null, verificationEmailQueuedAtUtc?: any | null, verificationEmailSentAtUtc?: any | null, verificationEmailFailedAtUtc?: any | null, verificationEmailFailureReason: string, invitationEmailStatus?: EmailDeliveryStatus | null, invitationEmailQueuedAtUtc?: any | null, invitationEmailSentAtUtc?: any | null, invitationEmailFailedAtUtc?: any | null, invitationEmailFailureReason: string, gdprConsentAccepted: boolean, gdprConsentAcceptedAtUtc?: any | null, gdprConsentTextVersion: string, gdprConsentEventId?: number | null, offerDueDate?: any | null, participationPaymentMethod: PaymentMethod, accommodationPaymentMethod: PaymentMethod, createdAt: any, payerId: number, payerType: PayerType, payerName: string, payerEmail: string, payerPhone: string, payerAddress: string, payerCity: string, payerCountry: string, payerTaxId: string, payerContactPerson: string, participantTypeProofFileId?: number | null, participantTypeProofFileName: string, participantTypeProofFileContentType: string, selectedEventOptionIds: Array<number>, selectedParticipationFeeTypeId?: number | null, currentParticipationOfferId?: number | null, currentParticipationOfferNumber: string, currentParticipationOfferStatus?: EventOfferStatus | null, currentParticipationOfferPaymentStatus?: PaymentStatus | null, currentAccommodationOfferNumber: string, currentAccommodationOfferStatus?: EventOfferStatus | null, currentAccommodationOfferPaymentStatus?: PaymentStatus | null, activityAnswers: Array<{ __typename?: 'EventRegistrationActivityAnswerReturnDto', eventOptionId: number, questionType: OptionQuestionType, isSelected: boolean, textValue: string, selectedChoiceIds: Array<number>, value: string }> }>, roomReservations: Array<{ __typename?: 'EventParticipantCrmRoomReservationDto', id: number, registrationId: number, hotelId: number, hotelName: string, roomTypeId: number, roomTypeName: string, arrivalDate: any, departureDate: any, nightCount: number, roomCount: number, status: EventRoomReservationStatus, pricePerNightSnapshot: any }>, registrationCodes: Array<{ __typename?: 'EventParticipantCrmRegistrationCodeDto', id: number, registrationId: number, issuedAt: any, revokedAt?: any | null, isActive: boolean }>, certificates: Array<{ __typename?: 'EventCertificateHistoryDto', id: number, eventId: number, registrationId: number, registrationStatus: EventRegistrationStatus, participantId: number, participantFullName: string, fileId: number, fileName: string, status: EventCertificateStatus, requestedBy: string, requestedAt: any, generatedAt: any, emailQueuedAtUtc?: any | null, emailedAt?: any | null, emailFailedAtUtc?: any | null, emailFailureReason: string }> } };

export type EventParticipantRoomAllotmentOptionsQueryVariables = Exact<{
  hotelIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  roomTypeIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type EventParticipantRoomAllotmentOptionsQuery = { __typename?: 'BaseQuery', eventRoomAllotments?: { __typename?: 'EventRoomAllotmentsCollectionSegment', items?: Array<{ __typename?: 'EventRoomAllotmentReturnDto', id: number, hotelId: number, roomTypeId: number, startDate: any, endDate: any, totalRooms: number }> | null } | null };

export type EventParticipantRoomTypeOptionsQueryVariables = Exact<{
  hotelIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type EventParticipantRoomTypeOptionsQuery = { __typename?: 'BaseQuery', eventRoomTypes?: { __typename?: 'EventRoomTypesCollectionSegment', items?: Array<{ __typename?: 'EventRoomTypeReturnDto', id: number, hotelId: number, name: string, capacity: number, pricePerNight: any, description: string }> | null } | null };

export type EventParticipantsListQueryVariables = Exact<{
  where?: InputMaybe<EventParticipantReturnDtoFilterInput>;
  order?: InputMaybe<Array<EventParticipantReturnDtoSortInput> | EventParticipantReturnDtoSortInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  statusFilter?: InputMaybe<EventParticipantStatusFilterDtoInput>;
}>;


export type EventParticipantsListQuery = { __typename?: 'BaseQuery', eventParticipants?: { __typename?: 'EventParticipantsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'EventParticipantReturnDto', id: number, eventId: number, firstName: string, lastName: string, email: string, phoneNumber: string, company: string, linkedInUrl: string }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type EventParticipantsTotalQueryVariables = Exact<{
  where?: InputMaybe<EventParticipantReturnDtoFilterInput>;
}>;


export type EventParticipantsTotalQuery = { __typename?: 'BaseQuery', eventParticipants?: { __typename?: 'EventParticipantsCollectionSegment', totalCount: number } | null };

export type GenerateEventCertificateMutationVariables = Exact<{
  input: EventCertificateGenerateDtoInput;
}>;


export type GenerateEventCertificateMutation = { __typename?: 'BaseMutation', generateEventCertificate: { __typename?: 'EventCertificateReturnDto', id: number, eventId: number, registrationId: number, participantId: number, fileId: number, fileName: string, status: EventCertificateStatus, participantFullName: string, requestedBy: string, requestedAt: any, generatedAt: any, emailedAt?: any | null } };

export type InviteEventRegistrationMutationVariables = Exact<{
  input: EventRegistrationDeleteDtoInput;
}>;


export type InviteEventRegistrationMutation = { __typename?: 'BaseMutation', inviteEventRegistration: { __typename?: 'EventRegistrationReturnDto', id: number, status: EventRegistrationStatus } };

export type ParticipantPayerOptionsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type ParticipantPayerOptionsQuery = { __typename?: 'BaseQuery', payers?: { __typename?: 'PayersCollectionSegment', items?: Array<{ __typename?: 'PayerReturnDto', id: number, type: PayerType, name: string, email: string, phone: string, address: string, city: string, country: string, taxId: string, contactPerson: string }> | null } | null };

export type RejectEventRegistrationMutationVariables = Exact<{
  input: EventRegistrationRejectDtoInput;
}>;


export type RejectEventRegistrationMutation = { __typename?: 'BaseMutation', rejectEventRegistration: { __typename?: 'EventRegistrationReturnDto', id: number, status: EventRegistrationStatus, rejectionReason: string } };

export type ResendEventCertificateEmailMutationVariables = Exact<{
  input: EventCertificateEmailResendDtoInput;
}>;


export type ResendEventCertificateEmailMutation = { __typename?: 'BaseMutation', resendEventCertificateEmail: { __typename?: 'EventCertificateReturnDto', id: number, status: EventCertificateStatus, emailQueuedAtUtc?: any | null, emailedAt?: any | null, emailFailedAtUtc?: any | null, emailFailureReason: string } };

export type ResendEventRegistrationVerificationEmailMutationVariables = Exact<{
  input: EventRegistrationDeleteDtoInput;
}>;


export type ResendEventRegistrationVerificationEmailMutation = { __typename?: 'BaseMutation', resendEventRegistrationVerificationEmail: { __typename?: 'EventRegistrationReturnDto', id: number, verificationEmailStatus?: EmailDeliveryStatus | null, verificationEmailQueuedAtUtc?: any | null, verificationEmailSentAtUtc?: any | null, verificationEmailFailedAtUtc?: any | null, verificationEmailFailureReason: string } };

export type SaveEventRoomReservationMutationVariables = Exact<{
  input: EventRoomReservationSaveDtoInput;
}>;


export type SaveEventRoomReservationMutation = { __typename?: 'BaseMutation', saveEventRoomReservation: { __typename?: 'EventRoomReservationSaveResultDto', id: number, eventId: number, registrationId: number, participantId: number, hotelId: number, roomTypeId: number, arrivalDate: any, departureDate: any, roomCount: number, status: EventRoomReservationStatus, pricePerNightSnapshot: any, updatedAt: any } };

export type UpdateEventRegistrationActivitiesMutationVariables = Exact<{
  input: EventRegistrationOptionSelectionUpdateDtoInput;
}>;


export type UpdateEventRegistrationActivitiesMutation = { __typename?: 'BaseMutation', updateEventRegistrationActivities: { __typename?: 'EventRegistrationReturnDto', id: number, eventId: number, participantId: number } };

export type UpdateEventParticipantMutationVariables = Exact<{
  input: EventParticipantUpdateDtoInput;
}>;


export type UpdateEventParticipantMutation = { __typename?: 'BaseMutation', updateEventParticipant: Array<{ __typename?: 'EventParticipantReturnDto', id: number, eventId: number, firstName: string, lastName: string, company: string, phoneNumber: string, email: string, linkedInUrl: string, additionalInfo: string }> };

export type CreatePayerMutationVariables = Exact<{
  input: PayerCreateDtoInput;
}>;


export type CreatePayerMutation = { __typename?: 'BaseMutation', createPayer: Array<{ __typename?: 'PayerReturnDto', id: number, type: PayerType, name: string, email: string, phone: string, address: string, city: string, country: string, taxId: string, contactPerson: string }> };

export type DeletePayerMutationVariables = Exact<{
  input: PayerDeleteDtoInput;
}>;


export type DeletePayerMutation = { __typename?: 'BaseMutation', deletePayer: boolean };

export type ManualReconcilePayerPaymentMutationVariables = Exact<{
  input: PaymentManualReconcileDtoInput;
}>;


export type ManualReconcilePayerPaymentMutation = { __typename?: 'BaseMutation', manualReconcilePayment: { __typename?: 'PaymentReturnDto', id: number, status: PaymentStatus, manuallyReconciledAt?: any | null } };

export type PayerOfferHistoryQueryVariables = Exact<{
  payerId: Scalars['Int']['input'];
}>;


export type PayerOfferHistoryQuery = { __typename?: 'BaseQuery', payerOfferHistory?: { __typename?: 'PayerOfferHistoryCollectionSegment', items?: Array<{ __typename?: 'EventOfferHistoryDto', id: number, eventId: number, eventCode: string, eventName: string, registrationId: number, participantId: number, participantFullName: string, fileId: number, fileName: string, customerPurchaseOrderFileId?: number | null, customerPurchaseOrderFileName?: string | null, customerPurchaseOrderFileContentType?: string | null, type: EventOfferType, status: EventOfferStatus, offerNumber: string, grossTotal: any, currency: string, dueDate: any, paymentMethod: PaymentMethod, generatedAt: any, emailQueuedAtUtc?: any | null, emailedAt?: any | null, emailFailedAtUtc?: any | null, emailFailureReason: string }> | null } | null };

export type PayerPaymentAllocationsQueryVariables = Exact<{
  payerId: Scalars['Int']['input'];
}>;


export type PayerPaymentAllocationsQuery = { __typename?: 'BaseQuery', payerPaymentAllocations?: { __typename?: 'PayerPaymentAllocationsCollectionSegment', items?: Array<{ __typename?: 'PayerPaymentAllocationHistoryDto', id: number, paymentId: number, eventId: number, eventCode: string, eventName: string, registrationId?: number | null, participantId?: number | null, participantFullName: string, offerId?: number | null, offerNumber: string, allocatedAmount: any, description: string, paymentMethod: PaymentMethod, paymentStatus: PaymentStatus, paymentAmountGross: any, paymentAmountNet: any, paymentRefundedAmountGross: any, currency: string, isSponsorPayment: boolean, paidAt: any, reference: string, provider: string, providerReference: string, payerName: string, payerEmail: string, manuallyReconciledAt?: any | null }> | null } | null };

export type PayersPageQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type PayersPageQuery = { __typename?: 'BaseQuery', payers?: { __typename?: 'PayersCollectionSegment', items?: Array<{ __typename?: 'PayerReturnDto', id: number, type: PayerType, name: string, email: string, phone: string, address: string, city: string, country: string, taxId: string, contactPerson: string }> | null } | null };

export type RenewPayerEventParticipationOfferMutationVariables = Exact<{
  input: EventOfferRenewDtoInput;
}>;


export type RenewPayerEventParticipationOfferMutation = { __typename?: 'BaseMutation', renewEventParticipationOffer: { __typename?: 'EventOfferRenewalResultDto', previousOfferId: number, replacementOfferId: number, type: EventOfferType, previousStatus: EventOfferStatus, replacementStatus: EventOfferStatus, previousOfferNumber: string, replacementOfferNumber: string } };

export type UpdatePayerMutationVariables = Exact<{
  input: PayerUpdateDtoInput;
}>;


export type UpdatePayerMutation = { __typename?: 'BaseMutation', updatePayer: Array<{ __typename?: 'PayerReturnDto', id: number, type: PayerType, name: string, email: string, phone: string, address: string, city: string, country: string, taxId: string, contactPerson: string }> };

export type EventOfferBalancesQueryVariables = Exact<{
  eventId: Scalars['Int']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EventOfferBalanceDtoFilterInput>;
  order?: InputMaybe<Array<EventOfferBalanceDtoSortInput> | EventOfferBalanceDtoSortInput>;
}>;


export type EventOfferBalancesQuery = { __typename?: 'BaseQuery', eventOfferBalances?: { __typename?: 'EventOfferBalancesCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'EventOfferBalanceDto', id: number, offerNumber: string, type: EventOfferType, status: EventOfferStatus, participantId: number, participantFullName: string, payerId: number, payerName: string, grossTotal: any, paidAmount: any, outstandingAmount: any, currency: string, dueDate: any, generatedAt: any }> | null } | null };

export type RecordOfferPaymentMutationVariables = Exact<{
  input: RecordOfferPaymentDtoInput;
}>;


export type RecordOfferPaymentMutation = { __typename?: 'BaseMutation', recordOfferPayment: { __typename?: 'PaymentReturnDto', id: number, status: PaymentStatus, amountGross: any, currency: string, paidAt: any, manuallyReconciledAt?: any | null } };

export type EventRoomingListQueryVariables = Exact<{
  eventId: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EventRoomingListQuery = { __typename?: 'BaseQuery', eventById?: { __typename?: 'EventReturnDto', id: number, code: string, name: string } | null, eventRegistrations?: { __typename?: 'EventRegistrationsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'EventRegistrationReturnDto', id: number, participantFullName: string, hasAccommodationReservation: boolean, accommodationReservationId?: number | null, accommodationReservationStatus?: EventRoomReservationStatus | null, accommodationHotelName: string, accommodationRoomTypeName: string, accommodationArrivalDate?: any | null, accommodationDepartureDate?: any | null, currentAccommodationOfferPaymentStatus?: PaymentStatus | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type ReleaseEventRoomReservationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ReleaseEventRoomReservationMutation = { __typename?: 'BaseMutation', releaseEventRoomReservation: { __typename?: 'EventRoomReservationReleaseResultDto', id: number, eventId: number, registrationId: number, participantId: number, status: EventRoomReservationStatus, updatedAt: any } };

export type GeneralSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GeneralSettingsQuery = { __typename?: 'BaseQuery', generalSettings: { __typename?: 'GeneralSettingsReturnDto', id: number, isPersisted: boolean, createdAt?: any | null, updatedAt?: any | null, payeeName: string, payeeAddress: string, payeeIban: string, payeeOib: string, registrationVatRate: any, accommodationVatRate: any, accommodationTaxScheme: AccommodationTaxScheme } };

export type UpsertGeneralSettingsMutationVariables = Exact<{
  input: GeneralSettingsUpsertDtoInput;
}>;


export type UpsertGeneralSettingsMutation = { __typename?: 'BaseMutation', upsertGeneralSettings: { __typename?: 'GeneralSettingsReturnDto', id: number, isPersisted: boolean, createdAt?: any | null, updatedAt?: any | null, payeeName: string, payeeAddress: string, payeeIban: string, payeeOib: string, registrationVatRate: any, accommodationVatRate: any, accommodationTaxScheme: AccommodationTaxScheme } };


export const CompleteOrganizationMemberOnboardingDocument = gql`
    mutation completeOrganizationMemberOnboarding($input: OrganizationMemberOnboardingCompleteDtoInput!) {
  completeOrganizationMemberOnboarding(input: $input) {
    userId
    emailConfirmed
    hasPassword
    isPendingOnboarding
  }
}
    `;
export type CompleteOrganizationMemberOnboardingMutationFn = Apollo.MutationFunction<CompleteOrganizationMemberOnboardingMutation, CompleteOrganizationMemberOnboardingMutationVariables>;
export function useCompleteOrganizationMemberOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<CompleteOrganizationMemberOnboardingMutation, CompleteOrganizationMemberOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteOrganizationMemberOnboardingMutation, CompleteOrganizationMemberOnboardingMutationVariables>(CompleteOrganizationMemberOnboardingDocument, options);
      }
export type CompleteOrganizationMemberOnboardingMutationHookResult = ReturnType<typeof useCompleteOrganizationMemberOnboardingMutation>;
export type CompleteOrganizationMemberOnboardingMutationResult = Apollo.MutationResult<CompleteOrganizationMemberOnboardingMutation>;
export type CompleteOrganizationMemberOnboardingMutationOptions = Apollo.BaseMutationOptions<CompleteOrganizationMemberOnboardingMutation, CompleteOrganizationMemberOnboardingMutationVariables>;
export const CompleteOrganizerPasswordResetDocument = gql`
    mutation completeOrganizerPasswordReset($input: OrganizerPasswordResetCompleteDtoInput!) {
  completeOrganizerPasswordReset(input: $input)
}
    `;
export type CompleteOrganizerPasswordResetMutationFn = Apollo.MutationFunction<CompleteOrganizerPasswordResetMutation, CompleteOrganizerPasswordResetMutationVariables>;
export function useCompleteOrganizerPasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<CompleteOrganizerPasswordResetMutation, CompleteOrganizerPasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteOrganizerPasswordResetMutation, CompleteOrganizerPasswordResetMutationVariables>(CompleteOrganizerPasswordResetDocument, options);
      }
export type CompleteOrganizerPasswordResetMutationHookResult = ReturnType<typeof useCompleteOrganizerPasswordResetMutation>;
export type CompleteOrganizerPasswordResetMutationResult = Apollo.MutationResult<CompleteOrganizerPasswordResetMutation>;
export type CompleteOrganizerPasswordResetMutationOptions = Apollo.BaseMutationOptions<CompleteOrganizerPasswordResetMutation, CompleteOrganizerPasswordResetMutationVariables>;
export const CurrentAuthenticatedUserDocument = gql`
    query CurrentAuthenticatedUser {
  user {
    id
  }
}
    `;
export function useCurrentAuthenticatedUserQuery(baseOptions?: Apollo.QueryHookOptions<CurrentAuthenticatedUserQuery, CurrentAuthenticatedUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentAuthenticatedUserQuery, CurrentAuthenticatedUserQueryVariables>(CurrentAuthenticatedUserDocument, options);
      }
export function useCurrentAuthenticatedUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentAuthenticatedUserQuery, CurrentAuthenticatedUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentAuthenticatedUserQuery, CurrentAuthenticatedUserQueryVariables>(CurrentAuthenticatedUserDocument, options);
        }
export type CurrentAuthenticatedUserQueryHookResult = ReturnType<typeof useCurrentAuthenticatedUserQuery>;
export type CurrentAuthenticatedUserLazyQueryHookResult = ReturnType<typeof useCurrentAuthenticatedUserLazyQuery>;
export type CurrentAuthenticatedUserQueryResult = Apollo.QueryResult<CurrentAuthenticatedUserQuery, CurrentAuthenticatedUserQueryVariables>;
export const CurrentUserProfileDocument = gql`
    query CurrentUserProfile {
  currentUserProfile {
    id
    userName
    email
    emailSignature
  }
}
    `;
export function useCurrentUserProfileQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserProfileQuery, CurrentUserProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserProfileQuery, CurrentUserProfileQueryVariables>(CurrentUserProfileDocument, options);
      }
export function useCurrentUserProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserProfileQuery, CurrentUserProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserProfileQuery, CurrentUserProfileQueryVariables>(CurrentUserProfileDocument, options);
        }
export type CurrentUserProfileQueryHookResult = ReturnType<typeof useCurrentUserProfileQuery>;
export type CurrentUserProfileLazyQueryHookResult = ReturnType<typeof useCurrentUserProfileLazyQuery>;
export type CurrentUserProfileQueryResult = Apollo.QueryResult<CurrentUserProfileQuery, CurrentUserProfileQueryVariables>;
export const LogMeInDocument = gql`
    mutation logMeIn($password: String!, $username: String!) {
  login(model: {password: $password, username: $username}) {
    token
  }
}
    `;
export type LogMeInMutationFn = Apollo.MutationFunction<LogMeInMutation, LogMeInMutationVariables>;
export function useLogMeInMutation(baseOptions?: Apollo.MutationHookOptions<LogMeInMutation, LogMeInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogMeInMutation, LogMeInMutationVariables>(LogMeInDocument, options);
      }
export type LogMeInMutationHookResult = ReturnType<typeof useLogMeInMutation>;
export type LogMeInMutationResult = Apollo.MutationResult<LogMeInMutation>;
export type LogMeInMutationOptions = Apollo.BaseMutationOptions<LogMeInMutation, LogMeInMutationVariables>;
export const RefreshTokenDocument = gql`
    mutation refreshToken {
  refreshToken {
    token
  }
}
    `;
export type RefreshTokenMutationFn = Apollo.MutationFunction<RefreshTokenMutation, RefreshTokenMutationVariables>;
export function useRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<RefreshTokenMutation, RefreshTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(RefreshTokenDocument, options);
      }
export type RefreshTokenMutationHookResult = ReturnType<typeof useRefreshTokenMutation>;
export type RefreshTokenMutationResult = Apollo.MutationResult<RefreshTokenMutation>;
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<RefreshTokenMutation, RefreshTokenMutationVariables>;
export const RequestOrganizerPasswordResetDocument = gql`
    mutation requestOrganizerPasswordReset($email: String!) {
  requestOrganizerPasswordReset(email: $email)
}
    `;
export type RequestOrganizerPasswordResetMutationFn = Apollo.MutationFunction<RequestOrganizerPasswordResetMutation, RequestOrganizerPasswordResetMutationVariables>;
export function useRequestOrganizerPasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<RequestOrganizerPasswordResetMutation, RequestOrganizerPasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestOrganizerPasswordResetMutation, RequestOrganizerPasswordResetMutationVariables>(RequestOrganizerPasswordResetDocument, options);
      }
export type RequestOrganizerPasswordResetMutationHookResult = ReturnType<typeof useRequestOrganizerPasswordResetMutation>;
export type RequestOrganizerPasswordResetMutationResult = Apollo.MutationResult<RequestOrganizerPasswordResetMutation>;
export type RequestOrganizerPasswordResetMutationOptions = Apollo.BaseMutationOptions<RequestOrganizerPasswordResetMutation, RequestOrganizerPasswordResetMutationVariables>;
export const ResendConfirmationEmailDocument = gql`
    mutation resendConfirmationEmail($model: AccountResendConfirmationEmailDtoInput!) {
  resendConfirmationEmail(model: $model)
}
    `;
export type ResendConfirmationEmailMutationFn = Apollo.MutationFunction<ResendConfirmationEmailMutation, ResendConfirmationEmailMutationVariables>;
export function useResendConfirmationEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResendConfirmationEmailMutation, ResendConfirmationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendConfirmationEmailMutation, ResendConfirmationEmailMutationVariables>(ResendConfirmationEmailDocument, options);
      }
export type ResendConfirmationEmailMutationHookResult = ReturnType<typeof useResendConfirmationEmailMutation>;
export type ResendConfirmationEmailMutationResult = Apollo.MutationResult<ResendConfirmationEmailMutation>;
export type ResendConfirmationEmailMutationOptions = Apollo.BaseMutationOptions<ResendConfirmationEmailMutation, ResendConfirmationEmailMutationVariables>;
export const UpdateCurrentUserProfileDocument = gql`
    mutation UpdateCurrentUserProfile($input: UserProfileUpdateDtoInput!) {
  updateCurrentUserProfile(input: $input) {
    id
    userName
    email
    emailSignature
  }
}
    `;
export type UpdateCurrentUserProfileMutationFn = Apollo.MutationFunction<UpdateCurrentUserProfileMutation, UpdateCurrentUserProfileMutationVariables>;
export function useUpdateCurrentUserProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCurrentUserProfileMutation, UpdateCurrentUserProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCurrentUserProfileMutation, UpdateCurrentUserProfileMutationVariables>(UpdateCurrentUserProfileDocument, options);
      }
export type UpdateCurrentUserProfileMutationHookResult = ReturnType<typeof useUpdateCurrentUserProfileMutation>;
export type UpdateCurrentUserProfileMutationResult = Apollo.MutationResult<UpdateCurrentUserProfileMutation>;
export type UpdateCurrentUserProfileMutationOptions = Apollo.BaseMutationOptions<UpdateCurrentUserProfileMutation, UpdateCurrentUserProfileMutationVariables>;
export const EventActivityLogsDocument = gql`
    query EventActivityLogs($eventId: Int!, $take: Int, $skip: Int, $order: [EventActivityLogDtoSortInput!]) {
  eventActivityLogs(eventId: $eventId, take: $take, skip: $skip, order: $order) {
    items {
      id
      eventId
      occurredAt
      userId
      userName
      action
      actionType
      entityName
      entityId
      details
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;
export function useEventActivityLogsQuery(baseOptions: Apollo.QueryHookOptions<EventActivityLogsQuery, EventActivityLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventActivityLogsQuery, EventActivityLogsQueryVariables>(EventActivityLogsDocument, options);
      }
export function useEventActivityLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventActivityLogsQuery, EventActivityLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventActivityLogsQuery, EventActivityLogsQueryVariables>(EventActivityLogsDocument, options);
        }
export type EventActivityLogsQueryHookResult = ReturnType<typeof useEventActivityLogsQuery>;
export type EventActivityLogsLazyQueryHookResult = ReturnType<typeof useEventActivityLogsLazyQuery>;
export type EventActivityLogsQueryResult = Apollo.QueryResult<EventActivityLogsQuery, EventActivityLogsQueryVariables>;
export const CreateEventEmailTemplateDocument = gql`
    mutation CreateEventEmailTemplate($input: EventEmailTemplateCreateDtoInput!) {
  createEventEmailTemplate(input: $input) {
    id
    eventId
    language
    subject
    body
  }
}
    `;
export type CreateEventEmailTemplateMutationFn = Apollo.MutationFunction<CreateEventEmailTemplateMutation, CreateEventEmailTemplateMutationVariables>;
export function useCreateEventEmailTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventEmailTemplateMutation, CreateEventEmailTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventEmailTemplateMutation, CreateEventEmailTemplateMutationVariables>(CreateEventEmailTemplateDocument, options);
      }
export type CreateEventEmailTemplateMutationHookResult = ReturnType<typeof useCreateEventEmailTemplateMutation>;
export type CreateEventEmailTemplateMutationResult = Apollo.MutationResult<CreateEventEmailTemplateMutation>;
export type CreateEventEmailTemplateMutationOptions = Apollo.BaseMutationOptions<CreateEventEmailTemplateMutation, CreateEventEmailTemplateMutationVariables>;
export const CreateEventFeePriceDocument = gql`
    mutation CreateEventFeePrice($input: EventFeePriceCreateDtoInput!) {
  createEventFeePrice(input: $input) {
    id
    feeTypeId
    pricePeriodId
    amount
  }
}
    `;
export type CreateEventFeePriceMutationFn = Apollo.MutationFunction<CreateEventFeePriceMutation, CreateEventFeePriceMutationVariables>;
export function useCreateEventFeePriceMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventFeePriceMutation, CreateEventFeePriceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventFeePriceMutation, CreateEventFeePriceMutationVariables>(CreateEventFeePriceDocument, options);
      }
export type CreateEventFeePriceMutationHookResult = ReturnType<typeof useCreateEventFeePriceMutation>;
export type CreateEventFeePriceMutationResult = Apollo.MutationResult<CreateEventFeePriceMutation>;
export type CreateEventFeePriceMutationOptions = Apollo.BaseMutationOptions<CreateEventFeePriceMutation, CreateEventFeePriceMutationVariables>;
export const CreateEventFeeTypeDocument = gql`
    mutation CreateEventFeeType($input: EventFeeTypeCreateDtoInput!) {
  createEventFeeType(input: $input) {
    id
    eventId
    labelHr
    labelEn
    isFree
    isSponsored
    isPublicRegistrationHidden
    requiresParticipantTypeProof
  }
}
    `;
export type CreateEventFeeTypeMutationFn = Apollo.MutationFunction<CreateEventFeeTypeMutation, CreateEventFeeTypeMutationVariables>;
export function useCreateEventFeeTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventFeeTypeMutation, CreateEventFeeTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventFeeTypeMutation, CreateEventFeeTypeMutationVariables>(CreateEventFeeTypeDocument, options);
      }
export type CreateEventFeeTypeMutationHookResult = ReturnType<typeof useCreateEventFeeTypeMutation>;
export type CreateEventFeeTypeMutationResult = Apollo.MutationResult<CreateEventFeeTypeMutation>;
export type CreateEventFeeTypeMutationOptions = Apollo.BaseMutationOptions<CreateEventFeeTypeMutation, CreateEventFeeTypeMutationVariables>;
export const CreateEventHotelDocument = gql`
    mutation CreateEventHotel($input: EventHotelCreateDtoInput!) {
  createEventHotel(input: $input) {
    id
    eventId
    name
    category
    address
    city
    country
    notes
  }
}
    `;
export type CreateEventHotelMutationFn = Apollo.MutationFunction<CreateEventHotelMutation, CreateEventHotelMutationVariables>;
export function useCreateEventHotelMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventHotelMutation, CreateEventHotelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventHotelMutation, CreateEventHotelMutationVariables>(CreateEventHotelDocument, options);
      }
export type CreateEventHotelMutationHookResult = ReturnType<typeof useCreateEventHotelMutation>;
export type CreateEventHotelMutationResult = Apollo.MutationResult<CreateEventHotelMutation>;
export type CreateEventHotelMutationOptions = Apollo.BaseMutationOptions<CreateEventHotelMutation, CreateEventHotelMutationVariables>;
export const CreateEventOptionDocument = gql`
    mutation CreateEventOption($input: EventOptionCreateDtoInput!) {
  createEventOption(input: $input) {
    id
    eventId
    labelHr
    labelEn
    vatRate
    questionType
    price
    publicRegistrationEndDate
    tracksUsageOrAttendance
    allowedFeeTypeIds
    visibilityDependsOnEventOptionId
    visibilityDependsOnExpectedAnswer
    isActive
  }
}
    `;
export type CreateEventOptionMutationFn = Apollo.MutationFunction<CreateEventOptionMutation, CreateEventOptionMutationVariables>;
export function useCreateEventOptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventOptionMutation, CreateEventOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventOptionMutation, CreateEventOptionMutationVariables>(CreateEventOptionDocument, options);
      }
export type CreateEventOptionMutationHookResult = ReturnType<typeof useCreateEventOptionMutation>;
export type CreateEventOptionMutationResult = Apollo.MutationResult<CreateEventOptionMutation>;
export type CreateEventOptionMutationOptions = Apollo.BaseMutationOptions<CreateEventOptionMutation, CreateEventOptionMutationVariables>;
export const CreateEventPaymentMethodForConfigDocument = gql`
    mutation createEventPaymentMethodForConfig($input: EventPaymentMethodCreateDtoInput!) {
  createEventPaymentMethod(input: $input) {
    id
    eventId
    category
    bankTransferAllowed
    cardAllowed
    posAllowed
  }
}
    `;
export type CreateEventPaymentMethodForConfigMutationFn = Apollo.MutationFunction<CreateEventPaymentMethodForConfigMutation, CreateEventPaymentMethodForConfigMutationVariables>;
export function useCreateEventPaymentMethodForConfigMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventPaymentMethodForConfigMutation, CreateEventPaymentMethodForConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventPaymentMethodForConfigMutation, CreateEventPaymentMethodForConfigMutationVariables>(CreateEventPaymentMethodForConfigDocument, options);
      }
export type CreateEventPaymentMethodForConfigMutationHookResult = ReturnType<typeof useCreateEventPaymentMethodForConfigMutation>;
export type CreateEventPaymentMethodForConfigMutationResult = Apollo.MutationResult<CreateEventPaymentMethodForConfigMutation>;
export type CreateEventPaymentMethodForConfigMutationOptions = Apollo.BaseMutationOptions<CreateEventPaymentMethodForConfigMutation, CreateEventPaymentMethodForConfigMutationVariables>;
export const CreateEventPricePeriodDocument = gql`
    mutation CreateEventPricePeriod($input: EventPricePeriodCreateDtoInput!) {
  createEventPricePeriod(input: $input) {
    id
    eventId
    name
    code
    startDate
    endDate
  }
}
    `;
export type CreateEventPricePeriodMutationFn = Apollo.MutationFunction<CreateEventPricePeriodMutation, CreateEventPricePeriodMutationVariables>;
export function useCreateEventPricePeriodMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventPricePeriodMutation, CreateEventPricePeriodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventPricePeriodMutation, CreateEventPricePeriodMutationVariables>(CreateEventPricePeriodDocument, options);
      }
export type CreateEventPricePeriodMutationHookResult = ReturnType<typeof useCreateEventPricePeriodMutation>;
export type CreateEventPricePeriodMutationResult = Apollo.MutationResult<CreateEventPricePeriodMutation>;
export type CreateEventPricePeriodMutationOptions = Apollo.BaseMutationOptions<CreateEventPricePeriodMutation, CreateEventPricePeriodMutationVariables>;
export const CreateEventTaxSettingDocument = gql`
    mutation CreateEventTaxSetting($input: EventTaxSettingCreateDtoInput!) {
  createEventTaxSetting(input: $input) {
    id
    eventId
    registrationVatRate
    accommodationVatRate
    accommodationTaxScheme
  }
}
    `;
export type CreateEventTaxSettingMutationFn = Apollo.MutationFunction<CreateEventTaxSettingMutation, CreateEventTaxSettingMutationVariables>;
export function useCreateEventTaxSettingMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventTaxSettingMutation, CreateEventTaxSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventTaxSettingMutation, CreateEventTaxSettingMutationVariables>(CreateEventTaxSettingDocument, options);
      }
export type CreateEventTaxSettingMutationHookResult = ReturnType<typeof useCreateEventTaxSettingMutation>;
export type CreateEventTaxSettingMutationResult = Apollo.MutationResult<CreateEventTaxSettingMutation>;
export type CreateEventTaxSettingMutationOptions = Apollo.BaseMutationOptions<CreateEventTaxSettingMutation, CreateEventTaxSettingMutationVariables>;
export const DeleteAccommodationOptionsDocument = gql`
    mutation DeleteAccommodationOptions($input: DeleteAccommodationOptionsDtoInput!) {
  deleteAccommodationOptions(input: $input)
}
    `;
export type DeleteAccommodationOptionsMutationFn = Apollo.MutationFunction<DeleteAccommodationOptionsMutation, DeleteAccommodationOptionsMutationVariables>;
export function useDeleteAccommodationOptionsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccommodationOptionsMutation, DeleteAccommodationOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccommodationOptionsMutation, DeleteAccommodationOptionsMutationVariables>(DeleteAccommodationOptionsDocument, options);
      }
export type DeleteAccommodationOptionsMutationHookResult = ReturnType<typeof useDeleteAccommodationOptionsMutation>;
export type DeleteAccommodationOptionsMutationResult = Apollo.MutationResult<DeleteAccommodationOptionsMutation>;
export type DeleteAccommodationOptionsMutationOptions = Apollo.BaseMutationOptions<DeleteAccommodationOptionsMutation, DeleteAccommodationOptionsMutationVariables>;
export const EventAccessGrantsForConfigDocument = gql`
    query eventAccessGrantsForConfig($eventId: Int!) {
  eventAccessGrants(eventId: $eventId, take: 100) {
    items {
      id
      eventId
      userId
      userEmail
      userName
      grantedAtUtc
    }
    totalCount
  }
}
    `;
export function useEventAccessGrantsForConfigQuery(baseOptions: Apollo.QueryHookOptions<EventAccessGrantsForConfigQuery, EventAccessGrantsForConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventAccessGrantsForConfigQuery, EventAccessGrantsForConfigQueryVariables>(EventAccessGrantsForConfigDocument, options);
      }
export function useEventAccessGrantsForConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventAccessGrantsForConfigQuery, EventAccessGrantsForConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventAccessGrantsForConfigQuery, EventAccessGrantsForConfigQueryVariables>(EventAccessGrantsForConfigDocument, options);
        }
export type EventAccessGrantsForConfigQueryHookResult = ReturnType<typeof useEventAccessGrantsForConfigQuery>;
export type EventAccessGrantsForConfigLazyQueryHookResult = ReturnType<typeof useEventAccessGrantsForConfigLazyQuery>;
export type EventAccessGrantsForConfigQueryResult = Apollo.QueryResult<EventAccessGrantsForConfigQuery, EventAccessGrantsForConfigQueryVariables>;
export const EventAccessUsersForConfigDocument = gql`
    query eventAccessUsersForConfig($eventId: Int!, $take: Int!) {
  eventAccessUsers(eventId: $eventId, take: $take, order: [{email: ASC}]) {
    items {
      id
      email
      userName
      firstName
      lastName
      defaultRole
    }
    totalCount
  }
}
    `;
export function useEventAccessUsersForConfigQuery(baseOptions: Apollo.QueryHookOptions<EventAccessUsersForConfigQuery, EventAccessUsersForConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventAccessUsersForConfigQuery, EventAccessUsersForConfigQueryVariables>(EventAccessUsersForConfigDocument, options);
      }
export function useEventAccessUsersForConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventAccessUsersForConfigQuery, EventAccessUsersForConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventAccessUsersForConfigQuery, EventAccessUsersForConfigQueryVariables>(EventAccessUsersForConfigDocument, options);
        }
export type EventAccessUsersForConfigQueryHookResult = ReturnType<typeof useEventAccessUsersForConfigQuery>;
export type EventAccessUsersForConfigLazyQueryHookResult = ReturnType<typeof useEventAccessUsersForConfigLazyQuery>;
export type EventAccessUsersForConfigQueryResult = Apollo.QueryResult<EventAccessUsersForConfigQuery, EventAccessUsersForConfigQueryVariables>;
export const EventEmailTemplatesListDocument = gql`
    query EventEmailTemplatesList($where: EventEmailTemplateReturnDtoFilterInput, $order: [EventEmailTemplateReturnDtoSortInput!], $skip: Int, $take: Int) {
  eventEmailTemplates(where: $where, order: $order, skip: $skip, take: $take) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    items {
      id
      eventId
      language
      subject
      body
    }
  }
}
    `;
export function useEventEmailTemplatesListQuery(baseOptions?: Apollo.QueryHookOptions<EventEmailTemplatesListQuery, EventEmailTemplatesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventEmailTemplatesListQuery, EventEmailTemplatesListQueryVariables>(EventEmailTemplatesListDocument, options);
      }
export function useEventEmailTemplatesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventEmailTemplatesListQuery, EventEmailTemplatesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventEmailTemplatesListQuery, EventEmailTemplatesListQueryVariables>(EventEmailTemplatesListDocument, options);
        }
export type EventEmailTemplatesListQueryHookResult = ReturnType<typeof useEventEmailTemplatesListQuery>;
export type EventEmailTemplatesListLazyQueryHookResult = ReturnType<typeof useEventEmailTemplatesListLazyQuery>;
export type EventEmailTemplatesListQueryResult = Apollo.QueryResult<EventEmailTemplatesListQuery, EventEmailTemplatesListQueryVariables>;
export const EventFeePricesListDocument = gql`
    query EventFeePricesList($where: EventFeePriceReturnDtoFilterInput, $order: [EventFeePriceReturnDtoSortInput!], $skip: Int, $take: Int) {
  eventFeePrices(where: $where, order: $order, skip: $skip, take: $take) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    items {
      id
      feeTypeId
      pricePeriodId
      amount
    }
  }
}
    `;
export function useEventFeePricesListQuery(baseOptions?: Apollo.QueryHookOptions<EventFeePricesListQuery, EventFeePricesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventFeePricesListQuery, EventFeePricesListQueryVariables>(EventFeePricesListDocument, options);
      }
export function useEventFeePricesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventFeePricesListQuery, EventFeePricesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventFeePricesListQuery, EventFeePricesListQueryVariables>(EventFeePricesListDocument, options);
        }
export type EventFeePricesListQueryHookResult = ReturnType<typeof useEventFeePricesListQuery>;
export type EventFeePricesListLazyQueryHookResult = ReturnType<typeof useEventFeePricesListLazyQuery>;
export type EventFeePricesListQueryResult = Apollo.QueryResult<EventFeePricesListQuery, EventFeePricesListQueryVariables>;
export const EventFeeTypesListDocument = gql`
    query EventFeeTypesList($where: EventFeeTypeReturnDtoFilterInput, $order: [EventFeeTypeReturnDtoSortInput!], $skip: Int, $take: Int) {
  eventFeeTypes(where: $where, order: $order, skip: $skip, take: $take) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    items {
      id
      eventId
      labelHr
      labelEn
      isFree
      isSponsored
      isPublicRegistrationHidden
      requiresParticipantTypeProof
    }
  }
}
    `;
export function useEventFeeTypesListQuery(baseOptions?: Apollo.QueryHookOptions<EventFeeTypesListQuery, EventFeeTypesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventFeeTypesListQuery, EventFeeTypesListQueryVariables>(EventFeeTypesListDocument, options);
      }
export function useEventFeeTypesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventFeeTypesListQuery, EventFeeTypesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventFeeTypesListQuery, EventFeeTypesListQueryVariables>(EventFeeTypesListDocument, options);
        }
export type EventFeeTypesListQueryHookResult = ReturnType<typeof useEventFeeTypesListQuery>;
export type EventFeeTypesListLazyQueryHookResult = ReturnType<typeof useEventFeeTypesListLazyQuery>;
export type EventFeeTypesListQueryResult = Apollo.QueryResult<EventFeeTypesListQuery, EventFeeTypesListQueryVariables>;
export const EventHotelsListDocument = gql`
    query EventHotelsList($where: EventHotelReturnDtoFilterInput, $order: [EventHotelReturnDtoSortInput!], $skip: Int, $take: Int) {
  eventHotels(where: $where, order: $order, skip: $skip, take: $take) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    items {
      id
      eventId
      name
      category
      address
      city
      country
      notes
    }
  }
}
    `;
export function useEventHotelsListQuery(baseOptions?: Apollo.QueryHookOptions<EventHotelsListQuery, EventHotelsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventHotelsListQuery, EventHotelsListQueryVariables>(EventHotelsListDocument, options);
      }
export function useEventHotelsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventHotelsListQuery, EventHotelsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventHotelsListQuery, EventHotelsListQueryVariables>(EventHotelsListDocument, options);
        }
export type EventHotelsListQueryHookResult = ReturnType<typeof useEventHotelsListQuery>;
export type EventHotelsListLazyQueryHookResult = ReturnType<typeof useEventHotelsListLazyQuery>;
export type EventHotelsListQueryResult = Apollo.QueryResult<EventHotelsListQuery, EventHotelsListQueryVariables>;
export const EventOptionsForConfigDocument = gql`
    query eventOptionsForConfig($where: EventOptionReturnDtoFilterInput, $order: [EventOptionReturnDtoSortInput!], $skip: Int, $take: Int) {
  eventOptions(where: $where, order: $order, skip: $skip, take: $take) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    items {
      id
      eventId
      labelHr
      labelEn
      descriptionHr
      descriptionEn
      vatRate
      conditionType
      categoryCodes
      dependsOnCode
      dependsOnValue
      questionType
      priceEffect
      price
      publicRegistrationEndDate
      tracksUsageOrAttendance
      allowedFeeTypeIds
      visibilityDependsOnEventOptionId
      visibilityDependsOnExpectedAnswer
      isActive
      choices {
        id
        value
        labelHr
        labelEn
        order
        isActive
      }
    }
  }
}
    `;
export function useEventOptionsForConfigQuery(baseOptions?: Apollo.QueryHookOptions<EventOptionsForConfigQuery, EventOptionsForConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventOptionsForConfigQuery, EventOptionsForConfigQueryVariables>(EventOptionsForConfigDocument, options);
      }
export function useEventOptionsForConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventOptionsForConfigQuery, EventOptionsForConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventOptionsForConfigQuery, EventOptionsForConfigQueryVariables>(EventOptionsForConfigDocument, options);
        }
export type EventOptionsForConfigQueryHookResult = ReturnType<typeof useEventOptionsForConfigQuery>;
export type EventOptionsForConfigLazyQueryHookResult = ReturnType<typeof useEventOptionsForConfigLazyQuery>;
export type EventOptionsForConfigQueryResult = Apollo.QueryResult<EventOptionsForConfigQuery, EventOptionsForConfigQueryVariables>;
export const EventOptionsListDocument = gql`
    query EventOptionsList($where: EventOptionReturnDtoFilterInput, $order: [EventOptionReturnDtoSortInput!], $skip: Int, $take: Int) {
  eventOptions(where: $where, order: $order, skip: $skip, take: $take) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    items {
      id
      eventId
      labelHr
      labelEn
      descriptionHr
      descriptionEn
      vatRate
      conditionType
      categoryCodes
      dependsOnCode
      dependsOnValue
      questionType
      priceEffect
      price
      publicRegistrationEndDate
      tracksUsageOrAttendance
      allowedFeeTypeIds
      visibilityDependsOnEventOptionId
      visibilityDependsOnExpectedAnswer
      isActive
    }
  }
}
    `;
export function useEventOptionsListQuery(baseOptions?: Apollo.QueryHookOptions<EventOptionsListQuery, EventOptionsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventOptionsListQuery, EventOptionsListQueryVariables>(EventOptionsListDocument, options);
      }
export function useEventOptionsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventOptionsListQuery, EventOptionsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventOptionsListQuery, EventOptionsListQueryVariables>(EventOptionsListDocument, options);
        }
export type EventOptionsListQueryHookResult = ReturnType<typeof useEventOptionsListQuery>;
export type EventOptionsListLazyQueryHookResult = ReturnType<typeof useEventOptionsListLazyQuery>;
export type EventOptionsListQueryResult = Apollo.QueryResult<EventOptionsListQuery, EventOptionsListQueryVariables>;
export const EventPaymentMethodsDocument = gql`
    query eventPaymentMethods($eventId: Int!) {
  eventPaymentMethods(where: {eventId: {eq: $eventId}}, take: 20) {
    items {
      id
      eventId
      category
      bankTransferAllowed
      cardAllowed
      posAllowed
    }
    totalCount
  }
}
    `;
export function useEventPaymentMethodsQuery(baseOptions: Apollo.QueryHookOptions<EventPaymentMethodsQuery, EventPaymentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventPaymentMethodsQuery, EventPaymentMethodsQueryVariables>(EventPaymentMethodsDocument, options);
      }
export function useEventPaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventPaymentMethodsQuery, EventPaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventPaymentMethodsQuery, EventPaymentMethodsQueryVariables>(EventPaymentMethodsDocument, options);
        }
export type EventPaymentMethodsQueryHookResult = ReturnType<typeof useEventPaymentMethodsQuery>;
export type EventPaymentMethodsLazyQueryHookResult = ReturnType<typeof useEventPaymentMethodsLazyQuery>;
export type EventPaymentMethodsQueryResult = Apollo.QueryResult<EventPaymentMethodsQuery, EventPaymentMethodsQueryVariables>;
export const EventPricePeriodsListDocument = gql`
    query EventPricePeriodsList($where: EventPricePeriodReturnDtoFilterInput, $order: [EventPricePeriodReturnDtoSortInput!], $skip: Int, $take: Int) {
  eventPricePeriods(where: $where, order: $order, skip: $skip, take: $take) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    items {
      id
      eventId
      name
      code
      startDate
      endDate
    }
  }
}
    `;
export function useEventPricePeriodsListQuery(baseOptions?: Apollo.QueryHookOptions<EventPricePeriodsListQuery, EventPricePeriodsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventPricePeriodsListQuery, EventPricePeriodsListQueryVariables>(EventPricePeriodsListDocument, options);
      }
export function useEventPricePeriodsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventPricePeriodsListQuery, EventPricePeriodsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventPricePeriodsListQuery, EventPricePeriodsListQueryVariables>(EventPricePeriodsListDocument, options);
        }
export type EventPricePeriodsListQueryHookResult = ReturnType<typeof useEventPricePeriodsListQuery>;
export type EventPricePeriodsListLazyQueryHookResult = ReturnType<typeof useEventPricePeriodsListLazyQuery>;
export type EventPricePeriodsListQueryResult = Apollo.QueryResult<EventPricePeriodsListQuery, EventPricePeriodsListQueryVariables>;
export const EventRoomAllotmentsListDocument = gql`
    query EventRoomAllotmentsList($where: EventRoomAllotmentReturnDtoFilterInput, $order: [EventRoomAllotmentReturnDtoSortInput!], $skip: Int, $take: Int) {
  eventRoomAllotments(where: $where, order: $order, skip: $skip, take: $take) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    items {
      id
      hotelId
      roomTypeId
      startDate
      endDate
      totalRooms
      paymentDeadline
    }
  }
}
    `;
export function useEventRoomAllotmentsListQuery(baseOptions?: Apollo.QueryHookOptions<EventRoomAllotmentsListQuery, EventRoomAllotmentsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventRoomAllotmentsListQuery, EventRoomAllotmentsListQueryVariables>(EventRoomAllotmentsListDocument, options);
      }
export function useEventRoomAllotmentsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventRoomAllotmentsListQuery, EventRoomAllotmentsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventRoomAllotmentsListQuery, EventRoomAllotmentsListQueryVariables>(EventRoomAllotmentsListDocument, options);
        }
export type EventRoomAllotmentsListQueryHookResult = ReturnType<typeof useEventRoomAllotmentsListQuery>;
export type EventRoomAllotmentsListLazyQueryHookResult = ReturnType<typeof useEventRoomAllotmentsListLazyQuery>;
export type EventRoomAllotmentsListQueryResult = Apollo.QueryResult<EventRoomAllotmentsListQuery, EventRoomAllotmentsListQueryVariables>;
export const EventRoomTypesListDocument = gql`
    query EventRoomTypesList($where: EventRoomTypeReturnDtoFilterInput, $order: [EventRoomTypeReturnDtoSortInput!], $skip: Int, $take: Int) {
  eventRoomTypes(where: $where, order: $order, skip: $skip, take: $take) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    items {
      id
      hotelId
      name
      capacity
      pricePerNight
      vatRate
      description
      reservationCount
    }
  }
}
    `;
export function useEventRoomTypesListQuery(baseOptions?: Apollo.QueryHookOptions<EventRoomTypesListQuery, EventRoomTypesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventRoomTypesListQuery, EventRoomTypesListQueryVariables>(EventRoomTypesListDocument, options);
      }
export function useEventRoomTypesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventRoomTypesListQuery, EventRoomTypesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventRoomTypesListQuery, EventRoomTypesListQueryVariables>(EventRoomTypesListDocument, options);
        }
export type EventRoomTypesListQueryHookResult = ReturnType<typeof useEventRoomTypesListQuery>;
export type EventRoomTypesListLazyQueryHookResult = ReturnType<typeof useEventRoomTypesListLazyQuery>;
export type EventRoomTypesListQueryResult = Apollo.QueryResult<EventRoomTypesListQuery, EventRoomTypesListQueryVariables>;
export const EventTaxSettingsListDocument = gql`
    query EventTaxSettingsList($where: EventTaxSettingReturnDtoFilterInput, $order: [EventTaxSettingReturnDtoSortInput!], $skip: Int, $take: Int) {
  eventTaxSettings(where: $where, order: $order, skip: $skip, take: $take) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    items {
      id
      eventId
      registrationVatRate
      accommodationVatRate
      accommodationTaxScheme
    }
  }
}
    `;
export function useEventTaxSettingsListQuery(baseOptions?: Apollo.QueryHookOptions<EventTaxSettingsListQuery, EventTaxSettingsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventTaxSettingsListQuery, EventTaxSettingsListQueryVariables>(EventTaxSettingsListDocument, options);
      }
export function useEventTaxSettingsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventTaxSettingsListQuery, EventTaxSettingsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventTaxSettingsListQuery, EventTaxSettingsListQueryVariables>(EventTaxSettingsListDocument, options);
        }
export type EventTaxSettingsListQueryHookResult = ReturnType<typeof useEventTaxSettingsListQuery>;
export type EventTaxSettingsListLazyQueryHookResult = ReturnType<typeof useEventTaxSettingsListLazyQuery>;
export type EventTaxSettingsListQueryResult = Apollo.QueryResult<EventTaxSettingsListQuery, EventTaxSettingsListQueryVariables>;
export const GrantEventAccessForConfigDocument = gql`
    mutation grantEventAccessForConfig($input: EventAccessGrantDtoInput!) {
  grantEventAccess(input: $input)
}
    `;
export type GrantEventAccessForConfigMutationFn = Apollo.MutationFunction<GrantEventAccessForConfigMutation, GrantEventAccessForConfigMutationVariables>;
export function useGrantEventAccessForConfigMutation(baseOptions?: Apollo.MutationHookOptions<GrantEventAccessForConfigMutation, GrantEventAccessForConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GrantEventAccessForConfigMutation, GrantEventAccessForConfigMutationVariables>(GrantEventAccessForConfigDocument, options);
      }
export type GrantEventAccessForConfigMutationHookResult = ReturnType<typeof useGrantEventAccessForConfigMutation>;
export type GrantEventAccessForConfigMutationResult = Apollo.MutationResult<GrantEventAccessForConfigMutation>;
export type GrantEventAccessForConfigMutationOptions = Apollo.BaseMutationOptions<GrantEventAccessForConfigMutation, GrantEventAccessForConfigMutationVariables>;
export const RevokeEventAccessForConfigDocument = gql`
    mutation revokeEventAccessForConfig($input: EventAccessGrantDtoInput!) {
  revokeEventAccess(input: $input)
}
    `;
export type RevokeEventAccessForConfigMutationFn = Apollo.MutationFunction<RevokeEventAccessForConfigMutation, RevokeEventAccessForConfigMutationVariables>;
export function useRevokeEventAccessForConfigMutation(baseOptions?: Apollo.MutationHookOptions<RevokeEventAccessForConfigMutation, RevokeEventAccessForConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeEventAccessForConfigMutation, RevokeEventAccessForConfigMutationVariables>(RevokeEventAccessForConfigDocument, options);
      }
export type RevokeEventAccessForConfigMutationHookResult = ReturnType<typeof useRevokeEventAccessForConfigMutation>;
export type RevokeEventAccessForConfigMutationResult = Apollo.MutationResult<RevokeEventAccessForConfigMutation>;
export type RevokeEventAccessForConfigMutationOptions = Apollo.BaseMutationOptions<RevokeEventAccessForConfigMutation, RevokeEventAccessForConfigMutationVariables>;
export const SaveAccommodationOptionDocument = gql`
    mutation saveAccommodationOption($input: SaveAccommodationOptionDtoInput!) {
  saveAccommodationOption(input: $input)
}
    `;
export type SaveAccommodationOptionMutationFn = Apollo.MutationFunction<SaveAccommodationOptionMutation, SaveAccommodationOptionMutationVariables>;
export function useSaveAccommodationOptionMutation(baseOptions?: Apollo.MutationHookOptions<SaveAccommodationOptionMutation, SaveAccommodationOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAccommodationOptionMutation, SaveAccommodationOptionMutationVariables>(SaveAccommodationOptionDocument, options);
      }
export type SaveAccommodationOptionMutationHookResult = ReturnType<typeof useSaveAccommodationOptionMutation>;
export type SaveAccommodationOptionMutationResult = Apollo.MutationResult<SaveAccommodationOptionMutation>;
export type SaveAccommodationOptionMutationOptions = Apollo.BaseMutationOptions<SaveAccommodationOptionMutation, SaveAccommodationOptionMutationVariables>;
export const UpdateEventEmailTemplateDocument = gql`
    mutation UpdateEventEmailTemplate($input: EventEmailTemplateUpdateDtoInput!) {
  updateEventEmailTemplate(input: $input) {
    id
    eventId
    language
    subject
    body
  }
}
    `;
export type UpdateEventEmailTemplateMutationFn = Apollo.MutationFunction<UpdateEventEmailTemplateMutation, UpdateEventEmailTemplateMutationVariables>;
export function useUpdateEventEmailTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventEmailTemplateMutation, UpdateEventEmailTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventEmailTemplateMutation, UpdateEventEmailTemplateMutationVariables>(UpdateEventEmailTemplateDocument, options);
      }
export type UpdateEventEmailTemplateMutationHookResult = ReturnType<typeof useUpdateEventEmailTemplateMutation>;
export type UpdateEventEmailTemplateMutationResult = Apollo.MutationResult<UpdateEventEmailTemplateMutation>;
export type UpdateEventEmailTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateEventEmailTemplateMutation, UpdateEventEmailTemplateMutationVariables>;
export const UpdateEventFeePriceDocument = gql`
    mutation UpdateEventFeePrice($input: EventFeePriceUpdateDtoInput!) {
  updateEventFeePrice(input: $input) {
    id
    feeTypeId
    pricePeriodId
    amount
  }
}
    `;
export type UpdateEventFeePriceMutationFn = Apollo.MutationFunction<UpdateEventFeePriceMutation, UpdateEventFeePriceMutationVariables>;
export function useUpdateEventFeePriceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventFeePriceMutation, UpdateEventFeePriceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventFeePriceMutation, UpdateEventFeePriceMutationVariables>(UpdateEventFeePriceDocument, options);
      }
export type UpdateEventFeePriceMutationHookResult = ReturnType<typeof useUpdateEventFeePriceMutation>;
export type UpdateEventFeePriceMutationResult = Apollo.MutationResult<UpdateEventFeePriceMutation>;
export type UpdateEventFeePriceMutationOptions = Apollo.BaseMutationOptions<UpdateEventFeePriceMutation, UpdateEventFeePriceMutationVariables>;
export const UpdateEventFeeTypeDocument = gql`
    mutation UpdateEventFeeType($input: EventFeeTypeUpdateDtoInput!) {
  updateEventFeeType(input: $input) {
    id
    eventId
    labelHr
    labelEn
    isFree
    isSponsored
    isPublicRegistrationHidden
    requiresParticipantTypeProof
  }
}
    `;
export type UpdateEventFeeTypeMutationFn = Apollo.MutationFunction<UpdateEventFeeTypeMutation, UpdateEventFeeTypeMutationVariables>;
export function useUpdateEventFeeTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventFeeTypeMutation, UpdateEventFeeTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventFeeTypeMutation, UpdateEventFeeTypeMutationVariables>(UpdateEventFeeTypeDocument, options);
      }
export type UpdateEventFeeTypeMutationHookResult = ReturnType<typeof useUpdateEventFeeTypeMutation>;
export type UpdateEventFeeTypeMutationResult = Apollo.MutationResult<UpdateEventFeeTypeMutation>;
export type UpdateEventFeeTypeMutationOptions = Apollo.BaseMutationOptions<UpdateEventFeeTypeMutation, UpdateEventFeeTypeMutationVariables>;
export const UpdateEventOptionDocument = gql`
    mutation UpdateEventOption($input: EventOptionUpdateDtoInput!) {
  updateEventOption(input: $input) {
    id
    eventId
    labelHr
    labelEn
    vatRate
    questionType
    price
    publicRegistrationEndDate
    tracksUsageOrAttendance
    allowedFeeTypeIds
    visibilityDependsOnEventOptionId
    visibilityDependsOnExpectedAnswer
    isActive
  }
}
    `;
export type UpdateEventOptionMutationFn = Apollo.MutationFunction<UpdateEventOptionMutation, UpdateEventOptionMutationVariables>;
export function useUpdateEventOptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventOptionMutation, UpdateEventOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventOptionMutation, UpdateEventOptionMutationVariables>(UpdateEventOptionDocument, options);
      }
export type UpdateEventOptionMutationHookResult = ReturnType<typeof useUpdateEventOptionMutation>;
export type UpdateEventOptionMutationResult = Apollo.MutationResult<UpdateEventOptionMutation>;
export type UpdateEventOptionMutationOptions = Apollo.BaseMutationOptions<UpdateEventOptionMutation, UpdateEventOptionMutationVariables>;
export const UpdateEventPaymentMethodForConfigDocument = gql`
    mutation updateEventPaymentMethodForConfig($input: EventPaymentMethodUpdateDtoInput!) {
  updateEventPaymentMethod(input: $input) {
    id
    eventId
    category
    bankTransferAllowed
    cardAllowed
    posAllowed
  }
}
    `;
export type UpdateEventPaymentMethodForConfigMutationFn = Apollo.MutationFunction<UpdateEventPaymentMethodForConfigMutation, UpdateEventPaymentMethodForConfigMutationVariables>;
export function useUpdateEventPaymentMethodForConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventPaymentMethodForConfigMutation, UpdateEventPaymentMethodForConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventPaymentMethodForConfigMutation, UpdateEventPaymentMethodForConfigMutationVariables>(UpdateEventPaymentMethodForConfigDocument, options);
      }
export type UpdateEventPaymentMethodForConfigMutationHookResult = ReturnType<typeof useUpdateEventPaymentMethodForConfigMutation>;
export type UpdateEventPaymentMethodForConfigMutationResult = Apollo.MutationResult<UpdateEventPaymentMethodForConfigMutation>;
export type UpdateEventPaymentMethodForConfigMutationOptions = Apollo.BaseMutationOptions<UpdateEventPaymentMethodForConfigMutation, UpdateEventPaymentMethodForConfigMutationVariables>;
export const UpdateEventPricePeriodDocument = gql`
    mutation UpdateEventPricePeriod($input: EventPricePeriodUpdateDtoInput!) {
  updateEventPricePeriod(input: $input) {
    id
    eventId
    name
    code
    startDate
    endDate
  }
}
    `;
export type UpdateEventPricePeriodMutationFn = Apollo.MutationFunction<UpdateEventPricePeriodMutation, UpdateEventPricePeriodMutationVariables>;
export function useUpdateEventPricePeriodMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventPricePeriodMutation, UpdateEventPricePeriodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventPricePeriodMutation, UpdateEventPricePeriodMutationVariables>(UpdateEventPricePeriodDocument, options);
      }
export type UpdateEventPricePeriodMutationHookResult = ReturnType<typeof useUpdateEventPricePeriodMutation>;
export type UpdateEventPricePeriodMutationResult = Apollo.MutationResult<UpdateEventPricePeriodMutation>;
export type UpdateEventPricePeriodMutationOptions = Apollo.BaseMutationOptions<UpdateEventPricePeriodMutation, UpdateEventPricePeriodMutationVariables>;
export const UpdateEventTaxSettingDocument = gql`
    mutation UpdateEventTaxSetting($input: EventTaxSettingUpdateDtoInput!) {
  updateEventTaxSetting(input: $input) {
    id
    eventId
    registrationVatRate
    accommodationVatRate
    accommodationTaxScheme
  }
}
    `;
export type UpdateEventTaxSettingMutationFn = Apollo.MutationFunction<UpdateEventTaxSettingMutation, UpdateEventTaxSettingMutationVariables>;
export function useUpdateEventTaxSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventTaxSettingMutation, UpdateEventTaxSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventTaxSettingMutation, UpdateEventTaxSettingMutationVariables>(UpdateEventTaxSettingDocument, options);
      }
export type UpdateEventTaxSettingMutationHookResult = ReturnType<typeof useUpdateEventTaxSettingMutation>;
export type UpdateEventTaxSettingMutationResult = Apollo.MutationResult<UpdateEventTaxSettingMutation>;
export type UpdateEventTaxSettingMutationOptions = Apollo.BaseMutationOptions<UpdateEventTaxSettingMutation, UpdateEventTaxSettingMutationVariables>;
export const ActivateEventRegistrationFormTemplateDocument = gql`
    mutation ActivateEventRegistrationFormTemplate($input: EventRegistrationFormArbitraryFieldsTemplateDeleteDtoInput!) {
  activateEventRegistrationFormArbitraryFieldsTemplate(input: $input) {
    id
    eventId
    status
    version
  }
}
    `;
export type ActivateEventRegistrationFormTemplateMutationFn = Apollo.MutationFunction<ActivateEventRegistrationFormTemplateMutation, ActivateEventRegistrationFormTemplateMutationVariables>;
export function useActivateEventRegistrationFormTemplateMutation(baseOptions?: Apollo.MutationHookOptions<ActivateEventRegistrationFormTemplateMutation, ActivateEventRegistrationFormTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateEventRegistrationFormTemplateMutation, ActivateEventRegistrationFormTemplateMutationVariables>(ActivateEventRegistrationFormTemplateDocument, options);
      }
export type ActivateEventRegistrationFormTemplateMutationHookResult = ReturnType<typeof useActivateEventRegistrationFormTemplateMutation>;
export type ActivateEventRegistrationFormTemplateMutationResult = Apollo.MutationResult<ActivateEventRegistrationFormTemplateMutation>;
export type ActivateEventRegistrationFormTemplateMutationOptions = Apollo.BaseMutationOptions<ActivateEventRegistrationFormTemplateMutation, ActivateEventRegistrationFormTemplateMutationVariables>;
export const CreateBasicEventRegistrationFormTemplateDocument = gql`
    mutation CreateBasicEventRegistrationFormTemplate($input: EventRegistrationFormArbitraryFieldsTemplateCreateDtoInput!) {
  createEventRegistrationFormArbitraryFieldsTemplate(input: $input) {
    id
    eventId
    status
    version
  }
}
    `;
export type CreateBasicEventRegistrationFormTemplateMutationFn = Apollo.MutationFunction<CreateBasicEventRegistrationFormTemplateMutation, CreateBasicEventRegistrationFormTemplateMutationVariables>;
export function useCreateBasicEventRegistrationFormTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateBasicEventRegistrationFormTemplateMutation, CreateBasicEventRegistrationFormTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBasicEventRegistrationFormTemplateMutation, CreateBasicEventRegistrationFormTemplateMutationVariables>(CreateBasicEventRegistrationFormTemplateDocument, options);
      }
export type CreateBasicEventRegistrationFormTemplateMutationHookResult = ReturnType<typeof useCreateBasicEventRegistrationFormTemplateMutation>;
export type CreateBasicEventRegistrationFormTemplateMutationResult = Apollo.MutationResult<CreateBasicEventRegistrationFormTemplateMutation>;
export type CreateBasicEventRegistrationFormTemplateMutationOptions = Apollo.BaseMutationOptions<CreateBasicEventRegistrationFormTemplateMutation, CreateBasicEventRegistrationFormTemplateMutationVariables>;
export const EventRegistrationFormTemplatesForSetupDocument = gql`
    query EventRegistrationFormTemplatesForSetup($eventId: Int!) {
  eventRegistrationFormArbitraryFieldsTemplates(
    where: {eventId: {eq: $eventId}}
    order: [{version: DESC}]
    take: 100
  ) {
    items {
      id
      eventId
      status
      version
    }
  }
}
    `;
export function useEventRegistrationFormTemplatesForSetupQuery(baseOptions: Apollo.QueryHookOptions<EventRegistrationFormTemplatesForSetupQuery, EventRegistrationFormTemplatesForSetupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventRegistrationFormTemplatesForSetupQuery, EventRegistrationFormTemplatesForSetupQueryVariables>(EventRegistrationFormTemplatesForSetupDocument, options);
      }
export function useEventRegistrationFormTemplatesForSetupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventRegistrationFormTemplatesForSetupQuery, EventRegistrationFormTemplatesForSetupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventRegistrationFormTemplatesForSetupQuery, EventRegistrationFormTemplatesForSetupQueryVariables>(EventRegistrationFormTemplatesForSetupDocument, options);
        }
export type EventRegistrationFormTemplatesForSetupQueryHookResult = ReturnType<typeof useEventRegistrationFormTemplatesForSetupQuery>;
export type EventRegistrationFormTemplatesForSetupLazyQueryHookResult = ReturnType<typeof useEventRegistrationFormTemplatesForSetupLazyQuery>;
export type EventRegistrationFormTemplatesForSetupQueryResult = Apollo.QueryResult<EventRegistrationFormTemplatesForSetupQuery, EventRegistrationFormTemplatesForSetupQueryVariables>;
export const ArchivedEventsDocument = gql`
    query ArchivedEvents($skip: Int, $take: Int, $order: [ArchivedEventReturnDtoSortInput!]) {
  archivedEvents(skip: $skip, take: $take, order: $order) {
    items {
      id
      code
      name
      nameHr
      nameEn
      place
      startDate
      endDate
      lifecycleStatus
      archivedAt
      participantCount
      reservationCount
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;
export function useArchivedEventsQuery(baseOptions?: Apollo.QueryHookOptions<ArchivedEventsQuery, ArchivedEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArchivedEventsQuery, ArchivedEventsQueryVariables>(ArchivedEventsDocument, options);
      }
export function useArchivedEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArchivedEventsQuery, ArchivedEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArchivedEventsQuery, ArchivedEventsQueryVariables>(ArchivedEventsDocument, options);
        }
export type ArchivedEventsQueryHookResult = ReturnType<typeof useArchivedEventsQuery>;
export type ArchivedEventsLazyQueryHookResult = ReturnType<typeof useArchivedEventsLazyQuery>;
export type ArchivedEventsQueryResult = Apollo.QueryResult<ArchivedEventsQuery, ArchivedEventsQueryVariables>;
export const EventsPageEventsDocument = gql`
    query EventsPageEvents($where: EventReturnDtoFilterInput, $order: [EventReturnDtoSortInput!], $skip: Int, $take: Int) {
  events(where: $where, order: $order, skip: $skip, take: $take) {
    items {
      id
      code
      name
      nameHr
      nameEn
      place
      startDate
      endDate
      lifecycleStatus
      arbitraryFieldsTemplateId
      participantCount
      reservationCount
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;
export function useEventsPageEventsQuery(baseOptions?: Apollo.QueryHookOptions<EventsPageEventsQuery, EventsPageEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsPageEventsQuery, EventsPageEventsQueryVariables>(EventsPageEventsDocument, options);
      }
export function useEventsPageEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsPageEventsQuery, EventsPageEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsPageEventsQuery, EventsPageEventsQueryVariables>(EventsPageEventsDocument, options);
        }
export type EventsPageEventsQueryHookResult = ReturnType<typeof useEventsPageEventsQuery>;
export type EventsPageEventsLazyQueryHookResult = ReturnType<typeof useEventsPageEventsLazyQuery>;
export type EventsPageEventsQueryResult = Apollo.QueryResult<EventsPageEventsQuery, EventsPageEventsQueryVariables>;
export const ActivateEventActionDocument = gql`
    mutation activateEventAction($input: EventDeleteDtoInput!) {
  activateEvent(input: $input) {
    id
  }
}
    `;
export type ActivateEventActionMutationFn = Apollo.MutationFunction<ActivateEventActionMutation, ActivateEventActionMutationVariables>;
export function useActivateEventActionMutation(baseOptions?: Apollo.MutationHookOptions<ActivateEventActionMutation, ActivateEventActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateEventActionMutation, ActivateEventActionMutationVariables>(ActivateEventActionDocument, options);
      }
export type ActivateEventActionMutationHookResult = ReturnType<typeof useActivateEventActionMutation>;
export type ActivateEventActionMutationResult = Apollo.MutationResult<ActivateEventActionMutation>;
export type ActivateEventActionMutationOptions = Apollo.BaseMutationOptions<ActivateEventActionMutation, ActivateEventActionMutationVariables>;
export const ArchiveEventActionDocument = gql`
    mutation archiveEventAction($input: EventDeleteDtoInput!) {
  deleteEvent(input: $input)
}
    `;
export type ArchiveEventActionMutationFn = Apollo.MutationFunction<ArchiveEventActionMutation, ArchiveEventActionMutationVariables>;
export function useArchiveEventActionMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveEventActionMutation, ArchiveEventActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveEventActionMutation, ArchiveEventActionMutationVariables>(ArchiveEventActionDocument, options);
      }
export type ArchiveEventActionMutationHookResult = ReturnType<typeof useArchiveEventActionMutation>;
export type ArchiveEventActionMutationResult = Apollo.MutationResult<ArchiveEventActionMutation>;
export type ArchiveEventActionMutationOptions = Apollo.BaseMutationOptions<ArchiveEventActionMutation, ArchiveEventActionMutationVariables>;
export const CompleteEventActionDocument = gql`
    mutation completeEventAction($input: EventDeleteDtoInput!) {
  completeEvent(input: $input) {
    id
  }
}
    `;
export type CompleteEventActionMutationFn = Apollo.MutationFunction<CompleteEventActionMutation, CompleteEventActionMutationVariables>;
export function useCompleteEventActionMutation(baseOptions?: Apollo.MutationHookOptions<CompleteEventActionMutation, CompleteEventActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteEventActionMutation, CompleteEventActionMutationVariables>(CompleteEventActionDocument, options);
      }
export type CompleteEventActionMutationHookResult = ReturnType<typeof useCompleteEventActionMutation>;
export type CompleteEventActionMutationResult = Apollo.MutationResult<CompleteEventActionMutation>;
export type CompleteEventActionMutationOptions = Apollo.BaseMutationOptions<CompleteEventActionMutation, CompleteEventActionMutationVariables>;
export const CreateEventDocument = gql`
    mutation CreateEvent($input: EventCreateDtoInput!) {
  createEvent(input: $input) {
    id
    code
    name
    hasParticipationFee
    startDate
    endDate
  }
}
    `;
export type CreateEventMutationFn = Apollo.MutationFunction<CreateEventMutation, CreateEventMutationVariables>;
export function useCreateEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventMutation, CreateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventMutation, CreateEventMutationVariables>(CreateEventDocument, options);
      }
export type CreateEventMutationHookResult = ReturnType<typeof useCreateEventMutation>;
export type CreateEventMutationResult = Apollo.MutationResult<CreateEventMutation>;
export type CreateEventMutationOptions = Apollo.BaseMutationOptions<CreateEventMutation, CreateEventMutationVariables>;
export const DuplicateEventActionDocument = gql`
    mutation duplicateEventAction($input: EventCloneDtoInput!) {
  cloneEvent(input: $input) {
    id
  }
}
    `;
export type DuplicateEventActionMutationFn = Apollo.MutationFunction<DuplicateEventActionMutation, DuplicateEventActionMutationVariables>;
export function useDuplicateEventActionMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateEventActionMutation, DuplicateEventActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateEventActionMutation, DuplicateEventActionMutationVariables>(DuplicateEventActionDocument, options);
      }
export type DuplicateEventActionMutationHookResult = ReturnType<typeof useDuplicateEventActionMutation>;
export type DuplicateEventActionMutationResult = Apollo.MutationResult<DuplicateEventActionMutation>;
export type DuplicateEventActionMutationOptions = Apollo.BaseMutationOptions<DuplicateEventActionMutation, DuplicateEventActionMutationVariables>;
export const EventBasicSetupDocument = gql`
    query eventBasicSetup($id: Int!) {
  eventById(id: $id) {
    id
    code
    name
    nameHr
    nameEn
    place
    address
    eventInformationHr
    eventInformationEn
    onSiteRegistrationInstructionsHr
    onSiteRegistrationInstructionsEn
    hasParticipationFee
    startDate
    endDate
    lifecycleStatus
  }
}
    `;
export function useEventBasicSetupQuery(baseOptions: Apollo.QueryHookOptions<EventBasicSetupQuery, EventBasicSetupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventBasicSetupQuery, EventBasicSetupQueryVariables>(EventBasicSetupDocument, options);
      }
export function useEventBasicSetupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventBasicSetupQuery, EventBasicSetupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventBasicSetupQuery, EventBasicSetupQueryVariables>(EventBasicSetupDocument, options);
        }
export type EventBasicSetupQueryHookResult = ReturnType<typeof useEventBasicSetupQuery>;
export type EventBasicSetupLazyQueryHookResult = ReturnType<typeof useEventBasicSetupLazyQuery>;
export type EventBasicSetupQueryResult = Apollo.QueryResult<EventBasicSetupQuery, EventBasicSetupQueryVariables>;
export const EventBasicSetupBrandingDocument = gql`
    query eventBasicSetupBranding($eventId: Int!) {
  eventBrandings(where: {eventId: {eq: $eventId}}, take: 1) {
    items {
      id
      eventId
      logoUrl
      primaryColor
      secondaryColor
      publicAssetMode
      programPdfUrl
      venueLayoutImageUrl
      sponsorsImageUrl
      badgeTemplateUrl
      badgeBackTemplateUrl
      badgeFirstNameX
      badgeFirstNameY
      badgeLastNameX
      badgeLastNameY
      badgeCompanyX
      badgeCompanyY
      badgeQrCodeX
      badgeQrCodeY
      badgeTextFieldsJson
      headerImageUrl
      certificateTemplateUrl
      certificateParticipantNameX
      certificateParticipantNameY
      certificateTextFieldsJson
    }
    totalCount
  }
}
    `;
export function useEventBasicSetupBrandingQuery(baseOptions: Apollo.QueryHookOptions<EventBasicSetupBrandingQuery, EventBasicSetupBrandingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventBasicSetupBrandingQuery, EventBasicSetupBrandingQueryVariables>(EventBasicSetupBrandingDocument, options);
      }
export function useEventBasicSetupBrandingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventBasicSetupBrandingQuery, EventBasicSetupBrandingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventBasicSetupBrandingQuery, EventBasicSetupBrandingQueryVariables>(EventBasicSetupBrandingDocument, options);
        }
export type EventBasicSetupBrandingQueryHookResult = ReturnType<typeof useEventBasicSetupBrandingQuery>;
export type EventBasicSetupBrandingLazyQueryHookResult = ReturnType<typeof useEventBasicSetupBrandingLazyQuery>;
export type EventBasicSetupBrandingQueryResult = Apollo.QueryResult<EventBasicSetupBrandingQuery, EventBasicSetupBrandingQueryVariables>;
export const EventOverviewSummaryDocument = gql`
    query eventOverviewSummary($eventId: Int!, $trendRange: String, $trendGranularity: String) {
  overviewSummary: eventDashboardSummary(
    eventId: $eventId
    trendRange: $trendRange
    trendGranularity: $trendGranularity
  ) {
    eventId
    participants {
      participantCount
      registrationCount
    }
    payments {
      paidCount
      unpaidCount
      pendingCount
    }
    accommodation {
      reservationCount
      reservedRoomCount
    }
    certificates {
      readyOrSentCount
    }
    trend {
      rangeStartDate
      rangeEndDate
      points {
        date
        registrationCount
        reservationCount
      }
    }
  }
}
    `;
export function useEventOverviewSummaryQuery(baseOptions: Apollo.QueryHookOptions<EventOverviewSummaryQuery, EventOverviewSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventOverviewSummaryQuery, EventOverviewSummaryQueryVariables>(EventOverviewSummaryDocument, options);
      }
export function useEventOverviewSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventOverviewSummaryQuery, EventOverviewSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventOverviewSummaryQuery, EventOverviewSummaryQueryVariables>(EventOverviewSummaryDocument, options);
        }
export type EventOverviewSummaryQueryHookResult = ReturnType<typeof useEventOverviewSummaryQuery>;
export type EventOverviewSummaryLazyQueryHookResult = ReturnType<typeof useEventOverviewSummaryLazyQuery>;
export type EventOverviewSummaryQueryResult = Apollo.QueryResult<EventOverviewSummaryQuery, EventOverviewSummaryQueryVariables>;
export const EventTemplateSettingsDocument = gql`
    query eventTemplateSettings($id: Int!) {
  eventById(id: $id) {
    id
    code
    name
    nameHr
    nameEn
    place
    address
    eventInformationHr
    eventInformationEn
    onSiteRegistrationInstructionsHr
    onSiteRegistrationInstructionsEn
    hasParticipationFee
    startDate
    endDate
  }
  eventBrandings(where: {eventId: {eq: $id}}, take: 1) {
    items {
      id
      eventId
      logoUrl
      primaryColor
      secondaryColor
      publicAssetMode
      programPdfUrl
      venueLayoutImageUrl
      sponsorsImageUrl
      badgeTemplateUrl
      badgeBackTemplateUrl
      badgeFirstNameX
      badgeFirstNameY
      badgeLastNameX
      badgeLastNameY
      badgeCompanyX
      badgeCompanyY
      badgeQrCodeX
      badgeQrCodeY
      badgeTextFieldsJson
      headerImageUrl
      certificateTemplateUrl
      certificateParticipantNameX
      certificateParticipantNameY
      certificateTextFieldsJson
    }
    totalCount
  }
}
    `;
export function useEventTemplateSettingsQuery(baseOptions: Apollo.QueryHookOptions<EventTemplateSettingsQuery, EventTemplateSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventTemplateSettingsQuery, EventTemplateSettingsQueryVariables>(EventTemplateSettingsDocument, options);
      }
export function useEventTemplateSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventTemplateSettingsQuery, EventTemplateSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventTemplateSettingsQuery, EventTemplateSettingsQueryVariables>(EventTemplateSettingsDocument, options);
        }
export type EventTemplateSettingsQueryHookResult = ReturnType<typeof useEventTemplateSettingsQuery>;
export type EventTemplateSettingsLazyQueryHookResult = ReturnType<typeof useEventTemplateSettingsLazyQuery>;
export type EventTemplateSettingsQueryResult = Apollo.QueryResult<EventTemplateSettingsQuery, EventTemplateSettingsQueryVariables>;
export const EventsListDocument = gql`
    query EventsList($where: EventReturnDtoFilterInput, $order: [EventReturnDtoSortInput!], $skip: Int, $take: Int) {
  events(where: $where, order: $order, skip: $skip, take: $take) {
    items {
      id
      code
      name
      place
      hasParticipationFee
      startDate
      endDate
      arbitraryFieldsTemplateId
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;
export function useEventsListQuery(baseOptions?: Apollo.QueryHookOptions<EventsListQuery, EventsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsListQuery, EventsListQueryVariables>(EventsListDocument, options);
      }
export function useEventsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsListQuery, EventsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsListQuery, EventsListQueryVariables>(EventsListDocument, options);
        }
export type EventsListQueryHookResult = ReturnType<typeof useEventsListQuery>;
export type EventsListLazyQueryHookResult = ReturnType<typeof useEventsListLazyQuery>;
export type EventsListQueryResult = Apollo.QueryResult<EventsListQuery, EventsListQueryVariables>;
export const RestoreEventActionDocument = gql`
    mutation restoreEventAction($input: EventDeleteDtoInput!) {
  restoreEvent(input: $input) {
    id
  }
}
    `;
export type RestoreEventActionMutationFn = Apollo.MutationFunction<RestoreEventActionMutation, RestoreEventActionMutationVariables>;
export function useRestoreEventActionMutation(baseOptions?: Apollo.MutationHookOptions<RestoreEventActionMutation, RestoreEventActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreEventActionMutation, RestoreEventActionMutationVariables>(RestoreEventActionDocument, options);
      }
export type RestoreEventActionMutationHookResult = ReturnType<typeof useRestoreEventActionMutation>;
export type RestoreEventActionMutationResult = Apollo.MutationResult<RestoreEventActionMutation>;
export type RestoreEventActionMutationOptions = Apollo.BaseMutationOptions<RestoreEventActionMutation, RestoreEventActionMutationVariables>;
export const SaveEventBasicSetupForConfigDocument = gql`
    mutation saveEventBasicSetupForConfig($input: EventBasicSetupSaveDtoInput!) {
  saveEventBasicSetup(input: $input)
}
    `;
export type SaveEventBasicSetupForConfigMutationFn = Apollo.MutationFunction<SaveEventBasicSetupForConfigMutation, SaveEventBasicSetupForConfigMutationVariables>;
export function useSaveEventBasicSetupForConfigMutation(baseOptions?: Apollo.MutationHookOptions<SaveEventBasicSetupForConfigMutation, SaveEventBasicSetupForConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveEventBasicSetupForConfigMutation, SaveEventBasicSetupForConfigMutationVariables>(SaveEventBasicSetupForConfigDocument, options);
      }
export type SaveEventBasicSetupForConfigMutationHookResult = ReturnType<typeof useSaveEventBasicSetupForConfigMutation>;
export type SaveEventBasicSetupForConfigMutationResult = Apollo.MutationResult<SaveEventBasicSetupForConfigMutation>;
export type SaveEventBasicSetupForConfigMutationOptions = Apollo.BaseMutationOptions<SaveEventBasicSetupForConfigMutation, SaveEventBasicSetupForConfigMutationVariables>;
export const SaveEventBasicSetupFromWizardDocument = gql`
    mutation saveEventBasicSetupFromWizard($input: EventBasicSetupSaveDtoInput!) {
  saveEventBasicSetup(input: $input)
}
    `;
export type SaveEventBasicSetupFromWizardMutationFn = Apollo.MutationFunction<SaveEventBasicSetupFromWizardMutation, SaveEventBasicSetupFromWizardMutationVariables>;
export function useSaveEventBasicSetupFromWizardMutation(baseOptions?: Apollo.MutationHookOptions<SaveEventBasicSetupFromWizardMutation, SaveEventBasicSetupFromWizardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveEventBasicSetupFromWizardMutation, SaveEventBasicSetupFromWizardMutationVariables>(SaveEventBasicSetupFromWizardDocument, options);
      }
export type SaveEventBasicSetupFromWizardMutationHookResult = ReturnType<typeof useSaveEventBasicSetupFromWizardMutation>;
export type SaveEventBasicSetupFromWizardMutationResult = Apollo.MutationResult<SaveEventBasicSetupFromWizardMutation>;
export type SaveEventBasicSetupFromWizardMutationOptions = Apollo.BaseMutationOptions<SaveEventBasicSetupFromWizardMutation, SaveEventBasicSetupFromWizardMutationVariables>;
export const SaveEventTemplateSettingsDocument = gql`
    mutation saveEventTemplateSettings($input: EventBasicSetupSaveDtoInput!) {
  saveEventBasicSetup(input: $input)
}
    `;
export type SaveEventTemplateSettingsMutationFn = Apollo.MutationFunction<SaveEventTemplateSettingsMutation, SaveEventTemplateSettingsMutationVariables>;
export function useSaveEventTemplateSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveEventTemplateSettingsMutation, SaveEventTemplateSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveEventTemplateSettingsMutation, SaveEventTemplateSettingsMutationVariables>(SaveEventTemplateSettingsDocument, options);
      }
export type SaveEventTemplateSettingsMutationHookResult = ReturnType<typeof useSaveEventTemplateSettingsMutation>;
export type SaveEventTemplateSettingsMutationResult = Apollo.MutationResult<SaveEventTemplateSettingsMutation>;
export type SaveEventTemplateSettingsMutationOptions = Apollo.BaseMutationOptions<SaveEventTemplateSettingsMutation, SaveEventTemplateSettingsMutationVariables>;
export const HotelCatalogDocument = gql`
    query hotelCatalog($eventId: Int, $where: HotelIdentityCatalogItemDtoFilterInput, $skip: Int, $take: Int) {
  hotelIdentityCatalog(eventId: $eventId, where: $where, skip: $skip, take: $take) {
    totalCount
    items {
      id
      name
      category
      address
      city
      country
      notes
    }
  }
}
    `;
export function useHotelCatalogQuery(baseOptions?: Apollo.QueryHookOptions<HotelCatalogQuery, HotelCatalogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HotelCatalogQuery, HotelCatalogQueryVariables>(HotelCatalogDocument, options);
      }
export function useHotelCatalogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HotelCatalogQuery, HotelCatalogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HotelCatalogQuery, HotelCatalogQueryVariables>(HotelCatalogDocument, options);
        }
export type HotelCatalogQueryHookResult = ReturnType<typeof useHotelCatalogQuery>;
export type HotelCatalogLazyQueryHookResult = ReturnType<typeof useHotelCatalogLazyQuery>;
export type HotelCatalogQueryResult = Apollo.QueryResult<HotelCatalogQuery, HotelCatalogQueryVariables>;
export const CreateCatalogHotelDocument = gql`
    mutation createCatalogHotel($input: HotelIdentityCreateDtoInput!) {
  createHotelIdentity(input: $input) {
    id
    name
    category
    address
    city
    country
    notes
  }
}
    `;
export type CreateCatalogHotelMutationFn = Apollo.MutationFunction<CreateCatalogHotelMutation, CreateCatalogHotelMutationVariables>;
export function useCreateCatalogHotelMutation(baseOptions?: Apollo.MutationHookOptions<CreateCatalogHotelMutation, CreateCatalogHotelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCatalogHotelMutation, CreateCatalogHotelMutationVariables>(CreateCatalogHotelDocument, options);
      }
export type CreateCatalogHotelMutationHookResult = ReturnType<typeof useCreateCatalogHotelMutation>;
export type CreateCatalogHotelMutationResult = Apollo.MutationResult<CreateCatalogHotelMutation>;
export type CreateCatalogHotelMutationOptions = Apollo.BaseMutationOptions<CreateCatalogHotelMutation, CreateCatalogHotelMutationVariables>;
export const UpdateCatalogHotelDocument = gql`
    mutation updateCatalogHotel($input: HotelIdentityUpdateDtoInput!) {
  updateHotelIdentity(input: $input) {
    id
    name
    category
    address
    city
    country
    notes
  }
}
    `;
export type UpdateCatalogHotelMutationFn = Apollo.MutationFunction<UpdateCatalogHotelMutation, UpdateCatalogHotelMutationVariables>;
export function useUpdateCatalogHotelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCatalogHotelMutation, UpdateCatalogHotelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCatalogHotelMutation, UpdateCatalogHotelMutationVariables>(UpdateCatalogHotelDocument, options);
      }
export type UpdateCatalogHotelMutationHookResult = ReturnType<typeof useUpdateCatalogHotelMutation>;
export type UpdateCatalogHotelMutationResult = Apollo.MutationResult<UpdateCatalogHotelMutation>;
export type UpdateCatalogHotelMutationOptions = Apollo.BaseMutationOptions<UpdateCatalogHotelMutation, UpdateCatalogHotelMutationVariables>;
export const DeleteCatalogHotelDocument = gql`
    mutation deleteCatalogHotel($id: Int!) {
  deleteHotelIdentity(id: $id)
}
    `;
export type DeleteCatalogHotelMutationFn = Apollo.MutationFunction<DeleteCatalogHotelMutation, DeleteCatalogHotelMutationVariables>;
export function useDeleteCatalogHotelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCatalogHotelMutation, DeleteCatalogHotelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCatalogHotelMutation, DeleteCatalogHotelMutationVariables>(DeleteCatalogHotelDocument, options);
      }
export type DeleteCatalogHotelMutationHookResult = ReturnType<typeof useDeleteCatalogHotelMutation>;
export type DeleteCatalogHotelMutationResult = Apollo.MutationResult<DeleteCatalogHotelMutation>;
export type DeleteCatalogHotelMutationOptions = Apollo.BaseMutationOptions<DeleteCatalogHotelMutation, DeleteCatalogHotelMutationVariables>;
export const EventNotificationRecipientsDocument = gql`
    query eventNotificationRecipients($eventId: Int!) {
  eventNotificationRecipients(eventId: $eventId) {
    id
    participantId
    registrationId
    eventId
    registrationStatus
    firstName
    lastName
    email
    company
    phoneNumber
    linkedInUrl
    additionalInfo
    participationFeeTypeId
    participationFeeTypeLabelHr
    participationFeeTypeLabelEn
    participationFeePricePeriodName
  }
}
    `;
export function useEventNotificationRecipientsQuery(baseOptions: Apollo.QueryHookOptions<EventNotificationRecipientsQuery, EventNotificationRecipientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventNotificationRecipientsQuery, EventNotificationRecipientsQueryVariables>(EventNotificationRecipientsDocument, options);
      }
export function useEventNotificationRecipientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventNotificationRecipientsQuery, EventNotificationRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventNotificationRecipientsQuery, EventNotificationRecipientsQueryVariables>(EventNotificationRecipientsDocument, options);
        }
export type EventNotificationRecipientsQueryHookResult = ReturnType<typeof useEventNotificationRecipientsQuery>;
export type EventNotificationRecipientsLazyQueryHookResult = ReturnType<typeof useEventNotificationRecipientsLazyQuery>;
export type EventNotificationRecipientsQueryResult = Apollo.QueryResult<EventNotificationRecipientsQuery, EventNotificationRecipientsQueryVariables>;
export const EventNotificationTemplatesDocument = gql`
    query eventNotificationTemplates($eventId: Int!, $take: Int!, $skip: Int!) {
  eventEmailTemplates(
    where: {eventId: {eq: $eventId}}
    order: [{language: ASC}, {subject: ASC}, {id: ASC}]
    take: $take
    skip: $skip
  ) {
    items {
      id
      eventId
      language
      subject
      body
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;
export function useEventNotificationTemplatesQuery(baseOptions: Apollo.QueryHookOptions<EventNotificationTemplatesQuery, EventNotificationTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventNotificationTemplatesQuery, EventNotificationTemplatesQueryVariables>(EventNotificationTemplatesDocument, options);
      }
export function useEventNotificationTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventNotificationTemplatesQuery, EventNotificationTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventNotificationTemplatesQuery, EventNotificationTemplatesQueryVariables>(EventNotificationTemplatesDocument, options);
        }
export type EventNotificationTemplatesQueryHookResult = ReturnType<typeof useEventNotificationTemplatesQuery>;
export type EventNotificationTemplatesLazyQueryHookResult = ReturnType<typeof useEventNotificationTemplatesLazyQuery>;
export type EventNotificationTemplatesQueryResult = Apollo.QueryResult<EventNotificationTemplatesQuery, EventNotificationTemplatesQueryVariables>;
export const EventParticipantNotificationHistoryDocument = gql`
    query eventParticipantNotificationHistory($eventId: Int!, $take: Int, $skip: Int) {
  eventParticipantNotificationHistory(eventId: $eventId, take: $take, skip: $skip) {
    items {
      id
      registrationId
      participantId
      eventEmailTemplateId
      notificationChannel
      recipientEmail
      subject
      message
      replyToEmailsJson
      status
      createdAt
      sentAt
      failedAt
      failureMessage
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;
export function useEventParticipantNotificationHistoryQuery(baseOptions: Apollo.QueryHookOptions<EventParticipantNotificationHistoryQuery, EventParticipantNotificationHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventParticipantNotificationHistoryQuery, EventParticipantNotificationHistoryQueryVariables>(EventParticipantNotificationHistoryDocument, options);
      }
export function useEventParticipantNotificationHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventParticipantNotificationHistoryQuery, EventParticipantNotificationHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventParticipantNotificationHistoryQuery, EventParticipantNotificationHistoryQueryVariables>(EventParticipantNotificationHistoryDocument, options);
        }
export type EventParticipantNotificationHistoryQueryHookResult = ReturnType<typeof useEventParticipantNotificationHistoryQuery>;
export type EventParticipantNotificationHistoryLazyQueryHookResult = ReturnType<typeof useEventParticipantNotificationHistoryLazyQuery>;
export type EventParticipantNotificationHistoryQueryResult = Apollo.QueryResult<EventParticipantNotificationHistoryQuery, EventParticipantNotificationHistoryQueryVariables>;
export const RetryFailedEventRegistrationNotificationsDocument = gql`
    mutation retryFailedEventRegistrationNotifications($eventId: Int!, $notificationLogIds: [Int!]!) {
  retryFailedEventRegistrationNotifications(
    eventId: $eventId
    notificationLogIds: $notificationLogIds
  )
}
    `;
export type RetryFailedEventRegistrationNotificationsMutationFn = Apollo.MutationFunction<RetryFailedEventRegistrationNotificationsMutation, RetryFailedEventRegistrationNotificationsMutationVariables>;
export function useRetryFailedEventRegistrationNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<RetryFailedEventRegistrationNotificationsMutation, RetryFailedEventRegistrationNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryFailedEventRegistrationNotificationsMutation, RetryFailedEventRegistrationNotificationsMutationVariables>(RetryFailedEventRegistrationNotificationsDocument, options);
      }
export type RetryFailedEventRegistrationNotificationsMutationHookResult = ReturnType<typeof useRetryFailedEventRegistrationNotificationsMutation>;
export type RetryFailedEventRegistrationNotificationsMutationResult = Apollo.MutationResult<RetryFailedEventRegistrationNotificationsMutation>;
export type RetryFailedEventRegistrationNotificationsMutationOptions = Apollo.BaseMutationOptions<RetryFailedEventRegistrationNotificationsMutation, RetryFailedEventRegistrationNotificationsMutationVariables>;
export const SaveEventRegistrationNotificationDraftDocument = gql`
    mutation saveEventRegistrationNotificationDraft($input: EventRegistrationNotificationSendDtoInput!) {
  saveEventRegistrationNotificationDraft(input: $input) {
    eventId
    eventEmailTemplateId
    requestedCount
    queuedCount
    sentCount
    failedCount
    logs {
      id
      registrationId
      participantId
      recipientEmail
      status
      failureMessage
      createdAt
      sentAt
      failedAt
      notificationChannel
      subject
      message
    }
  }
}
    `;
export type SaveEventRegistrationNotificationDraftMutationFn = Apollo.MutationFunction<SaveEventRegistrationNotificationDraftMutation, SaveEventRegistrationNotificationDraftMutationVariables>;
export function useSaveEventRegistrationNotificationDraftMutation(baseOptions?: Apollo.MutationHookOptions<SaveEventRegistrationNotificationDraftMutation, SaveEventRegistrationNotificationDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveEventRegistrationNotificationDraftMutation, SaveEventRegistrationNotificationDraftMutationVariables>(SaveEventRegistrationNotificationDraftDocument, options);
      }
export type SaveEventRegistrationNotificationDraftMutationHookResult = ReturnType<typeof useSaveEventRegistrationNotificationDraftMutation>;
export type SaveEventRegistrationNotificationDraftMutationResult = Apollo.MutationResult<SaveEventRegistrationNotificationDraftMutation>;
export type SaveEventRegistrationNotificationDraftMutationOptions = Apollo.BaseMutationOptions<SaveEventRegistrationNotificationDraftMutation, SaveEventRegistrationNotificationDraftMutationVariables>;
export const SendEventRegistrationNotificationDocument = gql`
    mutation sendEventRegistrationNotification($input: EventRegistrationNotificationSendDtoInput!) {
  sendEventRegistrationNotification(input: $input) {
    eventId
    eventEmailTemplateId
    requestedCount
    queuedCount
    sentCount
    failedCount
    logs {
      id
      registrationId
      recipientEmail
      status
      failureMessage
      createdAt
      sentAt
      failedAt
      notificationChannel
      subject
      message
    }
  }
}
    `;
export type SendEventRegistrationNotificationMutationFn = Apollo.MutationFunction<SendEventRegistrationNotificationMutation, SendEventRegistrationNotificationMutationVariables>;
export function useSendEventRegistrationNotificationMutation(baseOptions?: Apollo.MutationHookOptions<SendEventRegistrationNotificationMutation, SendEventRegistrationNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendEventRegistrationNotificationMutation, SendEventRegistrationNotificationMutationVariables>(SendEventRegistrationNotificationDocument, options);
      }
export type SendEventRegistrationNotificationMutationHookResult = ReturnType<typeof useSendEventRegistrationNotificationMutation>;
export type SendEventRegistrationNotificationMutationResult = Apollo.MutationResult<SendEventRegistrationNotificationMutation>;
export type SendEventRegistrationNotificationMutationOptions = Apollo.BaseMutationOptions<SendEventRegistrationNotificationMutation, SendEventRegistrationNotificationMutationVariables>;
export const CreateOrganizationMemberDocument = gql`
    mutation createOrganizationMember($input: OrganizationMemberCreateDtoInput!) {
  createOrganizationMember(input: $input) {
    userId
    email
    userName
    firstName
    lastName
    phoneNumber
    role
    emailConfirmed
    hasPassword
    isPendingOnboarding
    onboardingEmailSent
    onboardingEmailStatus
    onboardingEmailQueuedAtUtc
    onboardingEmailLastSentAtUtc
    onboardingEmailLastFailedAtUtc
    onboardingEmailSentCount
    onboardingEmailFailureReason
  }
}
    `;
export type CreateOrganizationMemberMutationFn = Apollo.MutationFunction<CreateOrganizationMemberMutation, CreateOrganizationMemberMutationVariables>;
export function useCreateOrganizationMemberMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationMemberMutation, CreateOrganizationMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationMemberMutation, CreateOrganizationMemberMutationVariables>(CreateOrganizationMemberDocument, options);
      }
export type CreateOrganizationMemberMutationHookResult = ReturnType<typeof useCreateOrganizationMemberMutation>;
export type CreateOrganizationMemberMutationResult = Apollo.MutationResult<CreateOrganizationMemberMutation>;
export type CreateOrganizationMemberMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationMemberMutation, CreateOrganizationMemberMutationVariables>;
export const OrganizationMembersDocument = gql`
    query organizationMembers($take: Int!) {
  users(
    take: $take
    where: {and: [{isDeleted: {eq: false}}, {defaultRole: {in: [ADMINISTRATOR, USER]}}]}
    order: [{email: ASC}]
  ) {
    items {
      id
      email
      userName
      firstName
      lastName
      phoneNumber
      emailConfirmed
      isActive
      isDeleted
      defaultRole
      onboardingEmailStatus
      onboardingEmailQueuedAtUtc
      onboardingEmailLastSentAtUtc
      onboardingEmailLastFailedAtUtc
      onboardingEmailSentCount
      onboardingEmailFailureReason
    }
    totalCount
  }
}
    `;
export function useOrganizationMembersQuery(baseOptions: Apollo.QueryHookOptions<OrganizationMembersQuery, OrganizationMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationMembersQuery, OrganizationMembersQueryVariables>(OrganizationMembersDocument, options);
      }
export function useOrganizationMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationMembersQuery, OrganizationMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationMembersQuery, OrganizationMembersQueryVariables>(OrganizationMembersDocument, options);
        }
export type OrganizationMembersQueryHookResult = ReturnType<typeof useOrganizationMembersQuery>;
export type OrganizationMembersLazyQueryHookResult = ReturnType<typeof useOrganizationMembersLazyQuery>;
export type OrganizationMembersQueryResult = Apollo.QueryResult<OrganizationMembersQuery, OrganizationMembersQueryVariables>;
export const RemovePendingOrganizationMemberInviteDocument = gql`
    mutation removePendingOrganizationMemberInvite($input: OrganizationMemberPendingInviteRemoveDtoInput!) {
  removePendingOrganizationMemberInvite(input: $input) {
    userId
    email
    isActive
    isDeleted
    isPendingOnboarding
  }
}
    `;
export type RemovePendingOrganizationMemberInviteMutationFn = Apollo.MutationFunction<RemovePendingOrganizationMemberInviteMutation, RemovePendingOrganizationMemberInviteMutationVariables>;
export function useRemovePendingOrganizationMemberInviteMutation(baseOptions?: Apollo.MutationHookOptions<RemovePendingOrganizationMemberInviteMutation, RemovePendingOrganizationMemberInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePendingOrganizationMemberInviteMutation, RemovePendingOrganizationMemberInviteMutationVariables>(RemovePendingOrganizationMemberInviteDocument, options);
      }
export type RemovePendingOrganizationMemberInviteMutationHookResult = ReturnType<typeof useRemovePendingOrganizationMemberInviteMutation>;
export type RemovePendingOrganizationMemberInviteMutationResult = Apollo.MutationResult<RemovePendingOrganizationMemberInviteMutation>;
export type RemovePendingOrganizationMemberInviteMutationOptions = Apollo.BaseMutationOptions<RemovePendingOrganizationMemberInviteMutation, RemovePendingOrganizationMemberInviteMutationVariables>;
export const ResendOrganizationMemberOnboardingDocument = gql`
    mutation resendOrganizationMemberOnboarding($input: OrganizationMemberOnboardingResendDtoInput!) {
  resendOrganizationMemberOnboarding(input: $input) {
    userId
    email
    emailConfirmed
    hasPassword
    isPendingOnboarding
    onboardingEmailSent
    onboardingEmailStatus
    onboardingEmailQueuedAtUtc
    onboardingEmailLastSentAtUtc
    onboardingEmailLastFailedAtUtc
    onboardingEmailSentCount
    onboardingEmailFailureReason
  }
}
    `;
export type ResendOrganizationMemberOnboardingMutationFn = Apollo.MutationFunction<ResendOrganizationMemberOnboardingMutation, ResendOrganizationMemberOnboardingMutationVariables>;
export function useResendOrganizationMemberOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<ResendOrganizationMemberOnboardingMutation, ResendOrganizationMemberOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendOrganizationMemberOnboardingMutation, ResendOrganizationMemberOnboardingMutationVariables>(ResendOrganizationMemberOnboardingDocument, options);
      }
export type ResendOrganizationMemberOnboardingMutationHookResult = ReturnType<typeof useResendOrganizationMemberOnboardingMutation>;
export type ResendOrganizationMemberOnboardingMutationResult = Apollo.MutationResult<ResendOrganizationMemberOnboardingMutation>;
export type ResendOrganizationMemberOnboardingMutationOptions = Apollo.BaseMutationOptions<ResendOrganizationMemberOnboardingMutation, ResendOrganizationMemberOnboardingMutationVariables>;
export const UpdateOrganizationMemberDocument = gql`
    mutation updateOrganizationMember($input: OrganizationMemberUpdateDtoInput!) {
  updateOrganizationMember(input: $input) {
    userId
    email
    userName
    firstName
    lastName
    phoneNumber
    role
    emailConfirmed
    hasPassword
    isPendingOnboarding
    isActive
    isDeleted
    onboardingEmailStatus
    onboardingEmailQueuedAtUtc
    onboardingEmailLastSentAtUtc
    onboardingEmailLastFailedAtUtc
    onboardingEmailSentCount
    onboardingEmailFailureReason
  }
}
    `;
export type UpdateOrganizationMemberMutationFn = Apollo.MutationFunction<UpdateOrganizationMemberMutation, UpdateOrganizationMemberMutationVariables>;
export function useUpdateOrganizationMemberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationMemberMutation, UpdateOrganizationMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationMemberMutation, UpdateOrganizationMemberMutationVariables>(UpdateOrganizationMemberDocument, options);
      }
export type UpdateOrganizationMemberMutationHookResult = ReturnType<typeof useUpdateOrganizationMemberMutation>;
export type UpdateOrganizationMemberMutationResult = Apollo.MutationResult<UpdateOrganizationMemberMutation>;
export type UpdateOrganizationMemberMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationMemberMutation, UpdateOrganizationMemberMutationVariables>;
export const ChangeEventRegistrationPayerDocument = gql`
    mutation changeEventRegistrationPayer($input: EventRegistrationPayerChangeDtoInput!) {
  changeEventRegistrationPayer(input: $input) {
    id
    payerId
    payerType
    payerName
    payerEmail
    payerPhone
    payerAddress
    payerCity
    payerCountry
    payerTaxId
    payerContactPerson
  }
}
    `;
export type ChangeEventRegistrationPayerMutationFn = Apollo.MutationFunction<ChangeEventRegistrationPayerMutation, ChangeEventRegistrationPayerMutationVariables>;
export function useChangeEventRegistrationPayerMutation(baseOptions?: Apollo.MutationHookOptions<ChangeEventRegistrationPayerMutation, ChangeEventRegistrationPayerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeEventRegistrationPayerMutation, ChangeEventRegistrationPayerMutationVariables>(ChangeEventRegistrationPayerDocument, options);
      }
export type ChangeEventRegistrationPayerMutationHookResult = ReturnType<typeof useChangeEventRegistrationPayerMutation>;
export type ChangeEventRegistrationPayerMutationResult = Apollo.MutationResult<ChangeEventRegistrationPayerMutation>;
export type ChangeEventRegistrationPayerMutationOptions = Apollo.BaseMutationOptions<ChangeEventRegistrationPayerMutation, ChangeEventRegistrationPayerMutationVariables>;
export const DeleteEventParticipantDocument = gql`
    mutation DeleteEventParticipant($input: EventParticipantDeleteDtoInput!) {
  deleteEventParticipant(input: $input)
}
    `;
export type DeleteEventParticipantMutationFn = Apollo.MutationFunction<DeleteEventParticipantMutation, DeleteEventParticipantMutationVariables>;
export function useDeleteEventParticipantMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEventParticipantMutation, DeleteEventParticipantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEventParticipantMutation, DeleteEventParticipantMutationVariables>(DeleteEventParticipantDocument, options);
      }
export type DeleteEventParticipantMutationHookResult = ReturnType<typeof useDeleteEventParticipantMutation>;
export type DeleteEventParticipantMutationResult = Apollo.MutationResult<DeleteEventParticipantMutation>;
export type DeleteEventParticipantMutationOptions = Apollo.BaseMutationOptions<DeleteEventParticipantMutation, DeleteEventParticipantMutationVariables>;
export const EventParticipantActivityOptionsDocument = gql`
    query eventParticipantActivityOptions($eventId: Int!) {
  eventOptions(
    where: {eventId: {eq: $eventId}, isActive: {eq: true}}
    order: [{labelHr: ASC}, {labelEn: ASC}]
    take: 100
  ) {
    items {
      id
      eventId
      labelHr
      labelEn
      questionType
      price
      allowedFeeTypeIds
      visibilityDependsOnEventOptionId
      visibilityDependsOnExpectedAnswer
      choices {
        id
        value
        labelHr
        labelEn
        order
        isActive
      }
    }
  }
}
    `;
export function useEventParticipantActivityOptionsQuery(baseOptions: Apollo.QueryHookOptions<EventParticipantActivityOptionsQuery, EventParticipantActivityOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventParticipantActivityOptionsQuery, EventParticipantActivityOptionsQueryVariables>(EventParticipantActivityOptionsDocument, options);
      }
export function useEventParticipantActivityOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventParticipantActivityOptionsQuery, EventParticipantActivityOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventParticipantActivityOptionsQuery, EventParticipantActivityOptionsQueryVariables>(EventParticipantActivityOptionsDocument, options);
        }
export type EventParticipantActivityOptionsQueryHookResult = ReturnType<typeof useEventParticipantActivityOptionsQuery>;
export type EventParticipantActivityOptionsLazyQueryHookResult = ReturnType<typeof useEventParticipantActivityOptionsLazyQuery>;
export type EventParticipantActivityOptionsQueryResult = Apollo.QueryResult<EventParticipantActivityOptionsQuery, EventParticipantActivityOptionsQueryVariables>;
export const EventParticipantCockpitRegistrationsDocument = gql`
    query eventParticipantCockpitRegistrations($where: EventRegistrationReturnDtoFilterInput, $order: [EventRegistrationReturnDtoSortInput!], $skip: Int, $take: Int) {
  eventRegistrations(where: $where, order: $order, skip: $skip, take: $take) {
    items {
      id
      eventId
      participantId
      status
      rejectionReason
      hasAccommodationReservation
      accommodationReservationCount
      currentParticipationOfferNumber
      currentParticipationOfferStatus
      currentParticipationOfferPaymentStatus
      currentAccommodationOfferNumber
      currentAccommodationOfferStatus
      currentAccommodationOfferPaymentStatus
      activeRegistrationCodeCount
      revokedRegistrationCodeCount
      hasCertificates
      certificateCount
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;
export function useEventParticipantCockpitRegistrationsQuery(baseOptions?: Apollo.QueryHookOptions<EventParticipantCockpitRegistrationsQuery, EventParticipantCockpitRegistrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventParticipantCockpitRegistrationsQuery, EventParticipantCockpitRegistrationsQueryVariables>(EventParticipantCockpitRegistrationsDocument, options);
      }
export function useEventParticipantCockpitRegistrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventParticipantCockpitRegistrationsQuery, EventParticipantCockpitRegistrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventParticipantCockpitRegistrationsQuery, EventParticipantCockpitRegistrationsQueryVariables>(EventParticipantCockpitRegistrationsDocument, options);
        }
export type EventParticipantCockpitRegistrationsQueryHookResult = ReturnType<typeof useEventParticipantCockpitRegistrationsQuery>;
export type EventParticipantCockpitRegistrationsLazyQueryHookResult = ReturnType<typeof useEventParticipantCockpitRegistrationsLazyQuery>;
export type EventParticipantCockpitRegistrationsQueryResult = Apollo.QueryResult<EventParticipantCockpitRegistrationsQuery, EventParticipantCockpitRegistrationsQueryVariables>;
export const EventParticipantDetailFallbackDocument = gql`
    query eventParticipantDetailFallback($id: Int!) {
  eventParticipantById(id: $id) {
    id
    eventId
    firstName
    lastName
    email
    phoneNumber
    company
    linkedInUrl
    additionalInfo
  }
}
    `;
export function useEventParticipantDetailFallbackQuery(baseOptions: Apollo.QueryHookOptions<EventParticipantDetailFallbackQuery, EventParticipantDetailFallbackQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventParticipantDetailFallbackQuery, EventParticipantDetailFallbackQueryVariables>(EventParticipantDetailFallbackDocument, options);
      }
export function useEventParticipantDetailFallbackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventParticipantDetailFallbackQuery, EventParticipantDetailFallbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventParticipantDetailFallbackQuery, EventParticipantDetailFallbackQueryVariables>(EventParticipantDetailFallbackDocument, options);
        }
export type EventParticipantDetailFallbackQueryHookResult = ReturnType<typeof useEventParticipantDetailFallbackQuery>;
export type EventParticipantDetailFallbackLazyQueryHookResult = ReturnType<typeof useEventParticipantDetailFallbackLazyQuery>;
export type EventParticipantDetailFallbackQueryResult = Apollo.QueryResult<EventParticipantDetailFallbackQuery, EventParticipantDetailFallbackQueryVariables>;
export const EventParticipantHotelOptionsDocument = gql`
    query eventParticipantHotelOptions($eventId: Int!) {
  eventHotels(where: {eventId: {eq: $eventId}}, order: [{name: ASC}], take: 100) {
    items {
      id
      eventId
      name
      city
      country
    }
  }
}
    `;
export function useEventParticipantHotelOptionsQuery(baseOptions: Apollo.QueryHookOptions<EventParticipantHotelOptionsQuery, EventParticipantHotelOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventParticipantHotelOptionsQuery, EventParticipantHotelOptionsQueryVariables>(EventParticipantHotelOptionsDocument, options);
      }
export function useEventParticipantHotelOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventParticipantHotelOptionsQuery, EventParticipantHotelOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventParticipantHotelOptionsQuery, EventParticipantHotelOptionsQueryVariables>(EventParticipantHotelOptionsDocument, options);
        }
export type EventParticipantHotelOptionsQueryHookResult = ReturnType<typeof useEventParticipantHotelOptionsQuery>;
export type EventParticipantHotelOptionsLazyQueryHookResult = ReturnType<typeof useEventParticipantHotelOptionsLazyQuery>;
export type EventParticipantHotelOptionsQueryResult = Apollo.QueryResult<EventParticipantHotelOptionsQuery, EventParticipantHotelOptionsQueryVariables>;
export const EventParticipantOperationsDetailDocument = gql`
    query eventParticipantOperationsDetail($eventId: Int!, $participantId: Int!) {
  eventParticipantOperationsDetail: eventParticipantCrmDetail(
    eventId: $eventId
    participantId: $participantId
  ) {
    eventId
    eventCode
    eventName
    participantId
    firstName
    lastName
    fullName
    company
    phoneNumber
    email
    linkedInUrl
    additionalInfo
    registrations {
      id
      status
      rejectionReason
      isEmailVerified
      verificationEmailStatus
      verificationEmailQueuedAtUtc
      verificationEmailSentAtUtc
      verificationEmailFailedAtUtc
      verificationEmailFailureReason
      invitationEmailStatus
      invitationEmailQueuedAtUtc
      invitationEmailSentAtUtc
      invitationEmailFailedAtUtc
      invitationEmailFailureReason
      gdprConsentAccepted
      gdprConsentAcceptedAtUtc
      gdprConsentTextVersion
      gdprConsentEventId
      offerDueDate
      participationPaymentMethod
      accommodationPaymentMethod
      createdAt
      payerId
      payerType
      payerName
      payerEmail
      payerPhone
      payerAddress
      payerCity
      payerCountry
      payerTaxId
      payerContactPerson
      participantTypeProofFileId
      participantTypeProofFileName
      participantTypeProofFileContentType
      selectedEventOptionIds
      selectedParticipationFeeTypeId
      activityAnswers {
        eventOptionId
        questionType
        isSelected
        textValue
        selectedChoiceIds
        value
      }
      currentParticipationOfferId
      currentParticipationOfferNumber
      currentParticipationOfferStatus
      currentParticipationOfferPaymentStatus
      currentAccommodationOfferNumber
      currentAccommodationOfferStatus
      currentAccommodationOfferPaymentStatus
    }
    roomReservations {
      id
      registrationId
      hotelId
      hotelName
      roomTypeId
      roomTypeName
      arrivalDate
      departureDate
      nightCount
      roomCount
      status
      pricePerNightSnapshot
    }
    registrationCodes {
      id
      registrationId
      issuedAt
      revokedAt
      isActive
    }
    certificates {
      id
      eventId
      registrationId
      registrationStatus
      participantId
      participantFullName
      fileId
      fileName
      status
      requestedBy
      requestedAt
      generatedAt
      emailQueuedAtUtc
      emailedAt
      emailFailedAtUtc
      emailFailureReason
    }
  }
}
    `;
export function useEventParticipantOperationsDetailQuery(baseOptions: Apollo.QueryHookOptions<EventParticipantOperationsDetailQuery, EventParticipantOperationsDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventParticipantOperationsDetailQuery, EventParticipantOperationsDetailQueryVariables>(EventParticipantOperationsDetailDocument, options);
      }
export function useEventParticipantOperationsDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventParticipantOperationsDetailQuery, EventParticipantOperationsDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventParticipantOperationsDetailQuery, EventParticipantOperationsDetailQueryVariables>(EventParticipantOperationsDetailDocument, options);
        }
export type EventParticipantOperationsDetailQueryHookResult = ReturnType<typeof useEventParticipantOperationsDetailQuery>;
export type EventParticipantOperationsDetailLazyQueryHookResult = ReturnType<typeof useEventParticipantOperationsDetailLazyQuery>;
export type EventParticipantOperationsDetailQueryResult = Apollo.QueryResult<EventParticipantOperationsDetailQuery, EventParticipantOperationsDetailQueryVariables>;
export const EventParticipantRoomAllotmentOptionsDocument = gql`
    query eventParticipantRoomAllotmentOptions($hotelIds: [Int!]!, $roomTypeIds: [Int!]!) {
  eventRoomAllotments(
    where: {and: [{hotelId: {in: $hotelIds}}, {roomTypeId: {in: $roomTypeIds}}]}
    order: [{startDate: ASC}, {endDate: ASC}]
    take: 100
  ) {
    items {
      id
      hotelId
      roomTypeId
      startDate
      endDate
      totalRooms
    }
  }
}
    `;
export function useEventParticipantRoomAllotmentOptionsQuery(baseOptions: Apollo.QueryHookOptions<EventParticipantRoomAllotmentOptionsQuery, EventParticipantRoomAllotmentOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventParticipantRoomAllotmentOptionsQuery, EventParticipantRoomAllotmentOptionsQueryVariables>(EventParticipantRoomAllotmentOptionsDocument, options);
      }
export function useEventParticipantRoomAllotmentOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventParticipantRoomAllotmentOptionsQuery, EventParticipantRoomAllotmentOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventParticipantRoomAllotmentOptionsQuery, EventParticipantRoomAllotmentOptionsQueryVariables>(EventParticipantRoomAllotmentOptionsDocument, options);
        }
export type EventParticipantRoomAllotmentOptionsQueryHookResult = ReturnType<typeof useEventParticipantRoomAllotmentOptionsQuery>;
export type EventParticipantRoomAllotmentOptionsLazyQueryHookResult = ReturnType<typeof useEventParticipantRoomAllotmentOptionsLazyQuery>;
export type EventParticipantRoomAllotmentOptionsQueryResult = Apollo.QueryResult<EventParticipantRoomAllotmentOptionsQuery, EventParticipantRoomAllotmentOptionsQueryVariables>;
export const EventParticipantRoomTypeOptionsDocument = gql`
    query eventParticipantRoomTypeOptions($hotelIds: [Int!]!) {
  eventRoomTypes(
    where: {hotelId: {in: $hotelIds}}
    order: [{hotelId: ASC}, {name: ASC}]
    take: 100
  ) {
    items {
      id
      hotelId
      name
      capacity
      pricePerNight
      description
    }
  }
}
    `;
export function useEventParticipantRoomTypeOptionsQuery(baseOptions: Apollo.QueryHookOptions<EventParticipantRoomTypeOptionsQuery, EventParticipantRoomTypeOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventParticipantRoomTypeOptionsQuery, EventParticipantRoomTypeOptionsQueryVariables>(EventParticipantRoomTypeOptionsDocument, options);
      }
export function useEventParticipantRoomTypeOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventParticipantRoomTypeOptionsQuery, EventParticipantRoomTypeOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventParticipantRoomTypeOptionsQuery, EventParticipantRoomTypeOptionsQueryVariables>(EventParticipantRoomTypeOptionsDocument, options);
        }
export type EventParticipantRoomTypeOptionsQueryHookResult = ReturnType<typeof useEventParticipantRoomTypeOptionsQuery>;
export type EventParticipantRoomTypeOptionsLazyQueryHookResult = ReturnType<typeof useEventParticipantRoomTypeOptionsLazyQuery>;
export type EventParticipantRoomTypeOptionsQueryResult = Apollo.QueryResult<EventParticipantRoomTypeOptionsQuery, EventParticipantRoomTypeOptionsQueryVariables>;
export const EventParticipantsListDocument = gql`
    query EventParticipantsList($where: EventParticipantReturnDtoFilterInput, $order: [EventParticipantReturnDtoSortInput!], $skip: Int, $take: Int, $statusFilter: EventParticipantStatusFilterDtoInput) {
  eventParticipants(
    where: $where
    order: $order
    skip: $skip
    take: $take
    statusFilter: $statusFilter
  ) {
    items {
      id
      eventId
      firstName
      lastName
      email
      phoneNumber
      company
      linkedInUrl
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;
export function useEventParticipantsListQuery(baseOptions?: Apollo.QueryHookOptions<EventParticipantsListQuery, EventParticipantsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventParticipantsListQuery, EventParticipantsListQueryVariables>(EventParticipantsListDocument, options);
      }
export function useEventParticipantsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventParticipantsListQuery, EventParticipantsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventParticipantsListQuery, EventParticipantsListQueryVariables>(EventParticipantsListDocument, options);
        }
export type EventParticipantsListQueryHookResult = ReturnType<typeof useEventParticipantsListQuery>;
export type EventParticipantsListLazyQueryHookResult = ReturnType<typeof useEventParticipantsListLazyQuery>;
export type EventParticipantsListQueryResult = Apollo.QueryResult<EventParticipantsListQuery, EventParticipantsListQueryVariables>;
export const EventParticipantsTotalDocument = gql`
    query EventParticipantsTotal($where: EventParticipantReturnDtoFilterInput) {
  eventParticipants(where: $where, take: 1) {
    totalCount
  }
}
    `;
export function useEventParticipantsTotalQuery(baseOptions?: Apollo.QueryHookOptions<EventParticipantsTotalQuery, EventParticipantsTotalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventParticipantsTotalQuery, EventParticipantsTotalQueryVariables>(EventParticipantsTotalDocument, options);
      }
export function useEventParticipantsTotalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventParticipantsTotalQuery, EventParticipantsTotalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventParticipantsTotalQuery, EventParticipantsTotalQueryVariables>(EventParticipantsTotalDocument, options);
        }
export type EventParticipantsTotalQueryHookResult = ReturnType<typeof useEventParticipantsTotalQuery>;
export type EventParticipantsTotalLazyQueryHookResult = ReturnType<typeof useEventParticipantsTotalLazyQuery>;
export type EventParticipantsTotalQueryResult = Apollo.QueryResult<EventParticipantsTotalQuery, EventParticipantsTotalQueryVariables>;
export const GenerateEventCertificateDocument = gql`
    mutation generateEventCertificate($input: EventCertificateGenerateDtoInput!) {
  generateEventCertificate(input: $input) {
    id
    eventId
    registrationId
    participantId
    fileId
    fileName
    status
    participantFullName
    requestedBy
    requestedAt
    generatedAt
    emailedAt
  }
}
    `;
export type GenerateEventCertificateMutationFn = Apollo.MutationFunction<GenerateEventCertificateMutation, GenerateEventCertificateMutationVariables>;
export function useGenerateEventCertificateMutation(baseOptions?: Apollo.MutationHookOptions<GenerateEventCertificateMutation, GenerateEventCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateEventCertificateMutation, GenerateEventCertificateMutationVariables>(GenerateEventCertificateDocument, options);
      }
export type GenerateEventCertificateMutationHookResult = ReturnType<typeof useGenerateEventCertificateMutation>;
export type GenerateEventCertificateMutationResult = Apollo.MutationResult<GenerateEventCertificateMutation>;
export type GenerateEventCertificateMutationOptions = Apollo.BaseMutationOptions<GenerateEventCertificateMutation, GenerateEventCertificateMutationVariables>;
export const InviteEventRegistrationDocument = gql`
    mutation inviteEventRegistration($input: EventRegistrationDeleteDtoInput!) {
  inviteEventRegistration(input: $input) {
    id
    status
  }
}
    `;
export type InviteEventRegistrationMutationFn = Apollo.MutationFunction<InviteEventRegistrationMutation, InviteEventRegistrationMutationVariables>;
export function useInviteEventRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<InviteEventRegistrationMutation, InviteEventRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteEventRegistrationMutation, InviteEventRegistrationMutationVariables>(InviteEventRegistrationDocument, options);
      }
export type InviteEventRegistrationMutationHookResult = ReturnType<typeof useInviteEventRegistrationMutation>;
export type InviteEventRegistrationMutationResult = Apollo.MutationResult<InviteEventRegistrationMutation>;
export type InviteEventRegistrationMutationOptions = Apollo.BaseMutationOptions<InviteEventRegistrationMutation, InviteEventRegistrationMutationVariables>;
export const ParticipantPayerOptionsDocument = gql`
    query participantPayerOptions($search: String) {
  payers(
    where: {or: [{name: {contains: $search}}, {email: {contains: $search}}, {taxId: {contains: $search}}]}
    order: [{name: ASC}]
    take: 100
  ) {
    items {
      id
      type
      name
      email
      phone
      address
      city
      country
      taxId
      contactPerson
    }
  }
}
    `;
export function useParticipantPayerOptionsQuery(baseOptions?: Apollo.QueryHookOptions<ParticipantPayerOptionsQuery, ParticipantPayerOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ParticipantPayerOptionsQuery, ParticipantPayerOptionsQueryVariables>(ParticipantPayerOptionsDocument, options);
      }
export function useParticipantPayerOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParticipantPayerOptionsQuery, ParticipantPayerOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ParticipantPayerOptionsQuery, ParticipantPayerOptionsQueryVariables>(ParticipantPayerOptionsDocument, options);
        }
export type ParticipantPayerOptionsQueryHookResult = ReturnType<typeof useParticipantPayerOptionsQuery>;
export type ParticipantPayerOptionsLazyQueryHookResult = ReturnType<typeof useParticipantPayerOptionsLazyQuery>;
export type ParticipantPayerOptionsQueryResult = Apollo.QueryResult<ParticipantPayerOptionsQuery, ParticipantPayerOptionsQueryVariables>;
export const RejectEventRegistrationDocument = gql`
    mutation rejectEventRegistration($input: EventRegistrationRejectDtoInput!) {
  rejectEventRegistration(input: $input) {
    id
    status
    rejectionReason
  }
}
    `;
export type RejectEventRegistrationMutationFn = Apollo.MutationFunction<RejectEventRegistrationMutation, RejectEventRegistrationMutationVariables>;
export function useRejectEventRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<RejectEventRegistrationMutation, RejectEventRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectEventRegistrationMutation, RejectEventRegistrationMutationVariables>(RejectEventRegistrationDocument, options);
      }
export type RejectEventRegistrationMutationHookResult = ReturnType<typeof useRejectEventRegistrationMutation>;
export type RejectEventRegistrationMutationResult = Apollo.MutationResult<RejectEventRegistrationMutation>;
export type RejectEventRegistrationMutationOptions = Apollo.BaseMutationOptions<RejectEventRegistrationMutation, RejectEventRegistrationMutationVariables>;
export const ResendEventCertificateEmailDocument = gql`
    mutation resendEventCertificateEmail($input: EventCertificateEmailResendDtoInput!) {
  resendEventCertificateEmail(input: $input) {
    id
    status
    emailQueuedAtUtc
    emailedAt
    emailFailedAtUtc
    emailFailureReason
  }
}
    `;
export type ResendEventCertificateEmailMutationFn = Apollo.MutationFunction<ResendEventCertificateEmailMutation, ResendEventCertificateEmailMutationVariables>;
export function useResendEventCertificateEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResendEventCertificateEmailMutation, ResendEventCertificateEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendEventCertificateEmailMutation, ResendEventCertificateEmailMutationVariables>(ResendEventCertificateEmailDocument, options);
      }
export type ResendEventCertificateEmailMutationHookResult = ReturnType<typeof useResendEventCertificateEmailMutation>;
export type ResendEventCertificateEmailMutationResult = Apollo.MutationResult<ResendEventCertificateEmailMutation>;
export type ResendEventCertificateEmailMutationOptions = Apollo.BaseMutationOptions<ResendEventCertificateEmailMutation, ResendEventCertificateEmailMutationVariables>;
export const ResendEventRegistrationVerificationEmailDocument = gql`
    mutation resendEventRegistrationVerificationEmail($input: EventRegistrationDeleteDtoInput!) {
  resendEventRegistrationVerificationEmail(input: $input) {
    id
    verificationEmailStatus
    verificationEmailQueuedAtUtc
    verificationEmailSentAtUtc
    verificationEmailFailedAtUtc
    verificationEmailFailureReason
  }
}
    `;
export type ResendEventRegistrationVerificationEmailMutationFn = Apollo.MutationFunction<ResendEventRegistrationVerificationEmailMutation, ResendEventRegistrationVerificationEmailMutationVariables>;
export function useResendEventRegistrationVerificationEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResendEventRegistrationVerificationEmailMutation, ResendEventRegistrationVerificationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendEventRegistrationVerificationEmailMutation, ResendEventRegistrationVerificationEmailMutationVariables>(ResendEventRegistrationVerificationEmailDocument, options);
      }
export type ResendEventRegistrationVerificationEmailMutationHookResult = ReturnType<typeof useResendEventRegistrationVerificationEmailMutation>;
export type ResendEventRegistrationVerificationEmailMutationResult = Apollo.MutationResult<ResendEventRegistrationVerificationEmailMutation>;
export type ResendEventRegistrationVerificationEmailMutationOptions = Apollo.BaseMutationOptions<ResendEventRegistrationVerificationEmailMutation, ResendEventRegistrationVerificationEmailMutationVariables>;
export const SaveEventRoomReservationDocument = gql`
    mutation saveEventRoomReservation($input: EventRoomReservationSaveDtoInput!) {
  saveEventRoomReservation(input: $input) {
    id
    eventId
    registrationId
    participantId
    hotelId
    roomTypeId
    arrivalDate
    departureDate
    roomCount
    status
    pricePerNightSnapshot
    updatedAt
  }
}
    `;
export type SaveEventRoomReservationMutationFn = Apollo.MutationFunction<SaveEventRoomReservationMutation, SaveEventRoomReservationMutationVariables>;
export function useSaveEventRoomReservationMutation(baseOptions?: Apollo.MutationHookOptions<SaveEventRoomReservationMutation, SaveEventRoomReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveEventRoomReservationMutation, SaveEventRoomReservationMutationVariables>(SaveEventRoomReservationDocument, options);
      }
export type SaveEventRoomReservationMutationHookResult = ReturnType<typeof useSaveEventRoomReservationMutation>;
export type SaveEventRoomReservationMutationResult = Apollo.MutationResult<SaveEventRoomReservationMutation>;
export type SaveEventRoomReservationMutationOptions = Apollo.BaseMutationOptions<SaveEventRoomReservationMutation, SaveEventRoomReservationMutationVariables>;
export const UpdateEventRegistrationActivitiesDocument = gql`
    mutation updateEventRegistrationActivities($input: EventRegistrationOptionSelectionUpdateDtoInput!) {
  updateEventRegistrationActivities(input: $input) {
    id
    eventId
    participantId
  }
}
    `;
export type UpdateEventRegistrationActivitiesMutationFn = Apollo.MutationFunction<UpdateEventRegistrationActivitiesMutation, UpdateEventRegistrationActivitiesMutationVariables>;
export function useUpdateEventRegistrationActivitiesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventRegistrationActivitiesMutation, UpdateEventRegistrationActivitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventRegistrationActivitiesMutation, UpdateEventRegistrationActivitiesMutationVariables>(UpdateEventRegistrationActivitiesDocument, options);
      }
export type UpdateEventRegistrationActivitiesMutationHookResult = ReturnType<typeof useUpdateEventRegistrationActivitiesMutation>;
export type UpdateEventRegistrationActivitiesMutationResult = Apollo.MutationResult<UpdateEventRegistrationActivitiesMutation>;
export type UpdateEventRegistrationActivitiesMutationOptions = Apollo.BaseMutationOptions<UpdateEventRegistrationActivitiesMutation, UpdateEventRegistrationActivitiesMutationVariables>;
export const UpdateEventParticipantDocument = gql`
    mutation UpdateEventParticipant($input: EventParticipantUpdateDtoInput!) {
  updateEventParticipant(input: $input) {
    id
    eventId
    firstName
    lastName
    company
    phoneNumber
    email
    linkedInUrl
    additionalInfo
  }
}
    `;
export type UpdateEventParticipantMutationFn = Apollo.MutationFunction<UpdateEventParticipantMutation, UpdateEventParticipantMutationVariables>;
export function useUpdateEventParticipantMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventParticipantMutation, UpdateEventParticipantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventParticipantMutation, UpdateEventParticipantMutationVariables>(UpdateEventParticipantDocument, options);
      }
export type UpdateEventParticipantMutationHookResult = ReturnType<typeof useUpdateEventParticipantMutation>;
export type UpdateEventParticipantMutationResult = Apollo.MutationResult<UpdateEventParticipantMutation>;
export type UpdateEventParticipantMutationOptions = Apollo.BaseMutationOptions<UpdateEventParticipantMutation, UpdateEventParticipantMutationVariables>;
export const CreatePayerDocument = gql`
    mutation createPayer($input: PayerCreateDtoInput!) {
  createPayer(input: $input) {
    id
    type
    name
    email
    phone
    address
    city
    country
    taxId
    contactPerson
  }
}
    `;
export type CreatePayerMutationFn = Apollo.MutationFunction<CreatePayerMutation, CreatePayerMutationVariables>;
export function useCreatePayerMutation(baseOptions?: Apollo.MutationHookOptions<CreatePayerMutation, CreatePayerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePayerMutation, CreatePayerMutationVariables>(CreatePayerDocument, options);
      }
export type CreatePayerMutationHookResult = ReturnType<typeof useCreatePayerMutation>;
export type CreatePayerMutationResult = Apollo.MutationResult<CreatePayerMutation>;
export type CreatePayerMutationOptions = Apollo.BaseMutationOptions<CreatePayerMutation, CreatePayerMutationVariables>;
export const DeletePayerDocument = gql`
    mutation deletePayer($input: PayerDeleteDtoInput!) {
  deletePayer(input: $input)
}
    `;
export type DeletePayerMutationFn = Apollo.MutationFunction<DeletePayerMutation, DeletePayerMutationVariables>;
export function useDeletePayerMutation(baseOptions?: Apollo.MutationHookOptions<DeletePayerMutation, DeletePayerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePayerMutation, DeletePayerMutationVariables>(DeletePayerDocument, options);
      }
export type DeletePayerMutationHookResult = ReturnType<typeof useDeletePayerMutation>;
export type DeletePayerMutationResult = Apollo.MutationResult<DeletePayerMutation>;
export type DeletePayerMutationOptions = Apollo.BaseMutationOptions<DeletePayerMutation, DeletePayerMutationVariables>;
export const ManualReconcilePayerPaymentDocument = gql`
    mutation manualReconcilePayerPayment($input: PaymentManualReconcileDtoInput!) {
  manualReconcilePayment(input: $input) {
    id
    status
    manuallyReconciledAt
  }
}
    `;
export type ManualReconcilePayerPaymentMutationFn = Apollo.MutationFunction<ManualReconcilePayerPaymentMutation, ManualReconcilePayerPaymentMutationVariables>;
export function useManualReconcilePayerPaymentMutation(baseOptions?: Apollo.MutationHookOptions<ManualReconcilePayerPaymentMutation, ManualReconcilePayerPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManualReconcilePayerPaymentMutation, ManualReconcilePayerPaymentMutationVariables>(ManualReconcilePayerPaymentDocument, options);
      }
export type ManualReconcilePayerPaymentMutationHookResult = ReturnType<typeof useManualReconcilePayerPaymentMutation>;
export type ManualReconcilePayerPaymentMutationResult = Apollo.MutationResult<ManualReconcilePayerPaymentMutation>;
export type ManualReconcilePayerPaymentMutationOptions = Apollo.BaseMutationOptions<ManualReconcilePayerPaymentMutation, ManualReconcilePayerPaymentMutationVariables>;
export const PayerOfferHistoryDocument = gql`
    query payerOfferHistory($payerId: Int!) {
  payerOfferHistory(payerId: $payerId, take: 100) {
    items {
      id
      eventId
      eventCode
      eventName
      registrationId
      participantId
      participantFullName
      fileId
      fileName
      customerPurchaseOrderFileId
      customerPurchaseOrderFileName
      customerPurchaseOrderFileContentType
      type
      status
      offerNumber
      grossTotal
      currency
      dueDate
      paymentMethod
      generatedAt
      emailQueuedAtUtc
      emailedAt
      emailFailedAtUtc
      emailFailureReason
    }
  }
}
    `;
export function usePayerOfferHistoryQuery(baseOptions: Apollo.QueryHookOptions<PayerOfferHistoryQuery, PayerOfferHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayerOfferHistoryQuery, PayerOfferHistoryQueryVariables>(PayerOfferHistoryDocument, options);
      }
export function usePayerOfferHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayerOfferHistoryQuery, PayerOfferHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayerOfferHistoryQuery, PayerOfferHistoryQueryVariables>(PayerOfferHistoryDocument, options);
        }
export type PayerOfferHistoryQueryHookResult = ReturnType<typeof usePayerOfferHistoryQuery>;
export type PayerOfferHistoryLazyQueryHookResult = ReturnType<typeof usePayerOfferHistoryLazyQuery>;
export type PayerOfferHistoryQueryResult = Apollo.QueryResult<PayerOfferHistoryQuery, PayerOfferHistoryQueryVariables>;
export const PayerPaymentAllocationsDocument = gql`
    query payerPaymentAllocations($payerId: Int!) {
  payerPaymentAllocations(payerId: $payerId, take: 100) {
    items {
      id
      paymentId
      eventId
      eventCode
      eventName
      registrationId
      participantId
      participantFullName
      offerId
      offerNumber
      allocatedAmount
      description
      paymentMethod
      paymentStatus
      paymentAmountGross
      paymentAmountNet
      paymentRefundedAmountGross
      currency
      isSponsorPayment
      paidAt
      reference
      provider
      providerReference
      payerName
      payerEmail
      manuallyReconciledAt
    }
  }
}
    `;
export function usePayerPaymentAllocationsQuery(baseOptions: Apollo.QueryHookOptions<PayerPaymentAllocationsQuery, PayerPaymentAllocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayerPaymentAllocationsQuery, PayerPaymentAllocationsQueryVariables>(PayerPaymentAllocationsDocument, options);
      }
export function usePayerPaymentAllocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayerPaymentAllocationsQuery, PayerPaymentAllocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayerPaymentAllocationsQuery, PayerPaymentAllocationsQueryVariables>(PayerPaymentAllocationsDocument, options);
        }
export type PayerPaymentAllocationsQueryHookResult = ReturnType<typeof usePayerPaymentAllocationsQuery>;
export type PayerPaymentAllocationsLazyQueryHookResult = ReturnType<typeof usePayerPaymentAllocationsLazyQuery>;
export type PayerPaymentAllocationsQueryResult = Apollo.QueryResult<PayerPaymentAllocationsQuery, PayerPaymentAllocationsQueryVariables>;
export const PayersPageDocument = gql`
    query payersPage($search: String) {
  payers(
    where: {or: [{name: {contains: $search}}, {email: {contains: $search}}, {taxId: {contains: $search}}]}
    order: [{name: ASC}]
    take: 100
  ) {
    items {
      id
      type
      name
      email
      phone
      address
      city
      country
      taxId
      contactPerson
    }
  }
}
    `;
export function usePayersPageQuery(baseOptions?: Apollo.QueryHookOptions<PayersPageQuery, PayersPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayersPageQuery, PayersPageQueryVariables>(PayersPageDocument, options);
      }
export function usePayersPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayersPageQuery, PayersPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayersPageQuery, PayersPageQueryVariables>(PayersPageDocument, options);
        }
export type PayersPageQueryHookResult = ReturnType<typeof usePayersPageQuery>;
export type PayersPageLazyQueryHookResult = ReturnType<typeof usePayersPageLazyQuery>;
export type PayersPageQueryResult = Apollo.QueryResult<PayersPageQuery, PayersPageQueryVariables>;
export const RenewPayerEventParticipationOfferDocument = gql`
    mutation renewPayerEventParticipationOffer($input: EventOfferRenewDtoInput!) {
  renewEventParticipationOffer(input: $input) {
    previousOfferId
    replacementOfferId
    type
    previousStatus
    replacementStatus
    previousOfferNumber
    replacementOfferNumber
  }
}
    `;
export type RenewPayerEventParticipationOfferMutationFn = Apollo.MutationFunction<RenewPayerEventParticipationOfferMutation, RenewPayerEventParticipationOfferMutationVariables>;
export function useRenewPayerEventParticipationOfferMutation(baseOptions?: Apollo.MutationHookOptions<RenewPayerEventParticipationOfferMutation, RenewPayerEventParticipationOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenewPayerEventParticipationOfferMutation, RenewPayerEventParticipationOfferMutationVariables>(RenewPayerEventParticipationOfferDocument, options);
      }
export type RenewPayerEventParticipationOfferMutationHookResult = ReturnType<typeof useRenewPayerEventParticipationOfferMutation>;
export type RenewPayerEventParticipationOfferMutationResult = Apollo.MutationResult<RenewPayerEventParticipationOfferMutation>;
export type RenewPayerEventParticipationOfferMutationOptions = Apollo.BaseMutationOptions<RenewPayerEventParticipationOfferMutation, RenewPayerEventParticipationOfferMutationVariables>;
export const UpdatePayerDocument = gql`
    mutation updatePayer($input: PayerUpdateDtoInput!) {
  updatePayer(input: $input) {
    id
    type
    name
    email
    phone
    address
    city
    country
    taxId
    contactPerson
  }
}
    `;
export type UpdatePayerMutationFn = Apollo.MutationFunction<UpdatePayerMutation, UpdatePayerMutationVariables>;
export function useUpdatePayerMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePayerMutation, UpdatePayerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePayerMutation, UpdatePayerMutationVariables>(UpdatePayerDocument, options);
      }
export type UpdatePayerMutationHookResult = ReturnType<typeof useUpdatePayerMutation>;
export type UpdatePayerMutationResult = Apollo.MutationResult<UpdatePayerMutation>;
export type UpdatePayerMutationOptions = Apollo.BaseMutationOptions<UpdatePayerMutation, UpdatePayerMutationVariables>;
export const EventOfferBalancesDocument = gql`
    query eventOfferBalances($eventId: Int!, $skip: Int, $take: Int, $where: EventOfferBalanceDtoFilterInput, $order: [EventOfferBalanceDtoSortInput!]) {
  eventOfferBalances(
    eventId: $eventId
    skip: $skip
    take: $take
    where: $where
    order: $order
  ) {
    totalCount
    items {
      id
      offerNumber
      type
      status
      participantId
      participantFullName
      payerId
      payerName
      grossTotal
      paidAmount
      outstandingAmount
      currency
      dueDate
      generatedAt
    }
  }
}
    `;
export function useEventOfferBalancesQuery(baseOptions: Apollo.QueryHookOptions<EventOfferBalancesQuery, EventOfferBalancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventOfferBalancesQuery, EventOfferBalancesQueryVariables>(EventOfferBalancesDocument, options);
      }
export function useEventOfferBalancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventOfferBalancesQuery, EventOfferBalancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventOfferBalancesQuery, EventOfferBalancesQueryVariables>(EventOfferBalancesDocument, options);
        }
export type EventOfferBalancesQueryHookResult = ReturnType<typeof useEventOfferBalancesQuery>;
export type EventOfferBalancesLazyQueryHookResult = ReturnType<typeof useEventOfferBalancesLazyQuery>;
export type EventOfferBalancesQueryResult = Apollo.QueryResult<EventOfferBalancesQuery, EventOfferBalancesQueryVariables>;
export const RecordOfferPaymentDocument = gql`
    mutation recordOfferPayment($input: RecordOfferPaymentDtoInput!) {
  recordOfferPayment(input: $input) {
    id
    status
    amountGross
    currency
    paidAt
    manuallyReconciledAt
  }
}
    `;
export type RecordOfferPaymentMutationFn = Apollo.MutationFunction<RecordOfferPaymentMutation, RecordOfferPaymentMutationVariables>;
export function useRecordOfferPaymentMutation(baseOptions?: Apollo.MutationHookOptions<RecordOfferPaymentMutation, RecordOfferPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordOfferPaymentMutation, RecordOfferPaymentMutationVariables>(RecordOfferPaymentDocument, options);
      }
export type RecordOfferPaymentMutationHookResult = ReturnType<typeof useRecordOfferPaymentMutation>;
export type RecordOfferPaymentMutationResult = Apollo.MutationResult<RecordOfferPaymentMutation>;
export type RecordOfferPaymentMutationOptions = Apollo.BaseMutationOptions<RecordOfferPaymentMutation, RecordOfferPaymentMutationVariables>;
export const EventRoomingListDocument = gql`
    query eventRoomingList($eventId: Int!, $take: Int, $skip: Int) {
  eventById(id: $eventId) {
    id
    code
    name
  }
  eventRegistrations(
    where: {eventId: {eq: $eventId}, hasAccommodationReservation: {eq: true}}
    order: [{participantLastName: ASC}, {participantFirstName: ASC}, {id: ASC}]
    take: $take
    skip: $skip
  ) {
    items {
      id
      participantFullName
      hasAccommodationReservation
      accommodationReservationId
      accommodationReservationStatus
      accommodationHotelName
      accommodationRoomTypeName
      accommodationArrivalDate
      accommodationDepartureDate
      currentAccommodationOfferPaymentStatus
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;
export function useEventRoomingListQuery(baseOptions: Apollo.QueryHookOptions<EventRoomingListQuery, EventRoomingListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventRoomingListQuery, EventRoomingListQueryVariables>(EventRoomingListDocument, options);
      }
export function useEventRoomingListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventRoomingListQuery, EventRoomingListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventRoomingListQuery, EventRoomingListQueryVariables>(EventRoomingListDocument, options);
        }
export type EventRoomingListQueryHookResult = ReturnType<typeof useEventRoomingListQuery>;
export type EventRoomingListLazyQueryHookResult = ReturnType<typeof useEventRoomingListLazyQuery>;
export type EventRoomingListQueryResult = Apollo.QueryResult<EventRoomingListQuery, EventRoomingListQueryVariables>;
export const ReleaseEventRoomReservationDocument = gql`
    mutation releaseEventRoomReservation($id: Int!) {
  releaseEventRoomReservation(input: {id: $id}) {
    id
    eventId
    registrationId
    participantId
    status
    updatedAt
  }
}
    `;
export type ReleaseEventRoomReservationMutationFn = Apollo.MutationFunction<ReleaseEventRoomReservationMutation, ReleaseEventRoomReservationMutationVariables>;
export function useReleaseEventRoomReservationMutation(baseOptions?: Apollo.MutationHookOptions<ReleaseEventRoomReservationMutation, ReleaseEventRoomReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReleaseEventRoomReservationMutation, ReleaseEventRoomReservationMutationVariables>(ReleaseEventRoomReservationDocument, options);
      }
export type ReleaseEventRoomReservationMutationHookResult = ReturnType<typeof useReleaseEventRoomReservationMutation>;
export type ReleaseEventRoomReservationMutationResult = Apollo.MutationResult<ReleaseEventRoomReservationMutation>;
export type ReleaseEventRoomReservationMutationOptions = Apollo.BaseMutationOptions<ReleaseEventRoomReservationMutation, ReleaseEventRoomReservationMutationVariables>;
export const GeneralSettingsDocument = gql`
    query generalSettings {
  generalSettings {
    id
    isPersisted
    createdAt
    updatedAt
    payeeName
    payeeAddress
    payeeIban
    payeeOib
    registrationVatRate
    accommodationVatRate
    accommodationTaxScheme
  }
}
    `;
export function useGeneralSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GeneralSettingsQuery, GeneralSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GeneralSettingsQuery, GeneralSettingsQueryVariables>(GeneralSettingsDocument, options);
      }
export function useGeneralSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GeneralSettingsQuery, GeneralSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GeneralSettingsQuery, GeneralSettingsQueryVariables>(GeneralSettingsDocument, options);
        }
export type GeneralSettingsQueryHookResult = ReturnType<typeof useGeneralSettingsQuery>;
export type GeneralSettingsLazyQueryHookResult = ReturnType<typeof useGeneralSettingsLazyQuery>;
export type GeneralSettingsQueryResult = Apollo.QueryResult<GeneralSettingsQuery, GeneralSettingsQueryVariables>;
export const UpsertGeneralSettingsDocument = gql`
    mutation upsertGeneralSettings($input: GeneralSettingsUpsertDtoInput!) {
  upsertGeneralSettings(input: $input) {
    id
    isPersisted
    createdAt
    updatedAt
    payeeName
    payeeAddress
    payeeIban
    payeeOib
    registrationVatRate
    accommodationVatRate
    accommodationTaxScheme
  }
}
    `;
export type UpsertGeneralSettingsMutationFn = Apollo.MutationFunction<UpsertGeneralSettingsMutation, UpsertGeneralSettingsMutationVariables>;
export function useUpsertGeneralSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertGeneralSettingsMutation, UpsertGeneralSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertGeneralSettingsMutation, UpsertGeneralSettingsMutationVariables>(UpsertGeneralSettingsDocument, options);
      }
export type UpsertGeneralSettingsMutationHookResult = ReturnType<typeof useUpsertGeneralSettingsMutation>;
export type UpsertGeneralSettingsMutationResult = Apollo.MutationResult<UpsertGeneralSettingsMutation>;
export type UpsertGeneralSettingsMutationOptions = Apollo.BaseMutationOptions<UpsertGeneralSettingsMutation, UpsertGeneralSettingsMutationVariables>;